import React from 'react'
import { Theme } from '@mui/material'
import omit from 'lodash/omit'

import { COLORS, COLORS2 } from '~/common/globalStyles'

import IconBase, { IconBaseProps } from './IconBase'
import { SvgIcon } from '@mui/material'

const Icons = {
  accountingBill: ({ color = 'currentColor', ...rest }: IconBaseProps) => (
    <IconBase {...rest} viewBox="0 0 25 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.50391 7.5C2.50391 7.22386 2.72776 7 3.00391 7H21.0039C21.28 7 21.5039 7.22386 21.5039 7.5V16.5C21.5039 16.7761 21.28 17 21.0039 17H3.00391C2.72776 17 2.50391 16.7761 2.50391 16.5V7.5Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.503906 6C0.503906 5.44772 0.951622 5 1.50391 5H22.5039C23.0562 5 23.5039 5.44772 23.5039 6V18C23.5039 18.5523 23.0562 19 22.5039 19H1.50391C0.951621 19 0.503906 18.5523 0.503906 18V6Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0039 15C13.6608 15 15.0039 13.6569 15.0039 12C15.0039 10.3431 13.6608 9 12.0039 9C10.3471 9 9.00391 10.3431 9.00391 12C9.00391 13.6569 10.3471 15 12.0039 15Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 9.25C5.13807 9.25 5.25 9.36193 5.25 9.5C5.25 9.63807 5.13807 9.75 5 9.75C4.86193 9.75 4.75 9.63807 4.75 9.5C4.75 9.36193 4.86193 9.25 5 9.25"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 14.25C19.1381 14.25 19.25 14.3619 19.25 14.5C19.25 14.6381 19.1381 14.75 19 14.75C18.8619 14.75 18.75 14.6381 18.75 14.5C18.75 14.3619 18.8619 14.25 19 14.25"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  accountingDocument: ({ color = 'currentColor', ...rest }: IconBaseProps) => (
    <IconBase {...rest} viewBox="0 0 25 24" fill="none">
      <path
        d="M8.50391 5.5V4.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0001 5.5H7.97108C7.32846 5.50045 6.77634 5.95639 6.6544 6.58734C6.53245 7.21828 6.8749 7.84712 7.47108 8.087L9.53508 8.913C10.1313 9.15288 10.4737 9.78172 10.3518 10.4127C10.2298 11.0436 9.6777 11.4996 9.03508 11.5H7.00008"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.50391 12.5V11.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5 22.5C20.5 23.0523 20.0523 23.5 19.5 23.5H4.5C3.94772 23.5 3.5 23.0523 3.5 22.5V1.5C3.5 0.947719 3.94772 0.500004 4.5 0.500004H14.09C14.3562 0.499263 14.6118 0.604718 14.8 0.793004L20.214 6.207C20.4016 6.3945 20.5069 6.64881 20.507 6.914L20.5 22.5Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 0.589966V5.49997C14.5 6.05225 14.9477 6.49997 15.5 6.49997H20.41"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.58691 16.5H17.5039"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.52 13.5H17.504"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5039 10.5H17.5039"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.58691 19.5H17.5039"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  activity: (props: IconBaseProps) => (
    <IconBase {...props}>
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline
          stroke={props.color || 'currentColor'}
          strokeWidth="1.5"
          fillRule="nonzero"
          points="4.5 10.0727153 6.07624321 10.0727153 7.98468757 5.15283203 12.1379701 13.9547254 14.0259707 10.0727153 15.5 10.0727153"
        />
      </g>
    </IconBase>
  ),
  notification: (props: IconBaseProps) => (
    <IconBase {...props}>
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline
          stroke={props.color || 'currentColor'}
          strokeWidth="1.5"
          fillRule="nonzero"
          points="4.5 10.0727153 6.07624321 10.0727153 7.98468757 5.15283203 12.1379701 13.9547254 14.0259707 10.0727153 15.5 10.0727153"
        />
      </g>
    </IconBase>
  ),
  'add-user': (props: IconBaseProps) => (
    <IconBase {...props}>
      <svg
        width="26"
        height="26"
        viewBox="0 0 34 34"
        fill={props.color || 'none'}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.7397 25.0011C22.1977 25.0011 25.0011 22.1977 25.0011 18.7397C25.0011 15.2816 22.1977 12.4783 18.7397 12.4783C15.2816 12.4783 12.4783 15.2816 12.4783 18.7397C12.4783 22.1977 15.2816 25.0011 18.7397 25.0011Z"
          stroke={props.stroke || COLORS2.gray[350]}
          strokeWidth={props.strokeWidth || '1.5'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.7391 15.6089V21.8703"
          stroke={props.stroke || COLORS2.gray[350]}
          strokeWidth={props.strokeWidth || '1.5'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.8696 18.7395H15.6087"
          stroke={props.stroke || COLORS2.gray[350]}
          strokeWidth={props.strokeWidth || '1.5'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.30435 9.8703C10.7536 9.8703 12.7391 7.88462 12.7391 5.43515C12.7391 2.98568 10.7536 1 8.30435 1C5.85509 1 3.86957 2.98568 3.86957 5.43515C3.86957 7.88462 5.85509 9.8703 8.30435 9.8703Z"
          stroke={props.stroke || COLORS2.gray[350]}
          strokeWidth={props.strokeWidth || '1.5'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.34783 18.7393H1C0.999897 16.0676 2.45826 13.6089 4.80281 12.3281C7.14737 11.0474 10.004 11.1488 12.2518 12.5927"
          stroke={props.stroke || COLORS2.gray[350]}
          strokeWidth={props.strokeWidth || '1.5'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  ),
  'arrow-up': (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M18.9263 14.9632L11.9631 8L4.99992 14.9632"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <polygon
          fill={props.color || 'currentColor'}
          points="5.41 13.41 10 8.83 14.59 13.41 16 12 10 6 4 12"
        />
      </IconBase>
    )
  },
  'arrow-down': (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M18.9263 10L11.9631 16.9632L4.99992 10"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <polygon
          fill={props.color || 'currentColor'}
          points="5.41 13.41 10 8.83 14.59 13.41 16 12 10 6 4 12"
          transform="matrix(1 0 0 -1 0 19.41)"
        />
      </IconBase>
    )
  },
  'arrow-left': (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.9634 5L8.00021 11.9632L14.9634 18.9263"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <polygon
          fill={props.color || 'currentColor'}
          points="5.41 13.41 10 8.83 14.59 13.41 16 12 10 6 4 12"
          transform="rotate(-90 10 9.705)"
        />
      </IconBase>
    )
  },
  'arrow-right': (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 5L16.9632 11.9632L10 18.9263"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <polygon
          fill={props.color || 'currentColor'}
          points="5.41 13.41 10 8.83 14.59 13.41 16 12 10 6 4 12"
          transform="rotate(90 10 9.705)"
        />
      </IconBase>
    )
  },
  'arrow-pointing-left': (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.4386 5.69237C10.821 5.29388 10.8079 4.66085 10.4094 4.27846C10.011 3.89607 9.37792 3.90913 8.99553 4.30763L10.4386 5.69237ZM3 12L2.27846 11.3076C1.90718 11.6945 1.90718 12.3055 2.27846 12.6924L3 12ZM8.99553 19.6924C9.37792 20.0909 10.011 20.1039 10.4094 19.7215C10.8079 19.3392 10.821 18.7061 10.4386 18.3076L8.99553 19.6924ZM4.26688 11.0317C3.71459 11.0317 3.26688 11.4795 3.26688 12.0317C3.26688 12.584 3.71459 13.0317 4.26688 13.0317V11.0317ZM19.9999 13.0317C20.5522 13.0317 20.9999 12.584 20.9999 12.0317C20.9999 11.4795 20.5522 11.0317 19.9999 11.0317V13.0317ZM8.99553 4.30763L2.27846 11.3076L3.72154 12.6924L10.4386 5.69237L8.99553 4.30763ZM2.27846 12.6924L8.99553 19.6924L10.4386 18.3076L3.72154 11.3076L2.27846 12.6924ZM4.26688 13.0317H19.9999V11.0317H4.26688V13.0317Z"
              fill={props.color || 'currentColor'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill={props.color || 'currentColor'}
            d="M3.20711 5.5L4.85355 7.14645C5.04882 7.34171 5.04882 7.65829 4.85355 7.85355C4.65829 8.04882 4.34171 8.04882 4.14645 7.85355L1.64645 5.35355C1.45118 5.15829 1.45118 4.84171 1.64645 4.64645L4.14645 2.14645C4.34171 1.95118 4.65829 1.95118 4.85355 2.14645C5.04882 2.34171 5.04882 2.65829 4.85355 2.85355L3.20711 4.5H8C8.27614 4.5 8.5 4.72386 8.5 5C8.5 5.27614 8.27614 5.5 8 5.5H3.20711Z"
          />
          <mask
            id="mask0"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="1"
            y="2"
            width="8"
            height="6"
          >
            <path
              d="M3.20711 5.5L4.85355 7.14645C5.04882 7.34171 5.04882 7.65829 4.85355 7.85355C4.65829 8.04882 4.34171 8.04882 4.14645 7.85355L1.64645 5.35355C1.45118 5.15829 1.45118 4.84171 1.64645 4.64645L4.14645 2.14645C4.34171 1.95118 4.65829 1.95118 4.85355 2.14645C5.04882 2.34171 5.04882 2.65829 4.85355 2.85355L3.20711 4.5H8C8.27614 4.5 8.5 4.72386 8.5 5C8.5 5.27614 8.27614 5.5 8 5.5H3.20711Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0)" />
        </svg>
      </IconBase>
    )
  },
  'arrow-pointing-right': (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.0044 4.30763C14.622 3.90913 13.989 3.89607 13.5905 4.27846C13.192 4.66085 13.1789 5.29388 13.5613 5.69237L15.0044 4.30763ZM20.9999 12L21.7215 12.6924C22.0928 12.3055 22.0928 11.6945 21.7215 11.3076L20.9999 12ZM13.5613 18.3076C13.1789 18.7061 13.192 19.3391 13.5905 19.7215C13.989 20.1039 14.622 20.0909 15.0044 19.6924L13.5613 18.3076ZM19.7331 13.0317C20.2853 13.0317 20.7331 12.584 20.7331 12.0317C20.7331 11.4795 20.2853 11.0317 19.7331 11.0317V13.0317ZM4 11.0317C3.44772 11.0317 3 11.4795 3 12.0317C3 12.584 3.44772 13.0317 4 13.0317V11.0317ZM13.5613 5.69237L20.2784 12.6924L21.7215 11.3076L15.0044 4.30763L13.5613 5.69237ZM20.2784 11.3076L13.5613 18.3076L15.0044 19.6924L21.7215 12.6924L20.2784 11.3076ZM19.7331 11.0317H4V13.0317H19.7331V11.0317Z"
              fill={props.color || 'currentColor'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill={props.color || 'currentColor'}
            d="M6.79289 4.5L5.14645 2.85355C4.95118 2.65829 4.95118 2.34171 5.14645 2.14645C5.34171 1.95118 5.65829 1.95118 5.85355 2.14645L8.35355 4.64645C8.54882 4.84171 8.54882 5.15829 8.35355 5.35355L5.85355 7.85355C5.65829 8.04882 5.34171 8.04882 5.14645 7.85355C4.95118 7.65829 4.95118 7.34171 5.14645 7.14645L6.79289 5.5H2C1.72386 5.5 1.5 5.27614 1.5 5C1.5 4.72386 1.72386 4.5 2 4.5H6.79289Z"
          />
          <mask
            id="mask0"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="1"
            y="2"
            width="8"
            height="6"
          >
            <path
              d="M6.79289 4.5L5.14645 2.85355C4.95118 2.65829 4.95118 2.34171 5.14645 2.14645C5.34171 1.95118 5.65829 1.95118 5.85355 2.14645L8.35355 4.64645C8.54882 4.84171 8.54882 5.15829 8.35355 5.35355L5.85355 7.85355C5.65829 8.04882 5.34171 8.04882 5.14645 7.85355C4.95118 7.65829 4.95118 7.34171 5.14645 7.14645L6.79289 5.5H2C1.72386 5.5 1.5 5.27614 1.5 5C1.5 4.72386 1.72386 4.5 2 4.5H6.79289Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0)" />
        </svg>
      </IconBase>
    )
  },
  'arrow-to-cloud': (props: IconBaseProps) => (
    <IconBase {...props}>
      <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M28.0656 54.7468V33.3837"
          stroke={props.color || 'currentColor'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.1644 42.285L28.0658 33.3837L36.9671 42.285"
          stroke={props.color || 'currentColor'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40.5277 36.9442H43.1981C48.1804 36.9526 52.6088 33.7711 54.1907 29.0466C55.7726 24.3221 54.1529 19.1154 50.17 16.1221C46.1872 13.1287 40.7355 13.0207 36.6372 15.854C34.9851 7.05793 27.0596 0.855792 18.1243 1.36667C9.18904 1.87755 2.02206 8.94262 1.38328 17.8697C0.744493 26.7967 6.8325 34.8102 15.604 36.5881"
          stroke={props.color || 'currentColor'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  ),
  backArrow: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.4386 5.69237C10.821 5.29388 10.8079 4.66085 10.4094 4.27846C10.011 3.89607 9.37792 3.90913 8.99553 4.30763L10.4386 5.69237ZM3 12L2.27846 11.3076C1.90718 11.6945 1.90718 12.3055 2.27846 12.6924L3 12ZM8.99553 19.6924C9.37792 20.0909 10.011 20.1039 10.4094 19.7215C10.8079 19.3392 10.821 18.7061 10.4386 18.3076L8.99553 19.6924ZM4.26688 11.0317C3.71459 11.0317 3.26688 11.4795 3.26688 12.0317C3.26688 12.584 3.71459 13.0317 4.26688 13.0317V11.0317ZM19.9999 13.0317C20.5522 13.0317 20.9999 12.584 20.9999 12.0317C20.9999 11.4795 20.5522 11.0317 19.9999 11.0317V13.0317ZM8.99553 4.30763L2.27846 11.3076L3.72154 12.6924L10.4386 5.69237L8.99553 4.30763ZM2.27846 12.6924L8.99553 19.6924L10.4386 18.3076L3.72154 11.3076L2.27846 12.6924ZM4.26688 13.0317H19.9999V11.0317H4.26688V13.0317Z"
              fill={props.color || '#121212'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase
        {...omit(props, ['viewBox', 'fill'])}
        fill="none"
        viewBox="0 0 26 14"
      >
        <path
          d="M1.86667 6.93335H24.4"
          stroke={props.color || 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.90246 0.866699L1.59583 6.41824C1.47924 6.52107 1.41245 6.66903 1.41245 6.82449C1.41245 6.97995 1.47924 7.12791 1.59583 7.23074L7.90246 12.7834"
          stroke={props.color || 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </IconBase>
    )
  },
  bell: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg width="20" height="20" viewBox="0 0 26 24" fill="none">
            <path
              d="M20.3333 9.01449C20.3333 7.15413 19.5607 5.36997 18.1855 4.0545C16.8102 2.73902 14.9449 2 13 2C11.0551 2 9.18982 2.73902 7.81455 4.0545C6.43928 5.36997 5.66667 7.15413 5.66667 9.01449C5.66667 14.9484 3.21304 17.809 1.86406 18.9333C1.6615 19.1021 1.79337 19.5362 2.05706 19.5362H8.52214C8.6391 19.5362 8.74073 19.6154 8.77521 19.7271C8.99911 20.4529 9.99866 23 13 23C16.0013 23 17.0009 20.4529 17.2248 19.7271C17.2593 19.6154 17.3609 19.5362 17.4779 19.5362H23.9429C24.2066 19.5362 24.3385 19.1021 24.1359 18.9333C22.787 17.809 20.3333 14.9484 20.3333 9.01449Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path
            d="M2,16.059573 C2,16.6865243 4.66666667,17 10,17 C15.3333333,17 18,16.6865243 18,16.059573 C16.5555006,13.9974368 15.8332508,12.2959341 15.8332508,10.9550651 C15.8332508,5.65168837 13.8888339,3 10,3 C5.97792241,3 3.96688362,5.65168837 3.96688362,10.9550651 C3.96688362,12.2959341 3.31125574,13.9974368 2,16.059573 Z"
            stroke={props.color || 'currentColor'}
            strokeWidth="1.5"
            fillRule="nonzero"
          />
          <path
            d="M10,19 C11.1045695,19 12,18.1045695 12,17 C11.4030463,17 10.7363797,17 10,17 C9.26362033,17 8.59695367,17 8,17 C8,18.1045695 8.8954305,19 10,19 Z"
            stroke={props.color || 'currentColor'}
            strokeWidth="1.5"
            fillRule="nonzero"
          />
          <path
            d="M10,3 C10.5522847,3 11,2.55228475 11,2 C10.7015232,2 10.3681898,2 10,2 C9.63181017,2 9.29847683,2 9,2 C9,2.55228475 9.44771525,3 10,3 Z"
            stroke={props.color || 'currentColor'}
            strokeWidth="1.5"
            fillRule="nonzero"
            transform="translate(10.000000, 2.500000) rotate(-180.000000) translate(-10.000000, -2.500000) "
          />
        </g>
      </IconBase>
    )
  },
  bookClosed: ({ color = 'currentColor', ...rest }: IconBaseProps) => (
    <IconBase {...rest} viewBox="0 0 24 24" fill="none">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 19V16H7C5.34315 16 4 17.3431 4 19M8.8 22H16.8C17.9201 22 18.4802 22 18.908 21.782C19.2843 21.5903 19.5903 21.2843 19.782 20.908C20 20.4802 20 19.9201 20 18.8V5.2C20 4.07989 20 3.51984 19.782 3.09202C19.5903 2.71569 19.2843 2.40973 18.908 2.21799C18.4802 2 17.9201 2 16.8 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22Z"
          stroke={color || 'currentColor'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  ),
  cancel: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 6.00002L19 19M6 19L19 6"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <path
          fill={props.color || 'currentColor'}
          fillRule="evenodd"
          d="M10,8.20039342 L13.7949334,4.40546006 C14.291881,3.90851242 15.0975923,3.90851242 15.5945399,4.40546006 C16.0914876,4.9024077 16.0914876,5.70811901 15.5945399,6.20506664 L11.7996066,10 L15.5945399,13.7949334 C16.0914876,14.291881 16.0914876,15.0975923 15.5945399,15.5945399 C15.0975923,16.0914876 14.291881,16.0914876 13.7949334,15.5945399 L10,11.7996066 L6.20506664,15.5945399 C5.70811901,16.0914876 4.9024077,16.0914876 4.40546006,15.5945399 C3.90851242,15.0975923 3.90851242,14.291881 4.40546006,13.7949334 L8.20039342,10 L4.40546006,6.20506664 C3.90851242,5.70811901 3.90851242,4.9024077 4.40546006,4.40546006 C4.9024077,3.90851242 5.70811901,3.90851242 6.20506664,4.40546006 L10,8.20039342 Z"
        />
      </IconBase>
    )
  },
  cancelV2: (props: IconBaseProps) => (
    <IconBase {...props} viewBox="0 0 16 16">
      <path
        d="M14.1334 1.8667L1.8667 14.1334"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1334 14.1334L1.8667 1.8667"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  close: (props: IconBaseProps) => (
    <IconBase {...omit(props, 'viewBox')} viewBox="0 0 12 12">
      <path
        d="M11.7494 12C11.6824 12 11.6199 11.974 11.5724 11.927L5.99975 6.3535L0.427098 11.927C0.380101 11.974 0.317105 12 0.250109 12C0.183114 12 0.120617 11.974 0.0731204 11.927C-0.0243735 11.8295 -0.0243735 11.671 0.0731204 11.5735L5.64577 6.0005L0.0736204 0.427C-0.0238735 0.3295 -0.0238735 0.171 0.0736204 0.0735C0.120617 0.026 0.183614 0 0.250109 0C0.316605 0 0.379601 0.026 0.427098 0.073L5.99975 5.6465L11.5729 0.0735C11.6199 0.0265 11.6829 0.0005 11.7499 0.0005C11.8169 0.0005 11.8794 0.0265 11.9269 0.0735C12.0244 0.171 12.0244 0.3295 11.9269 0.427L6.35323 6L11.9259 11.573C12.0234 11.6705 12.0234 11.829 11.9259 11.9265C11.8789 11.974 11.8164 12 11.7494 12Z"
        fill={props.color || 'currentColor'}
      />
    </IconBase>
  ),
  closeV2: (props: IconBaseProps) => (
    <IconBase {...omit(props, 'viewBox')} viewBox="0 0 12 12">
      <path
        d="M1 11L11 1"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 11L1 1"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  closeChips: () => (
    <SvgIcon
      viewBox="0 0 24 24"
      style={{ marginLeft: '1px' }}
      className="MuiSvgIcon-root MuiChip-deleteIcon"
      focusable="false"
      aria-hidden="true"
    >
      <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"></path>
    </SvgIcon>
  ),
  collapse: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 5H23M1 12H23M1 19H23"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            transform="translate(1.000000, 2.000000)"
            fill={props.color || 'currentColor'}
          >
            <rect x="0" y="4.66666667" width="18" height="2" rx="1" />
            <rect x="0" y="14" width="18" height="2" rx="1" />
            <rect x="0" y="0" width="18" height="2" rx="1" />
            <rect x="0" y="9.33333333" width="18" height="2" rx="1" />
          </g>
        </g>
      </IconBase>
    )
  },
  communication: (props: IconBaseProps) => (
    <IconBase {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M9.91613781,17.7228349 C11.0749024,17.7228349 12.1755161,17.4755826 13.1674025,17.0313048 C15.7929575,18.0225408 17.3479152,18.2530508 17.8322756,17.7228349 C18.1987837,17.3216286 17.964627,15.7819047 17.1298057,13.103663 C17.5810287,12.115135 17.8322756,11.0174143 17.8322756,9.86141743 C17.8322756,5.51967647 14.2881,2 9.91613781,2 C5.54417562,2 2,5.51967647 2,9.86141743 C2,14.2031584 5.54417562,17.7228349 9.91613781,17.7228349 Z"
          stroke={props.color || 'currentColor'}
          strokeWidth="1.5"
          fillRule="nonzero"
        />
        <circle
          stroke={props.color || 'currentColor'}
          fill={props.color || 'currentColor'}
          strokeWidth="1.5"
          fillRule="nonzero"
          cx="6.5"
          cy="10"
          r="0.8"
        />
        <circle
          stroke={props.color || 'currentColor'}
          fill={props.color || 'currentColor'}
          strokeWidth="1.5"
          fillRule="nonzero"
          cx="10"
          cy="10"
          r="0.8"
        />
        <circle
          stroke={props.color || 'currentColor'}
          fill={props.color || 'currentColor'}
          strokeWidth="1.5"
          fillRule="nonzero"
          cx="13.5"
          cy="10"
          r="0.8"
        />
      </g>
    </IconBase>
  ),
  customerPortal: (props: IconBaseProps) => (
    <IconBase {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4429_63108)">
          <path
            d="M15.3337 7.99935C15.3337 12.0494 12.0504 15.3327 8.00033 15.3327C3.95024 15.3327 0.666992 12.0494 0.666992 7.99935C0.666992 3.94926 3.95024 0.666016 8.00033 0.666016C12.0504 0.666016 15.3337 3.94926 15.3337 7.99935Z"
            stroke="#999999"
            strokeWidth="1.5"
          />
          <path
            d="M6.55261 6.55164L10.6335 5.13742L9.21928 9.2183L5.1384 10.6325L6.55261 6.55164Z"
            stroke="#999999"
            strokeWidth="1.5"
          />
        </g>
        <defs>
          <clipPath id="clip0_4429_63108">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </IconBase>
  ),
  minimize01: (props: IconBaseProps) => (
    <IconBase {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 14H10M10 14V20M10 14L3 21M20 10H14M14 10V4M14 10L21 3"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </svg>
    </IconBase>
  ),
  maximize01: (props: IconBaseProps) => (
    <IconBase {...props}>
      <path
        d="M14 10L21 3M21 3H15M21 3V9M10 14L3 21M3 21H9M3 21L3 15"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </IconBase>
  ),
  expand: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V7C22 8.10457 21.1046 9 20 9H4C2.89543 9 2 8.10457 2 7V5Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
            />
            <path
              d="M2 17C2 15.8954 2.89543 15 4 15H20C21.1046 15 22 15.8954 22 17V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V17Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            transform="translate(1.000000, 2.000000)"
            fill={props.color || 'currentColor'}
          >
            <rect x="0" y="0" width="18" height="7" rx="1" />
            <rect x="0" y="9" width="18" height="7" rx="1" />
          </g>
        </g>
      </IconBase>
    )
  },
  'square-check': (props: IconBaseProps) => (
    <IconBase {...omit(props, 'fill')} fill={props.color || 'currentColor'}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M2.03804163,4.10133193 L2.03804163,16.0440992 C2.03804163,17.1486687 2.93347213,18.0440992 4.03804163,18.0440992 L16.020676,18.0440992 C17.1252455,18.0440992 18.020676,17.1486687 18.020676,16.0440992 L18.020676,4.15857672 C18.020676,3.05773666 17.131058,2.16385854 16.0302305,2.15859954 L4.04759614,2.10135475 C2.94303925,2.09607794 2.04334126,2.98722052 2.03806445,4.09177742 C2.03804923,4.09496223 2.03804163,4.09814708 2.03804163,4.10133193 Z"
          stroke={props.color || 'currentColor'}
          strokeWidth="1.5"
        />
        <path
          d="M9.62890625,16.2709961 C9.17480242,15.4506795 8.82568481,14.8476582 8.58154297,14.4619141 L8.19335938,13.8540039 L7.90039062,13.4072266 C7.26073899,12.4111278 6.59424175,11.5883822 5.90087891,10.9389648 C6.2963887,10.6118148 6.66503735,10.4482422 7.00683594,10.4482422 C7.42675991,10.4482422 7.80029133,10.6020492 8.12744141,10.909668 C8.45459148,11.2172867 8.86718501,11.8032183 9.36523438,12.6674805 C9.93164346,10.826651 10.6518511,9.08106294 11.5258789,7.43066406 C12.0092798,6.53222207 12.4401837,5.92798007 12.8186035,5.61791992 C13.1970234,5.30785978 13.6987273,5.15283203 14.3237305,5.15283203 C14.6557634,5.15283203 15.0659155,5.20410105 15.5541992,5.30664062 C14.2993101,6.31738787 13.2959022,7.51854773 12.5439453,8.91015625 C11.7919884,10.3017648 10.8203185,12.7553535 9.62890625,16.2709961 Z"
          fill={props.color || 'currentColor'}
        />
      </g>
    </IconBase>
  ),
  squareCheck: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M9 11.9497L11.1213 14.071L15.364 9.82839M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...omit(props, 'fill')} fill={props.color || 'currentColor'}>
        <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21 1L9.09528 15.4179L4.33337 10.767"
            stroke="#474747"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.1429 10.3028V20.0698C18.1429 20.5835 17.7165 21 17.1905 21H1.95238C1.4264 21 1 20.5835 1 20.0698V5.18678C1 4.67305 1.4264 4.25659 1.95238 4.25659H12.9048"
            stroke="#474747"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </IconBase>
    )
  },
  'checkbox-checked-fancy': (props: IconBaseProps) => (
    <IconBase {...props}>
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15 0.75293L6.66668 11.0863L3.33334 7.75293"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 7.42025V14.4202C13 14.7884 12.7015 15.0869 12.3333 15.0869H1.66667C1.29848 15.0869 1 14.7884 1 14.4202V3.75358C1 3.38539 1.29848 3.08691 1.66667 3.08691H9.33333"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  ),
  'checkbox-checked': (props: IconBaseProps) => (
    <IconBase {...omit(props, 'fill')} fill={props.color || 'currentColor'}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="21"
          height="21"
          rx="2.5"
          fill="white"
          stroke={props.color || 'currentColor'}
        />
        <path
          d="M7 12.6L9.69212 15L15.9737 7"
          stroke={props.color || 'currentColor'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  ),
  'checkbox-unchecked': (props: IconBaseProps & { boldOutline?: boolean }) => (
    <IconBase
      {...omit(props, ['fill', 'bold'])}
      fill={props.color || 'currentColor'}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="21"
          height="21"
          rx="2.5"
          fill="white"
          stroke={props.boldOutline ? COLORS.blue : '#757575'}
        />
      </svg>
    </IconBase>
  ),
  'circle-check': (props: IconBaseProps) => (
    <IconBase {...omit(props, 'fill')} fill={props.color || 'currentColor'}>
      <path d="M10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 Z M10,17.7777778 C14.2955481,17.7777778 17.7777778,14.2955481 17.7777778,10 C17.7777778,5.70445195 14.2955481,2.22222222 10,2.22222222 C5.70445195,2.22222222 2.22222222,5.70445195 2.22222222,10 C2.22222222,14.2955481 5.70445195,17.7777778 10,17.7777778 Z" />
      <path d="M6.05591304,10.0853169 C5.61464387,9.64282702 4.89920518,9.64282702 4.45793601,10.0853169 C4.01666683,10.5278068 4.01666683,11.2452246 4.45793601,11.6877145 L6.7178168,13.9538469 C7.15908598,14.3963368 7.87452466,14.3963368 8.31579384,13.9538469 L19.6690481,2.56918563 C20.1103173,2.12669575 20.1103173,1.40927792 19.6690481,0.966788041 C19.2277789,0.524298166 18.5123403,0.524298166 18.0710711,0.966788041 L7.51680532,11.5502505 L6.05591304,10.0853169 Z" />
    </IconBase>
  ),
  'circle-filled': (props: IconBaseProps) => (
    <IconBase {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <circle
          stroke="#979797"
          fill="#5F8BFA"
          fillRule="nonzero"
          cx="10"
          cy="10"
          r="9"
        />
      </g>
    </IconBase>
  ),
  'circle-outline': (props: IconBaseProps) => (
    <IconBase {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <circle stroke="#979797" fillRule="nonzero" cx="10" cy="10" r="9" />
      </g>
    </IconBase>
  ),
  'circle-x': (props: IconBaseProps) => (
    <IconBase {...omit(props, 'fill')} fill={props.color || 'currentColor'}>
      <g fill={props.color || 'currentColor'} fillRule="evenodd">
        <path
          fillRule="nonzero"
          d="M10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 Z M10,17.7777778 C14.2955481,17.7777778 17.7777778,14.2955481 17.7777778,10 C17.7777778,5.70445195 14.2955481,2.22222222 10,2.22222222 C5.70445195,2.22222222 2.22222222,5.70445195 2.22222222,10 C2.22222222,14.2955481 5.70445195,17.7777778 10,17.7777778 Z"
        />
        <g transform="translate(5.397 5.397)">
          <rect
            width="1.905"
            height="10.794"
            x="3.81"
            y="-.635"
            rx=".952"
            transform="rotate(45 4.762 4.762)"
          />
          <rect
            width="1.905"
            height="10.794"
            x="3.81"
            y="-.635"
            rx=".952"
            transform="rotate(-45 4.762 4.762)"
          />
        </g>
      </g>
    </IconBase>
  ),
  'radio-checked': (props: IconBaseProps) => (
    <IconBase {...omit(props, 'viewBox')} viewBox="0 0 24 24">
      <path
        fill={props.color || 'currentColor'}
        d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
      />
    </IconBase>
  ),
  'radio-unchecked': (props: IconBaseProps) => (
    <IconBase {...omit(props, 'viewBox')} viewBox="0 0 24 24">
      <path
        fill={props.color || 'currentColor'}
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
      />
    </IconBase>
  ),
  'task-group': (props: IconBaseProps) => (
    <IconBase {...omit(props, 'viewBox')}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 8.6C15 8.82 14.805 9 14.565 9H5.435C5.195 9 5 8.82 5 8.6C5 8.6 5 5.62 5 5.4C5 5.18 5.195 5 5.435 5H14.565C14.805 5 15 5.18 15 5.4V8.6ZM15 14.6C15 14.82 14.805 15 14.565 15H5.435C5.195 15 5 14.82 5 14.6V11.4C5 11.18 5.195 11 5.435 11H14.565C14.805 11 15 11.18 15 11.4V14.6Z"
          stroke={props.color || '#414141'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.5082 3H4.4918C3.6679 3 3 3.6679 3 4.4918V15.5082C3 16.3321 3.6679 17 4.4918 17H15.5082C16.3321 17 17 16.3321 17 15.5082V4.4918C17 3.6679 16.3321 3 15.5082 3Z"
          stroke={props.color || '#414141'}
        />
      </svg>
    </IconBase>
  ),

  timeFileQuestion: ({ color = 'currentColor', ...rest }: IconBaseProps) => (
    <IconBase {...rest} viewBox="0 0 24 24" fill="none">
      <path
        d="M10.5 23.5H1.5C0.947715 23.5 0.5 23.0523 0.5 22.5V1.5C0.5 0.947715 0.947715 0.5 1.5 0.5H14.793C15.0583 0.500322 15.3127 0.606084 15.5 0.794L19.207 4.5C19.3946 4.68749 19.4999 4.9418 19.5 5.207V8.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.98092 15.474C6.43265 15.2059 4.49941 13.0549 4.50391 10.4926C4.50842 7.93027 6.44921 5.78605 8.99841 5.527C11.5476 5.26795 13.8801 6.97792 14.3999 9.48696"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 7.50098V10.501H11.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 23.501C20.8137 23.501 23.5 20.8147 23.5 17.501C23.5 14.1873 20.8137 11.501 17.5 11.501C14.1863 11.501 11.5 14.1873 11.5 17.501C11.5 20.8147 14.1863 23.501 17.5 23.501Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.625 16.042C15.625 15.0065 16.4645 14.167 17.5 14.167C18.5355 14.167 19.375 15.0065 19.375 16.042C19.375 17.0775 18.5355 17.917 17.5 17.917V18.917"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 20.917C17.6381 20.917 17.75 21.0289 17.75 21.167C17.75 21.3051 17.6381 21.417 17.5 21.417C17.3619 21.417 17.25 21.3051 17.25 21.167C17.25 21.0289 17.3619 20.917 17.5 20.917"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),

  timeFileBlock: ({ color = 'currentColor', ...rest }: IconBaseProps) => (
    <IconBase {...rest} viewBox="0 0 24 24" fill="none">
      <path
        d="M10.5 23.5H1.5C0.947715 23.5 0.5 23.0523 0.5 22.5V1.5C0.5 0.947715 0.947715 0.5 1.5 0.5H14.793C15.0583 0.500322 15.3127 0.606084 15.5 0.794L19.207 4.5C19.3946 4.68749 19.4999 4.9418 19.5 5.207V8.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.00009 15.4761C6.53688 15.2263 4.62736 13.2115 4.51008 10.7384C4.39279 8.26536 6.10306 6.07886 8.53158 5.59713C10.9601 5.11539 13.3755 6.48348 14.2111 8.81406"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 7.50098V10.501H11.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 23.501C20.8137 23.501 23.5 20.8147 23.5 17.501C23.5 14.1873 20.8137 11.501 17.5 11.501C14.1863 11.501 11.5 14.1873 11.5 17.501C11.5 20.8147 14.1863 23.501 17.5 23.501Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2581 21.7431L21.7431 13.2581"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),

  timeFileCash: ({ color = 'currentColor', ...rest }: IconBaseProps) => (
    <IconBase {...rest} viewBox="0 0 24 24" fill="none">
      <path
        d="M10.5 23.5H1.5C0.947715 23.5 0.5 23.0523 0.5 22.5V1.5C0.5 0.947715 0.947715 0.5 1.5 0.5H14.793C15.0583 0.500322 15.3127 0.606084 15.5 0.794L19.207 4.5C19.3946 4.68749 19.4999 4.9418 19.5 5.207V8.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.52804 15.5C6.89603 15.5123 4.70511 13.4821 4.51732 10.8568C4.32952 8.23143 6.20918 5.91003 8.81614 5.54764C11.4231 5.18524 13.8647 6.90595 14.4 9.48296"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 7.50098V10.501H11.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9999 14.5H16.9669C16.3243 14.5004 15.7722 14.9564 15.6502 15.5873C15.5283 16.2183 15.8708 16.8471 16.4669 17.087L18.5309 17.912C19.1285 18.151 19.4722 18.7807 19.3501 19.4126C19.228 20.0445 18.6745 20.5007 18.0309 20.5H15.9999"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 21.501V20.501"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 14.501V13.501"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 23.501C20.8137 23.501 23.5 20.8147 23.5 17.501C23.5 14.1873 20.8137 11.501 17.5 11.501C14.1863 11.501 11.5 14.1873 11.5 17.501C11.5 20.8147 14.1863 23.501 17.5 23.501Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),

  timeFileAdd: ({ color = 'currentColor', ...rest }: IconBaseProps) => (
    <IconBase {...rest} viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 23.501C20.8137 23.501 23.5 20.8147 23.5 17.501C23.5 14.1873 20.8137 11.501 17.5 11.501C14.1863 11.501 11.5 14.1873 11.5 17.501C11.5 20.8147 14.1863 23.501 17.5 23.501Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 14.501V20.501"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5 17.501H14.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 23.5H1.5C0.947715 23.5 0.5 23.0523 0.5 22.5V1.5C0.5 0.947715 0.947715 0.5 1.5 0.5H14.793C15.0583 0.500322 15.3127 0.606084 15.5 0.794L19.207 4.5C19.3946 4.68749 19.4999 4.9418 19.5 5.207V8.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.18911 15.327C5.90014 14.7042 4.36384 12.5588 4.5115 10.1912C4.65916 7.8236 6.45011 5.88565 8.79873 5.55209C11.1473 5.21852 13.4071 6.58117 14.2081 8.81402"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 7.50098V10.501H11.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),

  filter: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <mask id="path-1-inside-1_132_700" fill="white">
              <path d="M10.5842 7.29855C10.3139 7.56277 10.162 7.92113 10.162 8.29479V14.5894C10.162 15.6367 9.03444 16.3179 8.07608 15.8495L6.63472 15.1451C6.14641 14.9064 5.83796 14.4186 5.83796 13.8849V8.29479C5.83796 7.92113 5.6861 7.56277 5.4158 7.29855L1.09172 3.07187C0.183712 2.18432 0.826801 0.666748 2.11091 0.666748H13.8891C15.1732 0.666748 15.8163 2.18432 14.9083 3.07188L10.5842 7.29855Z" />
            </mask>
            <path
              d="M14.9083 3.07188L15.9568 4.14455L14.9083 3.07188ZM1.09172 3.07187L0.0432069 4.14455H0.0432069L1.09172 3.07187ZM5.4158 7.29855L6.46431 6.22588L5.4158 7.29855ZM6.63472 15.1451L7.29337 13.7974L6.63472 15.1451ZM8.07608 15.8495L7.41743 17.1972L8.07608 15.8495ZM10.5842 7.29855L9.53569 6.22588L10.5842 7.29855ZM8.66204 8.29479V14.5894H11.662V8.29479H8.66204ZM8.73473 14.5019L7.29337 13.7974L5.97607 16.4927L7.41743 17.1972L8.73473 14.5019ZM7.33796 13.8849V8.29479H4.33796V13.8849H7.33796ZM6.46431 6.22588L2.14023 1.9992L0.0432069 4.14455L4.36729 8.37123L6.46431 6.22588ZM2.11091 2.16675H13.8891V-0.833252H2.11091V2.16675ZM13.8598 1.9992L9.53569 6.22588L11.6327 8.37123L15.9568 4.14455L13.8598 1.9992ZM13.8891 2.16675C13.9006 2.16675 13.9005 2.16825 13.8925 2.16575C13.8848 2.16336 13.8756 2.15909 13.8669 2.15304C13.8504 2.1417 13.8431 2.12997 13.8396 2.12174C13.8361 2.11351 13.8299 2.0928 13.8357 2.05988C13.8387 2.0429 13.8444 2.02658 13.8516 2.01295C13.859 1.99899 13.8642 1.99486 13.8598 1.9992L15.9568 4.14455C17.8785 2.26608 16.4444 -0.833252 13.8891 -0.833252V2.16675ZM2.14023 1.9992C2.13579 1.99486 2.14102 1.99899 2.1484 2.01295C2.1556 2.02658 2.1613 2.0429 2.16431 2.05988C2.17014 2.0928 2.16387 2.11351 2.16038 2.12174C2.1569 2.12997 2.1496 2.1417 2.13314 2.15304C2.12435 2.15909 2.11518 2.16336 2.10752 2.16575C2.0995 2.16825 2.09939 2.16675 2.11091 2.16675V-0.833252C-0.444389 -0.833252 -1.87856 2.26607 0.0432069 4.14455L2.14023 1.9992ZM7.33796 8.29479C7.33796 7.51214 7.01957 6.76863 6.46431 6.22588L4.36729 8.37123C4.35264 8.35691 4.33796 8.33012 4.33796 8.29479H7.33796ZM7.29337 13.7974C7.30776 13.8044 7.33796 13.8321 7.33796 13.8849H4.33796C4.33796 15.005 4.98507 16.0084 5.97607 16.4927L7.29337 13.7974ZM8.66204 14.5894C8.66204 14.5848 8.66277 14.5752 8.66625 14.5626C8.66965 14.5504 8.67461 14.5391 8.68016 14.5297C8.69085 14.5117 8.70062 14.5053 8.70282 14.5039C8.70503 14.5026 8.70897 14.5006 8.71691 14.5002C8.72855 14.4995 8.73672 14.5028 8.73473 14.5019L7.41743 17.1972C9.32232 18.1282 11.662 16.801 11.662 14.5894H8.66204ZM11.662 8.29479C11.662 8.33012 11.6474 8.35691 11.6327 8.37123L9.53569 6.22588C8.98043 6.76864 8.66204 7.51214 8.66204 8.29479H11.662Z"
              fill={props.color || 'currentColor'}
              mask="url(#path-1-inside-1_132_700)"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <g fill={props.color || 'currentColor'}>
          <path
            d="M1,1 L19.0709639,1 L11.5066238,8.56434009 L11.5066238,16.2650659 C11.5066238,16.6023638 11.3365863,16.9169341 11.0543928,17.1016955 L8.28932748,18.9120751 L8.28932748,8.56434009 L1,1 Z"
            fill={props.color || 'currentColor'}
          />
        </g>
      </IconBase>
    )
  },
  filterNoFill: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <mask id="path-1-inside-1_132_700" fill="white">
              <path d="M10.5842 7.29855C10.3139 7.56277 10.162 7.92113 10.162 8.29479V14.5894C10.162 15.6367 9.03444 16.3179 8.07608 15.8495L6.63472 15.1451C6.14641 14.9064 5.83796 14.4186 5.83796 13.8849V8.29479C5.83796 7.92113 5.6861 7.56277 5.4158 7.29855L1.09172 3.07187C0.183712 2.18432 0.826801 0.666748 2.11091 0.666748H13.8891C15.1732 0.666748 15.8163 2.18432 14.9083 3.07188L10.5842 7.29855Z" />
            </mask>
            <path
              d="M14.9083 3.07188L15.9568 4.14455L14.9083 3.07188ZM1.09172 3.07187L0.0432069 4.14455H0.0432069L1.09172 3.07187ZM5.4158 7.29855L6.46431 6.22588L5.4158 7.29855ZM6.63472 15.1451L7.29337 13.7974L6.63472 15.1451ZM8.07608 15.8495L7.41743 17.1972L8.07608 15.8495ZM10.5842 7.29855L9.53569 6.22588L10.5842 7.29855ZM8.66204 8.29479V14.5894H11.662V8.29479H8.66204ZM8.73473 14.5019L7.29337 13.7974L5.97607 16.4927L7.41743 17.1972L8.73473 14.5019ZM7.33796 13.8849V8.29479H4.33796V13.8849H7.33796ZM6.46431 6.22588L2.14023 1.9992L0.0432069 4.14455L4.36729 8.37123L6.46431 6.22588ZM2.11091 2.16675H13.8891V-0.833252H2.11091V2.16675ZM13.8598 1.9992L9.53569 6.22588L11.6327 8.37123L15.9568 4.14455L13.8598 1.9992ZM13.8891 2.16675C13.9006 2.16675 13.9005 2.16825 13.8925 2.16575C13.8848 2.16336 13.8756 2.15909 13.8669 2.15304C13.8504 2.1417 13.8431 2.12997 13.8396 2.12174C13.8361 2.11351 13.8299 2.0928 13.8357 2.05988C13.8387 2.0429 13.8444 2.02658 13.8516 2.01295C13.859 1.99899 13.8642 1.99486 13.8598 1.9992L15.9568 4.14455C17.8785 2.26608 16.4444 -0.833252 13.8891 -0.833252V2.16675ZM2.14023 1.9992C2.13579 1.99486 2.14102 1.99899 2.1484 2.01295C2.1556 2.02658 2.1613 2.0429 2.16431 2.05988C2.17014 2.0928 2.16387 2.11351 2.16038 2.12174C2.1569 2.12997 2.1496 2.1417 2.13314 2.15304C2.12435 2.15909 2.11518 2.16336 2.10752 2.16575C2.0995 2.16825 2.09939 2.16675 2.11091 2.16675V-0.833252C-0.444389 -0.833252 -1.87856 2.26607 0.0432069 4.14455L2.14023 1.9992ZM7.33796 8.29479C7.33796 7.51214 7.01957 6.76863 6.46431 6.22588L4.36729 8.37123C4.35264 8.35691 4.33796 8.33012 4.33796 8.29479H7.33796ZM7.29337 13.7974C7.30776 13.8044 7.33796 13.8321 7.33796 13.8849H4.33796C4.33796 15.005 4.98507 16.0084 5.97607 16.4927L7.29337 13.7974ZM8.66204 14.5894C8.66204 14.5848 8.66277 14.5752 8.66625 14.5626C8.66965 14.5504 8.67461 14.5391 8.68016 14.5297C8.69085 14.5117 8.70062 14.5053 8.70282 14.5039C8.70503 14.5026 8.70897 14.5006 8.71691 14.5002C8.72855 14.4995 8.73672 14.5028 8.73473 14.5019L7.41743 17.1972C9.32232 18.1282 11.662 16.801 11.662 14.5894H8.66204ZM11.662 8.29479C11.662 8.33012 11.6474 8.35691 11.6327 8.37123L9.53569 6.22588C8.98043 6.76864 8.66204 7.51214 8.66204 8.29479H11.662Z"
              fill={props.color || 'currentColor'}
              mask="url(#path-1-inside-1_132_700)"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props} viewBox="0 0 18 20" fill="none">
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.3501 2.575C16.5205 2.34774 16.548 2.04368 16.4209 1.78959C16.2939 1.5355 16.0342 1.375 15.7501 1.375H2.23584C1.95177 1.375 1.69207 1.5355 1.56502 1.78959C1.43798 2.04368 1.4654 2.34774 1.63584 2.575L7.49184 10.4432V17.875C7.49184 18.1591 7.65235 18.4188 7.90643 18.5458C8.16052 18.6729 8.46458 18.6454 8.69184 18.475L10.1918 17.35C10.3807 17.2084 10.4918 16.9861 10.4918 16.75V10.4425L16.3501 2.575Z"
            stroke={props.color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </IconBase>
    )
  },
  folder: (props: IconBaseProps) => (
    <IconBase {...props}>
      <g fill="none" fillRule="evenodd" transform="translate(1 1)">
        <path
          stroke={props.color || 'currentColor'}
          strokeLinejoin="round"
          d="M15.9115513 18L2.08844927 18C1.1631924 18 .404886343 17.2657602.375054771 16.3409844L0 4.71428571 18 4.71428571 17.6249444 16.3409844C17.5951129 17.2657602 16.8368078 18 15.9115513 18zM17.1428571 3.85714286L17.1428571 3.42857143C17.1428571 2.71849089 16.5672226 2.14285714 15.8571429 2.14285714L10.2857143 2.14285714 7.71428571 0 2.57142857 0C1.8613482 0 1.28571429.575633914 1.28571429 1.28571429L1.28571429 3.85714286"
        />
        <path
          fill={props.color || 'currentColor'}
          fillRule="nonzero"
          d="M6.85714286 11.1428571L6.85714286 13.7142857C6.85714286 13.9509792 7.04902082 14.1428571 7.28571429 14.1428571 7.52240775 14.1428571 7.71428571 13.9509792 7.71428571 13.7142857L7.71428571 11.1428571C7.71428571 10.9061637 7.52240775 10.7142857 7.28571429 10.7142857 7.04902082 10.7142857 6.85714286 10.9061637 6.85714286 11.1428571zM8.57142857 11.1428571L8.57142857 13.7142857C8.57142857 13.9509792 8.76330654 14.1428571 9 14.1428571 9.23669346 14.1428571 9.42857143 13.9509792 9.42857143 13.7142857L9.42857143 11.1428571C9.42857143 10.9061637 9.23669346 10.7142857 9 10.7142857 8.76330654 10.7142857 8.57142857 10.9061637 8.57142857 11.1428571zM10.2857143 11.1428571L10.2857143 13.7142857C10.2857143 13.9509792 10.4775923 14.1428571 10.7142857 14.1428571 10.9509792 14.1428571 11.1428571 13.9509792 11.1428571 13.7142857L11.1428571 11.1428571C11.1428571 10.9061637 10.9509792 10.7142857 10.7142857 10.7142857 10.4775923 10.7142857 10.2857143 10.9061637 10.2857143 11.1428571zM12 11.1428571L12 13.7142857C12 13.9509792 12.191878 14.1428571 12.4285714 14.1428571 12.6652649 14.1428571 12.8571429 13.9509792 12.8571429 13.7142857L12.8571429 11.1428571C12.8571429 10.9061637 12.6652649 10.7142857 12.4285714 10.7142857 12.191878 10.7142857 12 10.9061637 12 11.1428571zM13.7142857 11.1428571L13.7142857 13.7142857C13.7142857 13.9509792 13.9061637 14.1428571 14.1428571 14.1428571 14.3795506 14.1428571 14.5714286 13.9509792 14.5714286 13.7142857L14.5714286 11.1428571C14.5714286 10.9061637 14.3795506 10.7142857 14.1428571 10.7142857 13.9061637 10.7142857 13.7142857 10.9061637 13.7142857 11.1428571z"
        />
      </g>
    </IconBase>
  ),
  gradCap: (props: IconBaseProps) => (
    <IconBase {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-0.350000, 2.100000)"
          fill={props.color || 'currentColor'}
          fillRule="nonzero"
        >
          <path d="M10.3002404,0.398076923 C10.2567007,0.404296875 10.2147159,0.416736779 10.1758413,0.435396635 L0.621995192,5.21231971 C0.482046473,5.27762901 0.391856971,5.41913301 0.391856971,5.57307692 C0.391856971,5.72702083 0.482046473,5.86852484 0.621995192,5.93383413 L1.99038462,6.61802885 L1.99038462,12.415024 C1.53010817,12.5814079 1.19423077,13.0199143 1.19423077,13.5346154 C1.19423077,13.7647536 1.27197997,13.9404671 1.35594952,14.1317308 C1.43991907,14.3229944 1.53788301,14.5111478 1.64206731,14.6915264 C1.8504359,15.0507288 2.06502404,15.3508413 2.06502404,15.3508413 L2.38846154,15.8235577 L2.71189904,15.3508413 C2.71189904,15.3508413 2.92648718,15.0507288 3.13485577,14.6915264 C3.23904006,14.5111478 3.33700401,14.3229944 3.42097356,14.1317308 C3.50494311,13.9404671 3.58269231,13.7647536 3.58269231,13.5346154 C3.58269231,13.0199143 3.2468149,12.5814079 2.78653846,12.415024 L2.78653846,7.01610577 L4.37884615,7.81225962 L4.37884615,9.15576923 C4.37884615,9.39834736 4.53901002,9.55229127 4.66496394,9.64092548 C4.79091787,9.7295597 4.92620192,9.78553926 5.08792067,9.83996394 C5.41135817,9.9488133 5.83897997,10.0390024 6.35679087,10.1136418 C7.39396795,10.2613658 8.79501202,10.35 10.35,10.35 C11.904988,10.35 13.3060321,10.2613658 14.3432091,10.1136418 C14.86102,10.0390024 15.2886418,9.9488133 15.6120793,9.83996394 C15.7737981,9.78553926 15.9090821,9.7295597 16.0350361,9.64092548 C16.16099,9.55229127 16.3211538,9.39834736 16.3211538,9.15576923 L16.3211538,7.81225962 L20.0780048,5.93383413 C20.2179535,5.86852484 20.308143,5.72702083 20.308143,5.57307692 C20.308143,5.41913301 20.2179535,5.27762901 20.0780048,5.21231971 L10.5241587,0.435396635 C10.4541843,0.4011867 10.3764347,0.388746796 10.3002404,0.398076923 Z M10.35,1.24399038 L19.0081731,5.57307692 L16.3211538,6.91658654 L16.3211538,6.36923077 C16.3211538,6.12509776 16.16099,5.97115385 16.0350361,5.88407452 C15.9090821,5.79699519 15.7737981,5.73946074 15.6120793,5.68503606 C15.2870869,5.5761867 14.8625753,5.4859976 14.3432091,5.41135817 C13.3044772,5.26363422 11.898768,5.175 10.35,5.175 C8.80123197,5.175 7.39552284,5.26363422 6.35679087,5.41135817 C5.83742468,5.4859976 5.41291306,5.5761867 5.08792067,5.68503606 C4.92620192,5.73946074 4.79091787,5.79699519 4.66496394,5.88407452 C4.53901002,5.97115385 4.37884615,6.12509776 4.37884615,6.36923077 L4.37884615,6.91658654 L1.69182692,5.57307692 L10.35,1.24399038 Z M10.35,5.97115385 C11.8676683,5.97115385 13.2484976,6.0551234 14.23125,6.19507212 C14.7226262,6.26504647 15.1098181,6.35057091 15.3508413,6.43143029 C15.4394756,6.46097516 15.4861254,6.48585497 15.525,6.50606971 L15.525,8.44669471 C15.2124475,8.34873037 14.8205905,8.26631611 14.3432091,8.19789663 C13.3060321,8.05017268 11.904988,7.96153846 10.35,7.96153846 C8.79501202,7.96153846 7.39396795,8.05017268 6.35679087,8.19789663 C5.87940946,8.26631611 5.48755248,8.34873037 5.175,8.44669471 L5.175,6.50606971 C5.2138746,6.48585497 5.26052444,6.46097516 5.34915865,6.43143029 C5.59018189,6.35057091 5.9773738,6.26504647 6.46875,6.19507212 C7.4515024,6.0551234 8.83233173,5.97115385 10.35,5.97115385 Z M10.35,8.75769231 C11.8738882,8.75769231 13.2500525,8.84166186 14.23125,8.98161058 C14.5920072,9.03292508 14.8314752,9.0951246 15.0647236,9.15576923 C14.8314752,9.21641386 14.5920072,9.27861338 14.23125,9.32992788 C13.2500525,9.4698766 11.8738882,9.55384615 10.35,9.55384615 C8.82611178,9.55384615 7.44994752,9.4698766 6.46875,9.32992788 C6.10799279,9.27861338 5.86852484,9.21641386 5.63527644,9.15576923 C5.86852484,9.0951246 6.10799279,9.03292508 6.46875,8.98161058 C7.44994752,8.84166186 8.82611178,8.75769231 10.35,8.75769231 Z M2.38846154,13.1365385 C2.60927003,13.1365385 2.78653846,13.3138069 2.78653846,13.5346154 C2.78653846,13.5237304 2.76476843,13.6605693 2.69945913,13.8082933 C2.63414984,13.9560172 2.53307532,14.1301759 2.43822115,14.2934495 C2.41178646,14.3400994 2.41489623,14.3369892 2.38846154,14.3805288 C2.36202684,14.3369892 2.36513662,14.3400994 2.33870192,14.2934495 C2.24384776,14.1301759 2.14277324,13.9560172 2.07746394,13.8082933 C2.01215465,13.6605693 1.99038462,13.5237304 1.99038462,13.5346154 C1.99038462,13.3138069 2.16765305,13.1365385 2.38846154,13.1365385 Z" />
        </g>
      </g>
    </IconBase>
  ),
  hamburger: (props: IconBaseProps) => {
    return (
      <IconBase {...props}>
        <svg
          width="18"
          height="16"
          viewBox="0 0 18 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.66669 3.33301H16.3334M1.66669 7.99967H16.3334M1.66669 12.6663H16.3334"
            stroke={props.color || '#121212'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </IconBase>
    )
  },
  house: (props: IconBaseProps) => (
    <IconBase {...props}>
      <path
        fill="none"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.2504142,6.95945948 L16.2504142,3.10830996 C16.2504142,2.87646225 16.0624642,2.68851252 15.8306168,2.68851252 L13.7316296,2.68851252 C13.4997821,2.68851252 13.3118321,2.87646225 13.3118321,3.10830996 L13.3118321,5.13432455 L10.2302642,2.1197144 C10.0739052,1.96675306 9.82629746,1.95948729 9.66123873,2.10301679 L1.14517729,9.50828721 C0.852189908,9.76305874 1.03237385,10.2448664 1.42063942,10.2448664 L3.23669363,10.2448664 L3.23669363,17.3814228 C3.23669363,17.8451179 3.6125931,18.2210177 4.07628851,18.2210177 L15.8306168,18.2210177 C16.2943118,18.2210177 16.6702116,17.8451179 16.6702116,17.3814228 L16.6702116,10.2448664 L18.5793592,10.2448664 C18.9555858,10.2448664 19.1418606,9.78807981 18.8729231,9.52498498 L16.2504142,6.95945948 Z"
      />
    </IconBase>
  ),
  info: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
              d="M9.75002 12.3334C9.75002 12.7476 9.41423 13.0834 9.00002 13.0834C8.58581 13.0834 8.25002 12.7476 8.25002 12.3334H9.75002ZM8.25002 9.00004C8.25002 8.58583 8.58581 8.25004 9.00002 8.25004C9.41423 8.25004 9.75002 8.58583 9.75002 9.00004H8.25002ZM9.75002 6.33337C9.75002 6.74759 9.41423 7.08337 9.00002 7.08337C8.58581 7.08337 8.25002 6.74759 8.25002 6.33337H9.75002ZM8.25002 6.00004C8.25002 5.58583 8.58581 5.25004 9.00002 5.25004C9.41423 5.25004 9.75002 5.58583 9.75002 6.00004H8.25002ZM15.5834 9.00004C15.5834 5.36417 12.6359 2.41671 9.00002 2.41671V0.916707C13.4643 0.916707 17.0834 4.53574 17.0834 9.00004H15.5834ZM9.00002 2.41671C5.36415 2.41671 2.41669 5.36417 2.41669 9.00004H0.916687C0.916687 4.53574 4.53572 0.916707 9.00002 0.916707V2.41671ZM2.41669 9.00004C2.41669 12.6359 5.36415 15.5834 9.00002 15.5834V17.0834C4.53572 17.0834 0.916687 13.4643 0.916687 9.00004H2.41669ZM9.00002 15.5834C12.6359 15.5834 15.5834 12.6359 15.5834 9.00004H17.0834C17.0834 13.4643 13.4643 17.0834 9.00002 17.0834V15.5834ZM8.25002 12.3334V9.00004H9.75002V12.3334H8.25002ZM8.25002 6.33337V6.00004H9.75002V6.33337H8.25002Z"
              fill={props.color || 'currentColor'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <circle
            stroke={props.color || 'currentColor'}
            cx="10"
            cy="10"
            r="9"
          />
          <path
            d="M10.0413536,9.31034844 L8.84993672,9.31034844 C8.84993672,9.11052909 8.85409948,9.05631339 8.8790769,8.86648501 C8.90405432,8.67665663 8.95650611,8.47684029 9.03643385,8.26702997 L11.3313134,8.26702997 L9.98253954,15.9550409 C9.8726389,15.9750228 9.84819661,15.9875113 9.70332758,15.9925068 C9.55845856,15.9975023 9.43107563,16 9.32117499,16 C9.21127435,16 9.09637995,15.9975023 8.97648834,15.9925068 C8.85659674,15.9875113 9.00396392,15.9750228 8.89406328,15.9550409 L10.0413536,9.31034844 Z M9.90564366,6.67847411 C9.90564366,6.38873606 9.9306207,6.11398858 9.98057554,5.85422343 C10.0305304,5.59445828 10.0954707,5.32970162 10.1753984,5.0599455 C10.315272,5.03996357 10.3152705,5.02497734 10.4751259,5.01498638 C10.6349814,5.00499541 10.7748529,5 10.8947445,5 C11.0146361,5 11.1520098,5.00499541 11.3068698,5.01498638 C11.4617298,5.02497734 11.5141807,5.03996357 11.6440633,5.0599455 C11.6340723,5.34968356 11.6040999,5.62692874 11.554145,5.89168937 C11.5041902,6.15645001 11.4392499,6.41870896 11.3593221,6.67847411 C11.2194486,6.69845605 11.1595046,6.71094457 10.9996491,6.71594005 C10.8397936,6.72093554 10.6999222,6.72343324 10.5800306,6.72343324 C10.4701299,6.72343324 10.3352539,6.72093554 10.1753984,6.71594005 C10.0155429,6.71094457 10.0255353,6.69845605 9.90564366,6.67847411 Z"
            fill={props.color || 'currentColor'}
          />
        </g>
      </IconBase>
    )
  },
  info2: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 10.5837C8.5313 10.5837 10.5833 8.53163 10.5833 6.00033C10.5833 3.46902 8.5313 1.41699 6 1.41699C3.46869 1.41699 1.41667 3.46902 1.41667 6.00033C1.41667 8.53163 3.46869 10.5837 6 10.5837Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.04167 8.08528H6.41667C6.18655 8.08528 6 7.89874 6 7.66862V4.96029C6 4.84523 5.90673 4.75195 5.79167 4.75195H5.16667"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.89375 3.70801C5.83622 3.70801 5.78959 3.75464 5.78959 3.81217C5.78959 3.8697 5.83622 3.91634 5.89375 3.91634C5.95128 3.91634 5.99792 3.8697 5.99792 3.81217C5.99792 3.75464 5.95128 3.70801 5.89375 3.70801"
        stroke={props.color || 'currentColor'}
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  info3: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        clipRule="evenodd"
        d="M8.00008 15.334C12.0502 15.334 15.3334 12.0508 15.3334 8.00069C15.3334 3.9506 12.0502 0.667358 8.00008 0.667358C3.94999 0.667358 0.666748 3.9506 0.666748 8.00069C0.666748 12.0508 3.94999 15.334 8.00008 15.334Z"
        stroke="#8F8F8F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.66675 11.3367H8.66675C8.29856 11.3367 8.00008 11.0382 8.00008 10.67V6.33669C8.00008 6.1526 7.85084 6.00336 7.66675 6.00336H6.66675"
        stroke="#8F8F8F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.83 4.33337C7.73795 4.33337 7.66333 4.40799 7.66333 4.50004C7.66333 4.59209 7.73795 4.66671 7.83 4.66671C7.92204 4.66671 7.99666 4.59209 7.99666 4.50004C7.99666 4.40799 7.92204 4.33337 7.83 4.33337"
        stroke="#8F8F8F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  flag: (props: IconBaseProps) => (
    <IconBase {...omit(props, 'fill')} fill={props.color || 'currentColor'}>
      <svg viewBox="0 0 48 48">
        <g />
        <g>
          <rect
            x="5"
            y="2"
            fill="none"
            stroke={props.color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            width="4"
            height="44"
          />

          <polyline
            fill="none"
            stroke={props.color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            points="9,5 39,16 9,27"
          />
          <line
            fill="none"
            stroke={props.color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            x1="13"
            y1="21"
            x2="26"
            y2="16"
          />
        </g>
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
      </svg>
    </IconBase>
  ),
  meatballsVertical: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg width="24" height="24" viewBox="0 0 24 29" fill="none">
            <path
              d="M14 4C14 5.10457 13.1046 6 12 6C10.8954 6 10 5.10457 10 4C10 2.89543 10.8954 2 12 2C13.1046 2 14 2.89543 14 4Z"
              fill={props.color || 'currentColor'}
            />
            <path
              d="M14 20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20C10 18.8954 10.8954 18 12 18C13.1046 18 14 18.8954 14 20Z"
              fill={props.color || 'currentColor'}
            />
            <path
              d="M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
              fill={props.color || 'currentColor'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <g
          fill={props.color || 'currentColor'}
          fillRule="evenodd"
          transform="rotate(-90 12.5 4.022)"
        >
          <circle cx="12.478" cy="1.522" r="1.522" />
          <circle cx="7" cy="1.522" r="1.522" />
          <circle cx="1.522" cy="1.522" r="1.522" />
        </g>
      </IconBase>
    )
  },
  meatballsHorizontal: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="21"
            height="21"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 14C18.8954 14 18 13.1046 18 12C18 10.8954 18.8954 10 20 10C21.1046 10 22 10.8954 22 12C22 13.1046 21.1046 14 20 14Z"
              fill="#121212"
            />
            <path
              d="M4 14C2.89543 14 2 13.1046 2 12C2 10.8954 2.89543 10 4 10C5.10457 10 6 10.8954 6 12C6 13.1046 5.10457 14 4 14Z"
              fill="#121212"
            />
            <path
              d="M12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14Z"
              fill="#121212"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <g
          fill={props.color || 'currentColor'}
          fillRule="evenodd"
          transform="translate(3.478 8.478)"
        >
          <circle cx="12.478" cy="1.522" r="1.522" />
          <circle cx="7" cy="1.522" r="1.522" />
          <circle cx="1.522" cy="1.522" r="1.522" />
        </g>
      </IconBase>
    )
  },
  mentions: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.5 20.353C15.9221 21.394 14.0318 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 13.6569 20.6569 15 19 15C17.3431 15 16 13.6569 16 12M16 8V13M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path
            d="M17.91,9.1225 C17.91,9.84583695 17.8020844,10.5574965 17.58625,11.2575 C17.3704156,11.9575035 17.0554187,12.5874972 16.64125,13.1475 C16.2270813,13.7075028 15.7283363,14.1595816 15.145,14.50375 C14.5616638,14.8479184 13.9025037,15.02 13.1675,15.02 C12.3508293,15.02 11.709169,14.8391685 11.2425,14.4775 C10.904165,14.6758343 10.5250021,14.8333328 10.105,14.95 C9.6849979,15.0666673 9.22416918,15.125 8.7225,15.125 C7.90582925,15.125 7.24958581,14.8770858 6.75375,14.38125 C6.25791419,13.8854142 6.01,13.2058376 6.01,12.3425 C6.01,11.5491627 6.14416532,10.8170867 6.4125,10.14625 C6.68083467,9.47541331 7.04249773,8.89791909 7.4975,8.41375 C7.95250228,7.92958091 8.48624694,7.55041804 9.09875,7.27625 C9.71125306,7.00208196 10.3616632,6.865 11.05,6.865 C11.516669,6.865 11.9629145,6.89999965 12.38875,6.97 C12.8145855,7.04000035 13.2316646,7.13916602 13.64,7.2675 L12.38,13.515 C12.4966672,13.6083338 12.6395825,13.6695832 12.80875,13.69875 C12.9779175,13.7279168 13.1441659,13.7425 13.3075,13.7425 C13.7975024,13.7425 14.2291648,13.5995848 14.6025,13.31375 C14.9758352,13.0279152 15.2937487,12.6604189 15.55625,12.21125 C15.8187513,11.7620811 16.0170827,11.2662527 16.15125,10.72375 C16.2854173,10.1812473 16.3525,9.64750262 16.3525,9.1225 C16.3525,7.64082592 15.9150044,6.51500385 15.04,5.745 C14.1649956,4.97499615 12.9341746,4.59 11.3475,4.59 C10.1341606,4.59 9.05500472,4.80291454 8.11,5.22875 C7.16499528,5.65458546 6.36875324,6.22332977 5.72125,6.935 C5.07374676,7.64667022 4.58083502,8.45749545 4.2425,9.3675 C3.90416497,10.2775045 3.735,11.2166618 3.735,12.185 C3.735,13.0950046 3.86624869,13.8766634 4.12875,14.53 C4.39125131,15.1833366 4.74999773,15.7170813 5.205,16.13125 C5.66000228,16.5454187 6.19666358,16.8516657 6.815,17.05 C7.43333643,17.2483343 8.09832977,17.3475 8.81,17.3475 C9.38166953,17.3475 9.91833082,17.3037504 10.42,17.21625 C10.9216692,17.1287496 11.3766646,17.0091674 11.785,16.8575 C11.8550004,17.0208341 11.9249997,17.2045823 11.995,17.40875 C12.0650004,17.6129177 12.1233331,17.8374988 12.17,18.0825 C11.3183291,18.4791686 10.1866737,18.6775 8.775,18.6775 C7.86499545,18.6775 7.00458739,18.549168 6.19375,18.2925 C5.38291261,18.035832 4.6741697,17.642086 4.0675,17.11125 C3.4608303,16.580414 2.98250175,15.912504 2.6325,15.1075 C2.28249825,14.302496 2.1075,13.3516721 2.1075,12.255 C2.1075,11.2049948 2.29124816,10.1462553 2.65875,9.07875 C3.02625184,8.01124466 3.59499615,7.04292101 4.365,6.17375 C5.13500385,5.30457899 6.11207741,4.59583608 7.29625,4.0475 C8.48042259,3.49916393 9.8891585,3.225 11.5225,3.225 C12.4091711,3.225 13.2404128,3.34458214 14.01625,3.58375 C14.7920872,3.82291786 15.4687471,4.18749755 16.04625,4.6775 C16.6237529,5.16750245 17.0787483,5.78291296 17.41125,6.52375 C17.7437517,7.26458704 17.91,8.13082837 17.91,9.1225 Z M11.7675,8.37 C11.6158326,8.33499982 11.475834,8.30875009 11.3475,8.29125 C11.219166,8.27374991 11.0850007,8.265 10.945,8.265 C10.4899977,8.265 10.0670853,8.36124904 9.67625,8.55375 C9.28541471,8.74625096 8.94708476,9.01166498 8.66125,9.35 C8.37541524,9.68833502 8.15083415,10.0849977 7.9875,10.54 C7.82416585,10.9950023 7.7425,11.4849974 7.7425,12.01 C7.7425,12.605003 7.87374869,13.0424986 8.13625,13.3225 C8.39875131,13.6025014 8.79249737,13.7425 9.3175,13.7425 C9.58583468,13.7425 9.83083222,13.7191669 10.0525,13.6725 C10.2741678,13.6258331 10.5249986,13.538334 10.805,13.41 L11.7675,8.37 Z"
            stroke={props.color || 'currentColor'}
            strokeWidth="0.25"
            fill={props.color || 'currentColor'}
          />
        </g>
      </IconBase>
    )
  },
  messages: (props: IconBaseProps) => (
    <IconBase {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke={props.color || 'currentColor'}
        strokeLinejoin="round"
        transform="translate(1 1.5)"
      >
        <path d="M15.2608696,6.26086957 C16.4347826,7.35652174 17.1782609,8.96086957 17.1782609,10.7217391 C17.1782609,11.6217391 16.9826087,12.4826087 16.6304348,13.2652174 C16.6304348,13.2652174 16.3173913,14.9086957 18,16.5913043 C18,16.5913043 14.9086957,17.2565217 13.8130435,16.2 C12.9913043,16.5913043 12.0913043,16.826087 11.1130435,16.826087 C9.1173913,16.826087 7.3173913,15.8478261 6.22173913,14.3608696" />
        <path d="M0,12.7565217 C0,12.7565217 3.24782609,13.4217391 4.42173913,12.3652174 C5.2826087,12.7956522 6.22173913,13.0304348 7.27826087,13.0304348 C10.8,13.0304348 13.6956522,10.1347826 13.6956522,6.61304348 C13.6956522,3.05217391 10.8391304,0.195652174 7.27826087,0.195652174 C3.75652174,0.195652174 0.860869565,3.09130435 0.860869565,6.61304348 C0.860869565,7.55217391 1.05652174,8.49130435 1.44782609,9.27391304 C1.44782609,9.27391304 1.8,10.9956522 0,12.7565217 Z" />
      </g>
    </IconBase>
  ),
  milestone: (props: IconBaseProps) => {
    return (
      <IconBase {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path
            d="M17.7286863,10.0717312 L14.6531336,4.5 L2.66392522,4.5 L5.14586002,9.63699905 C5.28014364,9.91493334 5.27854791,10.2393051 5.14153631,10.5159047 L2.67270151,15.5 L14.6567007,15.5 L17.7286863,10.0717312 Z"
            stroke={props.color || 'currentColor'}
          />
        </g>
      </IconBase>
    )
  },
  milestoneCrossed: (props: IconBaseProps) => (
    <IconBase {...props}>
      <g fill="none" fillRule="evenodd">
        <circle
          cx="4"
          cy="4"
          r="3"
          fill="#414141"
          fillRule="nonzero"
          stroke="#414141"
        />
        <circle cx="16" cy="16" r="3" stroke="#414141" />
        <polyline
          stroke="#414141"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="4 7 4 10 8.379 10 16 10 16 13"
        />
      </g>
    </IconBase>
  ),
  dotMilestone: (props: IconBaseProps) => {
    return (
      <IconBase {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path
            d="M12,15 C12,15.3474863 12.0506388,15.6831453 12.1449393,16 L2.67270151,16 C2.39655913,16 2.17270151,15.7761424 2.17270151,15.5 C2.17270151,15.423008 2.19048175,15.347056 2.22465634,15.2780641 L4.69349114,10.2939689 C4.76199694,10.155669 4.76279481,9.99348317 4.695653,9.85451602 L2.21371819,4.71751697 C2.09358688,4.4688745 2.19776577,4.16992428 2.44640824,4.04979297 C2.51423719,4.0170215 2.58859437,4 2.66392522,4 L14.6531336,4 C14.8352055,4 15.0028852,4.09897136 15.0908728,4.25837134 L18.3014808,10.0747713 L17.2348534,11.9595263 C16.9448961,11.7937237 16.6289403,11.6682038 16.2946119,11.5905925 L17.1558919,10.0686911 L14.3580134,5 L3.46079969,5 L5.59606705,9.41948207 C5.79749247,9.83638351 5.79509888,10.3229411 5.58958147,10.7378406 L3.47835228,15 L12,15 Z"
            fill="#414141"
            fillRule="nonzero"
          />
          <circle fill="#A6D960" fillRule="nonzero" cx="15.5" cy="15" r="2.5" />
        </g>
      </IconBase>
    )
  },
  party: (props: IconBaseProps) => (
    <IconBase {...props}>
      <svg
        width="16"
        height="20"
        viewBox="0 0 16 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_504_21834)">
          <path
            d="M2.45729 17.0852L10.0916 14.2395C10.3176 14.1597 10.5198 14.0243 10.6798 13.8459C10.8397 13.6674 10.9522 13.4515 11.0068 13.2182C11.0615 12.9848 11.0565 12.7415 10.9924 12.5105C10.9284 12.2796 10.8072 12.0685 10.6401 11.8967L5.85158 7.1081C5.67469 6.9423 5.4588 6.82386 5.22393 6.76373C4.98907 6.70361 4.74282 6.70376 4.50803 6.76417C4.27323 6.82458 4.05749 6.94329 3.8808 7.10929C3.70412 7.2753 3.5722 7.48324 3.49729 7.71381L0.663005 15.3481C0.584275 15.5954 0.576144 15.8598 0.639528 16.1115C0.702912 16.3632 0.835294 16.5922 1.02177 16.7728C1.20825 16.9533 1.44142 17.0782 1.69504 17.1334C1.94865 17.1886 2.21264 17.1719 2.45729 17.0852V17.0852Z"
            stroke="#42ABDC"
            strokeWidth="1.14286"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.6572 10.1481C13.1497 9.86485 12.5554 9.77937 11.9887 9.90806"
            stroke="#8FCE50"
            strokeWidth="1.14286"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.0516 6.89152C11.3753 6.40363 11.5094 5.81427 11.4288 5.23438"
            stroke="#F5C400"
            strokeWidth="1.14286"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.42314 2.82227C8.8237 4.04932 8.77099 5.37933 8.27457 6.57084"
            stroke="#E94D35"
            strokeWidth="1.14286"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.8573 6.31864C14.5417 6.31864 14.2859 6.0628 14.2859 5.74721C14.2859 5.43162 14.5417 5.17578 14.8573 5.17578C15.1729 5.17578 15.4287 5.43162 15.4287 5.74721C15.4287 6.0628 15.1729 6.31864 14.8573 6.31864Z"
            stroke="#42ABDC"
            strokeWidth="1.14286"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_504_21834">
            <rect
              width="16"
              height="16"
              fill="white"
              transform="matrix(-1 0 0 1 16 2)"
            />
          </clipPath>
        </defs>
      </svg>
    </IconBase>
  ),
  plus: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 3V21M3 12H21"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M8 2V14M2 8H14"
            stroke={props.color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </IconBase>
    )
  },
  dotMilestoneIncomplete: (props: IconBaseProps) => {
    return (
      <IconBase {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path
            d="M17.2348534,11.9595263 C16.9448961,11.7937237 16.6289403,11.6682038 16.2946119,11.5905925 L17.1558919,10.0686911 L14.6740611,5.57255811 L15.2380908,4.52507436 L18.3014808,10.0747713 L17.2348534,11.9595263 Z M12.1449393,16 L9.05928468,16 L9.59774622,15 L12,15 C12,15.3474863 12.0506388,15.6831453 12.1449393,16 Z M12.1135563,4 L11.5750947,5 L3.46079969,5 L5.59606705,9.41948207 C5.79749247,9.83638351 5.79509888,10.3229411 5.58958147,10.7378406 L3.47835228,15 L6.19047936,15 L5.65201782,16 L2.67270151,16 C2.39655913,16 2.17270151,15.7761424 2.17270151,15.5 C2.17270151,15.423008 2.19048175,15.347056 2.22465634,15.2780641 L4.69349114,10.2939689 C4.76199694,10.155669 4.76279481,9.99348317 4.695653,9.85451602 L2.21371819,4.71751697 C2.09358688,4.4688745 2.19776577,4.16992428 2.44640824,4.04979297 C2.51423719,4.0170215 2.58859437,4 2.66392522,4 L12.1135563,4 Z"
            fill="#414141"
            fillRule="nonzero"
          />
          <path
            d="M6.45514209,17.7169458 L14.3878533,2.80069227"
            stroke="#414141"
            strokeLinecap="round"
          />
          <circle fill="#FFA9A3" fillRule="nonzero" cx="15.5" cy="15" r="2.5" />
        </g>
      </IconBase>
    )
  },
  dotTask: (props: IconBaseProps) => {
    return (
      <IconBase {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path
            d="M12,15 C12,15.3474863 12.0506388,15.6831453 12.1449393,16 L3.36705074,16 C2.53862362,16 1.86705074,15.3284271 1.86705074,14.5 L1.86705074,5.5 C1.86705074,4.67157288 2.53862362,4 3.36705074,4 L16.8014808,4 C17.6299079,4 18.3014808,4.67157288 18.3014808,5.5 L18.3014808,12.9016311 C18.0301489,12.539962 17.690416,12.2325547 17.3014808,11.9986078 L17.3014808,5.5 C17.3014808,5.22385763 17.0776232,5 16.8014808,5 L3.36705074,5 C3.09090837,5 2.86705074,5.22385763 2.86705074,5.5 L2.86705074,14.5 C2.86705074,14.7761424 3.09090837,15 3.36705074,15 L12,15 Z"
            fill="#414141"
            fillRule="nonzero"
          />
          <circle
            stroke="#414141"
            strokeWidth="0.5"
            fillRule="nonzero"
            cx="5.5"
            cy="12.5"
            r="1.25"
          />
          <path
            d="M4.5,6.5 L15.5,6.5"
            stroke="#414141"
            strokeLinecap="round"
            fillRule="nonzero"
          />
          <circle fill="#A6D960" fillRule="nonzero" cx="15.5" cy="15" r="2.5" />
        </g>
      </IconBase>
    )
  },
  dotTaskIncomplete: (props: IconBaseProps) => (
    <IconBase {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M11.0366332,6 L10.4981717,7 L4.5,7 C4.22385763,7 4,6.77614237 4,6.5 C4,6.22385763 4.22385763,6 4.5,6 L11.0366332,6 Z M14.4439001,6 L15.5,6 C15.7761424,6 16,6.22385763 16,6.5 C16,6.77614237 15.7761424,7 15.5,7 L13.9054385,7 L14.4439001,6 Z"
          fill={props.color || 'currentColor'}
          fillRule="nonzero"
        />
        <path
          d="M12,15 C12,15.3474863 12.0506388,15.6831453 12.1449393,16 L9.05928468,16 L9.59774622,15 L12,15 Z M17.3014808,11.9986078 L17.3014808,5.5 C17.3014808,5.22385763 17.0776232,5 16.8014808,5 L14.9823616,5 L15.5208231,4 L16.8014808,4 C17.6299079,4 18.3014808,4.67157288 18.3014808,5.5 L18.3014808,12.9016311 C18.0301489,12.539962 17.690416,12.2325547 17.3014808,11.9986078 Z M6.19047936,15 L5.65201782,16 L3.36705074,16 C2.53862362,16 1.86705074,15.3284271 1.86705074,14.5 L1.86705074,5.5 C1.86705074,4.67157288 2.53862362,4 3.36705074,4 L12.1135563,4 L11.5750947,5 L3.36705074,5 C3.09090837,5 2.86705074,5.22385763 2.86705074,5.5 L2.86705074,14.5 C2.86705074,14.7761424 3.09090837,15 3.36705074,15 L6.19047936,15 Z"
          fill={props.color || 'currentColor'}
          fillRule="nonzero"
        />
        <circle
          stroke={props.color || 'currentColor'}
          strokeWidth="0.5"
          fillRule="nonzero"
          cx="5.5"
          cy="12.5"
          r="1.25"
        />
        <path
          d="M6.45514209,17.7169458 L14.3878533,2.80069227"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
        />
        <circle fill="#FFA9A3" fillRule="nonzero" cx="15.5" cy="15" r="2.5" />
      </g>
    </IconBase>
  ),
  dotTaskGroup: (props: IconBaseProps) => (
    <IconBase {...omit(props, 'viewBox')} viewBox="0 0 20 20">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.4918 3.5C3.94405 3.5 3.5 3.94405 3.5 4.4918V15.5082C3.5 16.056 3.94405 16.5 4.4918 16.5H12.3368C12.5149 16.8748 12.7576 17.2129 13.0505 17.5H4.4918C3.39176 17.5 2.5 16.6082 2.5 15.5082V4.4918C2.5 3.39176 3.39176 2.5 4.4918 2.5H15.5082C16.6082 2.5 17.5 3.39176 17.5 4.4918V12.1273C17.198 11.9167 16.8612 11.7524 16.5 11.6449V4.4918C16.5 3.94405 16.056 3.5 15.5082 3.5H4.4918ZM15.5 11.5V11.4C15.5 10.8657 15.0414 10.5 14.565 10.5H5.435C4.95859 10.5 4.5 10.8657 4.5 11.4V14.6C4.5 15.1343 4.95859 15.5 5.435 15.5H12.0354C12.0121 15.3367 12 15.1698 12 15C12 14.8302 12.0121 14.6633 12.0354 14.5H5.5V11.5H14.5V11.6449C14.8169 11.5506 15.1525 11.5 15.5 11.5ZM5.5 5.5V8.5H14.5V5.5H5.5ZM4.5 8.59997V5.4C4.5 4.86574 4.95859 4.5 5.435 4.5H14.565C15.0414 4.5 15.5 4.86574 15.5 5.4V8.6C15.5 9.13427 15.0414 9.5 14.565 9.5H5.435C4.95859 9.5 4.5 9.13423 4.5 8.59997Z"
          fill={props.color || '#414141'}
        />
        <path
          d="M15.5 17.5C16.8807 17.5 18 16.3807 18 15C18 13.6193 16.8807 12.5 15.5 12.5C14.1193 12.5 13 13.6193 13 15C13 16.3807 14.1193 17.5 15.5 17.5Z"
          fill="#A6D960"
        />
      </svg>
    </IconBase>
  ),
  dotTaskGroupIncomplete: (props: IconBaseProps) => (
    <IconBase {...omit(props, 'viewBox')}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.5 17.5C16.8807 17.5 18 16.3807 18 15C18 13.6193 16.8807 12.5 15.5 12.5C14.1193 12.5 13 13.6193 13 15C13 16.3807 14.1193 17.5 15.5 17.5Z"
          fill="#F3ADA6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.34207 19.013L15.7538 1.36597L14.8715 0.895386L14.0157 2.50003H14.0156L13.4823 3.50003H13.4824L12.949 4.50003H12.9489L12.4156 5.50003H12.4157L10.8157 8.50003H10.8156L10.2823 9.50003H10.2824L9.74902 10.5H9.74892L9.21559 11.5H9.21568L7.61568 14.5H7.61559L7.08225 15.5H7.08235L6.54902 16.5H6.54892L6.01559 17.5H6.01569L5.45972 18.5424L6.34207 19.013ZM4.4918 17.5H4.88225L5.41559 16.5H4.4918C3.94405 16.5 3.5 16.056 3.5 15.5082V4.49183C3.5 3.94407 3.94405 3.50003 4.4918 3.50003H12.3489L12.8823 2.50003H4.4918C3.39176 2.50003 2.5 3.39179 2.5 4.49183V15.5082C2.5 16.6083 3.39176 17.5 4.4918 17.5ZM5.435 4.50003H11.8156L11.2823 5.50003H5.5V8.50003H9.68225L9.14892 9.50003H5.435C4.95859 9.50003 4.5 9.13426 4.5 8.59999V5.40003C4.5 4.86576 4.95859 4.50003 5.435 4.50003ZM12.5489 9.50003L13.0823 8.50003H14.5V5.84175L15.121 4.6774C15.3447 4.8353 15.5 5.08913 15.5 5.40003V8.60003C15.5 9.13429 15.0414 9.50003 14.565 9.50003H12.5489ZM16.5 4.49183C16.5 4.02211 16.1735 3.62866 15.735 3.52608L16.2137 2.62858C16.9655 2.9134 17.5 3.6402 17.5 4.49183V12.1274C17.198 11.9167 16.8612 11.7525 16.5 11.645V4.49183ZM12.0156 10.5L11.4823 11.5H14.5V11.645C14.8169 11.5507 15.1525 11.5 15.5 11.5V11.4C15.5 10.8658 15.0414 10.5 14.565 10.5H12.0156ZM9.88225 14.5L9.34892 15.5H12.0354C12.0121 15.3367 12 15.1698 12 15C12 14.8303 12.0121 14.6633 12.0354 14.5H9.88225ZM8.81559 16.5L8.28225 17.5H13.0505C12.7576 17.213 12.5149 16.8748 12.3368 16.5H8.81559ZM5.435 15.5H5.94892L6.48225 14.5H5.5V11.5H8.08225L8.61559 10.5H5.435C4.95859 10.5 4.5 10.8658 4.5 11.4V14.6C4.5 15.1343 4.95859 15.5 5.435 15.5Z"
          fill={props.color || '#414141'}
        />
      </svg>
    </IconBase>
  ),
  taskCard: (props: IconBaseProps) => (
    <IconBase {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M 3.2324219 4 C 2.4039949 4 1.7324219 4.671572 1.7324219 5.5 L 1.7324219 12.902344 L 1.7324219 14.5 C 1.7324219 15.328427 2.4039948 16 3.2324219 16 L 7.8886719 16 L 12.011719 16 L 16.667969 16 C 17.496396 16 18.167969 15.328427 18.167969 14.5 L 18.167969 12.902344 L 18.167969 5.5 C 18.167969 4.671572 17.496396 4 16.667969 4 L 3.2324219 4 z M 3.2324219 5 L 16.667969 5 C 16.944111 5 17.167969 5.223857 17.167969 5.5 L 17.167969 11.998047 L 17.167969 14.5 C 17.167969 14.776142 16.944111 15 16.667969 15 L 11.865234 15 L 8.0351562 15 L 3.2324219 15 C 2.9562796 15 2.7324219 14.776142 2.7324219 14.5 L 2.7324219 11.998047 L 2.7324219 5.5 C 2.7324219 5.4309644 2.746183 5.3645067 2.7714844 5.3046875 C 2.8473886 5.1252299 3.0253154 5 3.2324219 5 z "
          fill="#414141"
          fillRule="nonzero"
        />
        <circle
          stroke="#414141"
          strokeWidth="0.5"
          fillRule="nonzero"
          cx="5.5"
          cy="12.5"
          r="1.25"
        />
        <path
          d="M4.5,6.5 L15.5,6.5"
          stroke="#414141"
          strokeLinecap="round"
          fillRule="nonzero"
        />
      </g>
    </IconBase>
  ),
  dotTemplate: (props: IconBaseProps) => (
    <IconBase {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M12.1449393,16 C12.2524429,16.3612174 12.4166903,16.6979964 12.6273446,17 L3.46034879,17 C2.65382042,17 2,16.2164983 2,15.25 L2,4.75 C2,3.78350169 2.65382042,3 3.46034879,3 L13.9957032,3 L14.9957032,4 L3.4849516,4 C3.21712023,4 3,4.26862915 3,4.6 L3,15.4 C3,15.7313708 3.21712023,16 3.4849516,16 L12.1449393,16 Z M17,11.8368156 L17,6.0042968 L18,7.0042968 L18,12.5505086 C17.7129397,12.2575665 17.3748024,12.0148648 17,11.8368156 Z"
          fill="#414141"
          fillRule="nonzero"
        />
        <path
          d="M14,7 L16.5964948,7 L15.3240547,5.70791749 L14,4.39444743 L14,7 Z M13,3 L14.0142133,3 L16.0241794,4.99382513 C16.0283293,4.99794167 16.0324551,5.00208244 16.0365565,5.00624722 L18,7 L18,8 L13,8 L13,3 Z"
          fill="#414141"
          fillRule="nonzero"
        />
        <circle fill="#A6D960" fillRule="nonzero" cx="15.5" cy="15" r="2.5" />
      </g>
    </IconBase>
  ),
  dotTemplateIncomplete: (props: IconBaseProps) => (
    <IconBase {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M8.52082314,17 L9.05928468,16 L12.1449393,16 C12.2524429,16.3612174 12.4166903,16.6979964 12.6273446,17 L8.52082314,17 Z M5.11355628,17 L3.46034879,17 C2.65382042,17 2,16.2164983 2,15.25 L2,4.75 C2,3.78350169 2.65382042,3 3.46034879,3 L12.6520178,3 L12.1135563,4 L3.4849516,4 C3.21712023,4 3,4.26862915 3,4.6 L3,15.4 C3,15.7313708 3.21712023,16 3.4849516,16 L5.65201782,16 L5.11355628,17 Z M17,11.8368156 L17,6.0042968 L18,7.0042968 L18,12.5505086 C17.7129397,12.2575665 17.3748024,12.0148648 17,11.8368156 Z"
          fill="#414141"
          fillRule="nonzero"
        />
        <circle fill="#FFA9A3" fillRule="nonzero" cx="15.5" cy="15" r="2.5" />
        <path
          d="M6.45514209,17.7169458 L14.3878533,2.80069227"
          stroke="#414141"
          strokeLinecap="round"
        />
        <polygon
          stroke="#414141"
          strokeLinecap="square"
          fillRule="nonzero"
          points="14.1398289 7.52887468 15.4730673 5.12321732 17.4752668 7.16156191 17.4752668 7.52887468"
        />
      </g>
    </IconBase>
  ),
  dependency: (props: IconBaseProps) => (
    <IconBase {...props}>
      <g fill="none" fillRule="evenodd">
        <circle cx="4" cy="4" r="3" stroke="#414141" />
        <circle cx="16" cy="16" r="3" stroke="#414141" />
        <polyline
          stroke="#414141"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="4 7 4 10 8.379 10 16 10 16 13"
        />
      </g>
    </IconBase>
  ),
  dependencyComplete: (props: IconBaseProps) => (
    <IconBase {...props}>
      <g fill="none" fillRule="evenodd">
        <circle
          cx="4"
          cy="4"
          r="3"
          fill="#414141"
          fillRule="nonzero"
          stroke="#414141"
        />
        <circle cx="16" cy="16" r="3" stroke="#414141" />
        <polyline
          stroke="#414141"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="4 7 4 10 8.379 10 16 10 16 13"
        />
      </g>
    </IconBase>
  ),
  paper: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 20V13C21 10.7909 19.2091 9 17 9H14.9211C14.0926 9 13.4211 8.32843 13.4211 7.5V5C13.4211 2.79086 11.6302 1 9.42105 1H6M21 20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V4C3 2.34315 4.34315 1 6 1M21 20V13.2847C21 11.1633 20.2507 9.11015 18.8842 7.48749L16.1181 4.20278C14.4081 2.1721 11.8887 1 9.23393 1H6"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <g
          fill="none"
          fillRule="evenodd"
          stroke={props.color || 'currentColor'}
          strokeLinejoin="round"
          transform="translate(3 1.5)"
        >
          <path d="M13.1363636,17 L0.772727273,17 C0.345961823,17 0,16.6540378 0,16.2272727 L0,0.772727273 C0,0.345961823 0.345961823,0 0.772727273,0 L9.27273245,0 L13.9090909,4.63636364 L13.9090909,16.2272727 C13.9090909,16.6540378 13.5631287,17 13.1363636,17 Z" />
          <polyline points="9.273 .386 9.273 4.636 13.909 4.636" />
        </g>
      </IconBase>
    )
  },
  paperclip: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.654 8.11147L8.05436 14.7111C8.05436 14.7111 4.99023 17.7753 2.1618 14.9468C-0.666626 12.1184 2.3975 9.05428 2.3975 9.05428L9.23287 2.21891C9.23287 2.21891 11.1185 0.333296 13.0041 2.21891C14.8897 4.10453 13.0041 5.99015 13.0041 5.99015L6.40444 12.5898C6.40444 12.5898 5.46163 13.5326 4.51882 12.5898C3.57601 11.647 4.51882 10.7042 4.51882 10.7042L10.6471 4.57594"
              stroke={props.color || 'currentColor'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <path
          fill={props.color || 'currentColor'}
          d="M7.88277685,14.8302227 L15.199228,7.51377153 C15.9493052,6.7636935 15.9493052,5.5475776 15.1992281,4.79750002 C14.4507123,4.04898475 13.2376865,4.04719445 12.4869669,4.79349637 L3.82777429,13.4107545 C2.72623332,14.5061591 2.72374493,16.2880551 3.82231252,17.3866217 C4.91871645,18.4830264 6.6963345,18.4830278 7.79273654,17.3866256 L16.9273201,8.25204199 C18.35756,6.82180182 18.35756,4.50292439 16.9273202,3.0726842 C15.4970759,1.64244017 13.1781988,1.64243858 11.7479581,3.07267956 L3.5877995,11.2328379 C3.45158603,11.3690513 3.45158603,11.589897 3.58779949,11.7261105 C3.72401296,11.8623239 3.94485863,11.8623239 4.0810721,11.7261105 L12.2412308,3.56595215 C13.3990443,2.40813829 15.2762301,2.40813957 16.4340475,3.5659568 C17.5918604,4.72377 17.5918604,6.60095619 16.4340475,7.75876941 L7.29946391,16.893353 C6.47548899,17.7173281 5.13956244,17.717327 4.31558511,16.8933491 C3.48998271,16.0677474 3.4918528,14.7286058 4.31975768,13.905313 L12.9789112,5.28809364 C13.4568415,4.81297582 14.2292984,4.81411589 14.7059555,5.29077265 C15.1836058,5.76842318 15.1836058,6.54284806 14.7059553,7.02049905 L7.38950424,14.3369501 C7.25329077,14.4731636 7.25329077,14.6940092 7.38950424,14.8302227 C7.52571771,14.9664362 7.74656338,14.9664362 7.88277685,14.8302227 Z"
        />
      </IconBase>
    )
  },
  pencil: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.999 1.79989L16.5845 0.889831L16.4199 0.964831L16.2919 1.09278L16.999 1.79989ZM22.6559 7.45674L23.363 8.16385L23.4909 8.0359L23.5659 7.87123L22.6559 7.45674ZM8.25661 21.856L8.37576 22.8489L8.71916 22.8077L8.96372 22.5631L8.25661 21.856ZM1.82837 22.6274L0.835492 22.5083L0.683853 23.7719L1.94751 23.6203L1.82837 22.6274ZM2.59976 16.1992L1.89265 15.492L1.64809 15.7366L1.60688 16.08L2.59976 16.1992ZM16.999 1.79989C17.4135 2.70995 17.413 2.71016 17.4126 2.71036C17.4125 2.71042 17.412 2.71062 17.4117 2.71075C17.4112 2.711 17.4107 2.71123 17.4102 2.71145C17.4092 2.71188 17.4084 2.71225 17.4077 2.71255C17.4064 2.71316 17.4056 2.71351 17.4053 2.71363C17.4048 2.71386 17.4064 2.71314 17.4101 2.71159C17.4176 2.7085 17.4333 2.70214 17.4567 2.6935C17.5035 2.67617 17.5798 2.65006 17.6806 2.62276C17.8838 2.56772 18.1758 2.51066 18.5189 2.50593C19.185 2.49674 20.0654 2.68064 20.9203 3.53551L22.3345 2.1213C21.0343 0.821179 19.6006 0.490821 18.4913 0.506122C17.9466 0.513634 17.4856 0.603509 17.1577 0.692337C16.9929 0.736972 16.8592 0.782031 16.7624 0.817886C16.7138 0.835843 16.6743 0.851582 16.6445 0.863935C16.6296 0.870115 16.6171 0.875457 16.6071 0.879818C16.6021 0.881999 16.5977 0.883936 16.5939 0.88561C16.592 0.886448 16.5903 0.887219 16.5888 0.887924C16.588 0.888276 16.5872 0.888611 16.5865 0.888929C16.5862 0.889088 16.5857 0.889313 16.5855 0.889393C16.585 0.889614 16.5845 0.889831 16.999 1.79989ZM20.9203 3.53551C21.7751 4.39038 21.959 5.27078 21.9498 5.93691C21.9451 6.27993 21.888 6.57196 21.833 6.77514C21.8057 6.87592 21.7796 6.95229 21.7623 6.99911C21.7536 7.02244 21.7473 7.03816 21.7442 7.04563C21.7426 7.04936 21.7419 7.051 21.7421 7.05048C21.7423 7.05021 21.7426 7.0494 21.7432 7.04804C21.7435 7.04735 21.7439 7.04653 21.7443 7.04557C21.7445 7.04509 21.7448 7.04457 21.745 7.04402C21.7451 7.04375 21.7453 7.04331 21.7454 7.04317C21.7456 7.04272 21.7458 7.04226 22.6559 7.45674C23.5659 7.87123 23.5662 7.87075 23.5664 7.87026C23.5665 7.87009 23.5667 7.86959 23.5668 7.86924C23.5672 7.86854 23.5675 7.86779 23.5678 7.86701C23.5685 7.86545 23.5693 7.86373 23.5702 7.86185C23.5718 7.85809 23.5738 7.8537 23.5759 7.84869C23.5803 7.83867 23.5857 7.82616 23.5918 7.81125C23.6042 7.78143 23.6199 7.74192 23.6379 7.69341C23.6737 7.59655 23.7188 7.46285 23.7634 7.29808C23.8523 6.97017 23.9421 6.50918 23.9496 5.96449C23.9649 4.8552 23.6346 3.42142 22.3345 2.1213L20.9203 3.53551ZM21.9488 6.74964L7.54951 21.1489L8.96372 22.5631L23.363 8.16385L21.9488 6.74964ZM8.13747 20.8631L1.70922 21.6345L1.94751 23.6203L8.37576 22.8489L8.13747 20.8631ZM2.82125 22.7465L3.59264 16.3183L1.60688 16.08L0.835492 22.5083L2.82125 22.7465ZM3.30687 16.9063L17.7061 2.507L16.2919 1.09278L1.89265 15.492L3.30687 16.9063ZM13.5601 5.2387L18.9476 10.6262L20.3618 9.21197L14.9743 3.82449L13.5601 5.2387Z"
              fill={props.color || 'currentColor'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <path
          fill={props.color || 'currentColor'}
          d="M19.104 0.896c-0.562-0.562-1.309-0.871-2.104-0.871s-1.542 0.309-2.104 0.871l-12.75 12.75c-0.052 0.052-0.091 0.114-0.116 0.183l-2 5.5c-0.066 0.183-0.021 0.387 0.116 0.524 0.095 0.095 0.223 0.146 0.354 0.146 0.057 0 0.115-0.010 0.171-0.030l5.5-2c0.069-0.025 0.131-0.065 0.183-0.116l12.75-12.75c0.562-0.562 0.871-1.309 0.871-2.104s-0.309-1.542-0.871-2.104zM5.725 17.068l-4.389 1.596 1.596-4.389 11.068-11.068 2.793 2.793-11.068 11.068zM18.396 4.396l-0.896 0.896-2.793-2.793 0.896-0.896c0.373-0.373 0.869-0.578 1.396-0.578s1.023 0.205 1.396 0.578c0.373 0.373 0.578 0.869 0.578 1.396s-0.205 1.023-0.578 1.396z"
        />
      </IconBase>
    )
  },
  chat: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.33337 15.6666C12.1994 15.6666 15.3334 12.5326 15.3334 8.66663C15.3334 4.80063 12.1994 1.66663 8.33337 1.66663C4.46738 1.66663 1.33337 4.80063 1.33337 8.66663C1.33337 9.97231 1.69086 11.1945 2.31329 12.2407L1.33337 15.6666L4.84368 14.7361C5.87096 15.328 7.06262 15.6666 8.33337 15.6666Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="1.5"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <path
          fill="none"
          stroke={props.color || 'currentColor'}
          d="M3,15.6906977 C3,15.6906977 6.28139535,16.3627907 7.46744186,15.2953488 C8.3372093,15.7302326 9.28604651,15.9674419 10.3534884,15.9674419 C13.9116279,15.9674419 16.8372093,13.0418605 16.8372093,9.48372093 C16.8372093,5.88604651 13.9511628,3 10.3534884,3 C6.79534884,3 3.86976744,5.9255814 3.86976744,9.48372093 C3.86976744,10.4325581 4.06744186,11.3813953 4.4627907,12.172093 C4.4627907,12.172093 4.81860465,13.9116279 3,15.6906977 Z"
        />
      </IconBase>
    )
  },
  projects: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5 2C5 0.89543 5.89543 0 7 0H17C18.1046 0 19 0.895431 19 2V3C20.1046 3 21 3.89543 21 5V6V7H22C23.1046 7 24 7.89543 24 9V22C24 23.1046 23.1046 24 22 24H2C0.895431 24 0 23.1046 0 22V9C0 7.89543 0.895431 7 2 7H3V6V5C3 3.89543 3.89543 3 5 3V2ZM5 7H19V6V5H17H7H5V6V7ZM19 9H5H2V22H22V9H19ZM17 2V3H7V2H17Z"
              fill={props.color || 'currentColor'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <g fill="none" fillRule="evenodd" transform="translate(1.5 1.5)">
          <rect
            width="17"
            height="3.643"
            stroke={props.color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fill={props.color || 'currentColor'}
            fillRule="nonzero"
            d="M15.2859532,3.62740062 L14.9216675,15.405972 C14.8931826,16.0314819 14.4162981,16.5 13.802381,16.5 L3.19761905,16.5 C2.58370187,16.5 2.10681739,16.0314819 2.0780557,15.3987247 L1.71404675,3.62740062 C1.70551035,3.35139022 1.47483959,3.1345597 1.19882919,3.1430961 C0.922818787,3.15163251 0.705988271,3.38230327 0.714524676,3.65831367 L1.07881039,15.4368851 C1.13185222,16.6049638 2.04287126,17.5 3.19761905,17.5 L13.802381,17.5 C14.9571287,17.5 15.8681478,16.6049638 15.9209128,15.4441324 L16.2854753,3.65831367 C16.2940117,3.38230327 16.0771812,3.15163251 15.8011708,3.1430961 C15.5251604,3.1345597 15.2944897,3.35139022 15.2859532,3.62740062 Z"
          />
          <path
            fill={props.color || 'currentColor'}
            d="M11.5357143,7.28190474 L5.46428571,7.28190474 C4.89761905,7.28190474 4.45238095,6.83750475 4.45238095,6.27190475 C4.45238095,5.70630476 4.89761905,5.26190476 5.46428571,5.26190476 L11.5357143,5.26190476 C12.102381,5.26190476 12.547619,5.70630476 12.547619,6.27190475 C12.547619,6.83750475 12.102381,7.28190474 11.5357143,7.28190474 Z"
          />
        </g>
      </IconBase>
    )
  },
  schedule: (props: IconBaseProps) => (
    <IconBase {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <circle
          stroke={props.color || 'currentColor'}
          strokeWidth="2"
          fillRule="nonzero"
          cx="10"
          cy="10"
          r="6"
        />
        <polyline
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          fillRule="nonzero"
          points="10 7 10 10 12 10.955813"
        />
      </g>
    </IconBase>
  ),
  search: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 14L12 12M13.3333 7.33331C13.3333 10.647 10.647 13.3333 7.33334 13.3333C4.01963 13.3333 1.33334 10.647 1.33334 7.33331C1.33334 4.0196 4.01963 1.33331 7.33334 1.33331C10.647 1.33331 13.3333 4.0196 13.3333 7.33331Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props} viewBox="0 0 24 24">
        <path
          d="M23.5 24C23.366 24 23.241 23.948 23.146 23.854L14.142 14.85C12.582 16.238 10.588 17 8.5 17C3.813 17 0 13.187 0 8.5C0 3.813 3.813 0 8.5 0C13.187 0 17 3.813 17 8.5C17 10.588 16.238 12.582 14.849 14.142L23.853 23.146C23.948 23.241 24 23.366 24 23.5C24 23.634 23.948 23.759 23.854 23.854C23.76 23.949 23.634 24 23.5 24ZM8.5 1C4.365 1 1 4.365 1 8.5C1 12.635 4.365 16 8.5 16C12.635 16 16 12.635 16 8.5C16 4.365 12.635 1 8.5 1Z"
          fill={props.color || 'currentColor'}
        />
      </IconBase>
    )
  },
  settingsIcon: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="26"
            height="26"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17 12.9997C17 15.2088 15.2091 16.9997 13 16.9997C10.7909 16.9997 9 15.2088 9 12.9997C9 10.7905 10.7909 8.99967 13 8.99967C15.2091 8.99967 17 10.7905 17 12.9997Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
            />
            <path
              d="M11.2844 2.8626C12.061 1.56663 13.939 1.56663 14.7156 2.8626L15.4213 4.04037C15.8742 4.79616 16.7684 5.16653 17.6231 4.95235L18.9549 4.61859C20.4204 4.25134 21.7483 5.57925 21.3811 7.04477L21.0473 8.37662C20.8331 9.2313 21.2035 10.1255 21.9593 10.5783L23.1371 11.2841C24.433 12.0607 24.433 13.9386 23.1371 14.7152L21.9593 15.421C21.2035 15.8739 20.8331 16.768 21.0473 17.6227L21.3811 18.9546C21.7483 20.4201 20.4204 21.748 18.9549 21.3808L17.623 21.047C16.7684 20.8328 15.8742 21.2032 15.4213 21.959L14.7156 23.1367C13.939 24.4327 12.061 24.4327 11.2844 23.1367L10.5787 21.959C10.1258 21.2032 9.23162 20.8328 8.37695 21.047L7.04509 21.3808C5.57958 21.748 4.25166 20.4201 4.61892 18.9546L4.95268 17.6227C5.16686 16.768 4.79649 15.8739 4.04069 15.421L2.86293 14.7152C1.56696 13.9386 1.56696 12.0607 2.86293 11.2841L4.0407 10.5783C4.79649 10.1255 5.16686 9.2313 4.95268 8.37662L4.61892 7.04477C4.25166 5.57925 5.57958 4.25134 7.0451 4.61859L8.37695 4.95235C9.23162 5.16653 10.1258 4.79616 10.5787 4.04037L11.2844 2.8626Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props} viewBox="0 0 20 20">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9414 6.40975C15.7705 6.76901 15.7598 7.18389 15.9121 7.55145C16.0644 7.91901 16.3653 8.20483 16.7402 8.338L17.6889 8.6755C18.2499 8.87462 18.6248 9.40543 18.6248 10.0007C18.6248 10.5961 18.2499 11.1269 17.6889 11.326L16.7402 11.6635C16.3653 11.7967 16.0644 12.0825 15.9121 12.45C15.7598 12.8176 15.7705 13.2325 15.9414 13.5917L16.3749 14.5C16.6317 15.0378 16.5217 15.679 16.1003 16.1004C15.6789 16.5218 15.0377 16.6318 14.4999 16.375L13.5902 15.943C13.2309 15.7721 12.816 15.7614 12.4485 15.9137C12.0809 16.0659 11.7951 16.3668 11.6619 16.7417L11.3244 17.6905C11.125 18.251 10.5944 18.6253 9.99954 18.6253C9.40463 18.6253 8.8741 18.251 8.67466 17.6905L8.33716 16.7417C8.20383 16.3668 7.91787 16.0659 7.55019 15.9136C7.18251 15.7614 6.76753 15.7721 6.40816 15.943L5.49991 16.375C4.96212 16.6328 4.32016 16.5232 3.89843 16.1015C3.47671 15.6797 3.36707 15.0378 3.62491 14.5L4.05691 13.5902C4.22783 13.231 4.23849 12.8161 4.08623 12.4485C3.93397 12.081 3.63307 11.7952 3.25816 11.662L2.30941 11.3245C1.74839 11.1254 1.37354 10.5946 1.37354 9.99925C1.37354 9.40393 1.74839 8.87312 2.30941 8.674L3.25816 8.3365C3.63266 8.20328 3.93325 7.91771 4.08547 7.55052C4.23769 7.18333 4.22732 6.76886 4.05691 6.40975L3.62491 5.5C3.36707 4.96221 3.47671 4.32024 3.89843 3.89852C4.32016 3.4768 4.96212 3.36715 5.49991 3.625L6.40966 4.057C6.76869 4.22748 7.18309 4.23808 7.55036 4.08617C7.91762 3.93426 8.20346 3.63403 8.33716 3.25975L8.67466 2.311C8.8741 1.75052 9.40463 1.37617 9.99954 1.37617C10.5944 1.37617 11.125 1.75052 11.3244 2.311L11.6619 3.25975C11.7951 3.63465 12.0809 3.93555 12.4485 4.08781C12.816 4.24007 13.2309 4.22942 13.5902 4.0585L14.4999 3.625C15.0377 3.36816 15.6789 3.47819 16.1003 3.89958C16.5217 4.32098 16.6317 4.96223 16.3749 5.5L15.9414 6.40975Z"
          stroke={props.color || '#8F8F8F'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.99927 13.3757C11.8632 13.3757 13.3743 11.8647 13.3743 10.0007C13.3743 8.13679 11.8632 6.62575 9.99927 6.62575C8.13531 6.62575 6.62427 8.13679 6.62427 10.0007C6.62427 11.8647 8.13531 13.3757 9.99927 13.3757Z"
          stroke="#8F8F8F"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </IconBase>
    )
  },
  send: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['fill', 'viewBox'])}
      viewBox="0 0 24 24"
      fill={props.color || 'currentColor'}
    >
      <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </IconBase>
  ),
  star: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M7.53864 1.77199C7.70973 1.36214 8.29037 1.36214 8.46146 1.77198L9.92917 5.28791C9.99755 5.4517 10.1476 5.56697 10.3235 5.59078L14.1918 6.11433C14.6252 6.17299 14.7797 6.72065 14.4408 6.9972L11.454 9.43455C11.3063 9.55504 11.24 9.74899 11.283 9.93466L12.2379 14.0612C12.3413 14.508 11.8389 14.8467 11.4636 14.5832L8.28729 12.3539C8.1149 12.233 7.88519 12.233 7.71281 12.3539L4.53651 14.5833C4.16116 14.8467 3.65876 14.508 3.76214 14.0613L4.71702 9.93465C4.75998 9.74899 4.69366 9.55504 4.54601 9.43455L1.55925 6.99719C1.22036 6.72065 1.37486 6.17299 1.80831 6.11433L5.67657 5.59078C5.85246 5.56697 6.00255 5.4517 6.07092 5.28791L7.53864 1.77199Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="1.5"
              strokeMiterlimit="3.3292"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase
        {...omit(props, ['fill', 'viewBox'])}
        viewBox="0 0 24 24"
        fill={props.color || 'currentColor'}
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon
            fill={props.color || 'currentColor'}
            points="10 16.1028369 4.4376941 18.8021698 5.5 13.0848911 1 9.03589177 7.21884705 8.20175204 10 3 12.7811529 8.20175204 19 9.03589177 14.5 13.0848911 15.5623059 18.8021698"
          />
        </g>
      </IconBase>
    )
  },
  upload: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.9821 4.47818L14.1165 4.97891C14.2952 5.2879 14.6251 5.47818 14.9821 5.47818V4.47818ZM1.55132 12.3162C1.72596 12.8402 2.29228 13.1233 2.81623 12.9487C3.34017 12.774 3.62333 12.2077 3.44868 11.6838L1.55132 12.3162ZM20.1056 11.5528C19.8586 12.0468 20.0588 12.6474 20.5528 12.8944C21.0468 13.1414 21.6474 12.9412 21.8944 12.4472L20.1056 11.5528ZM14.8905 15.3899C15.289 15.7723 15.922 15.7593 16.3044 15.3608C16.6868 14.9623 16.6738 14.3292 16.2753 13.9469L14.8905 15.3899ZM11.4996 10.7501L12.1919 10.0286C11.805 9.65728 11.1941 9.65728 10.8072 10.0286L11.4996 10.7501ZM6.72384 13.9469C6.32535 14.3292 6.31229 14.9623 6.69468 15.3608C7.07707 15.7593 7.7101 15.7723 8.10859 15.3899L6.72384 13.9469ZM12.4995 11.7807C12.4995 11.2284 12.0518 10.7807 11.4995 10.7807C10.9472 10.7807 10.4995 11.2284 10.4995 11.7807H12.4995ZM10.4995 22.7807C10.4995 23.333 10.9472 23.7807 11.4995 23.7807C12.0518 23.7807 12.4995 23.333 12.4995 22.7807H10.4995ZM8.95636 2C11.1598 2 13.0851 3.19594 14.1165 4.97891L15.8477 3.97746C14.4735 1.6019 11.9026 0 8.95636 0V2ZM3 7.95636C3 4.99673 5.6999 2 8.95636 2V0C4.52904 0 1 3.95964 1 7.95636H3ZM3.44868 11.6838C3.00632 10.3567 3 9.00917 3 7.95636H1C1 8.99083 0.993675 10.6433 1.55132 12.3162L3.44868 11.6838ZM20.5 9C20.5 10.0252 20.4854 10.7931 20.1056 11.5528L21.8944 12.4472C22.5146 11.2069 22.5 9.97482 22.5 9H20.5ZM15.9127 5.47818C17.1287 5.47818 18.3073 5.90795 19.1675 6.58664C20.0288 7.26624 20.5 8.13034 20.5 9H22.5C22.5 7.36966 21.6183 5.97285 20.4063 5.01654C19.1932 4.05932 17.5781 3.47818 15.9127 3.47818V5.47818ZM14.9821 5.47818H15.9127V3.47818H14.9821V5.47818ZM16.2753 13.9469L12.1919 10.0286L10.8072 11.4716L14.8905 15.3899L16.2753 13.9469ZM10.8072 10.0286L6.72384 13.9469L8.10859 15.3899L12.1919 11.4716L10.8072 10.0286ZM10.4995 11.7807V22.7807H12.4995V11.7807H10.4995Z"
              fill={props.color || 'currentColor'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <g
          fill="none"
          fillRule="evenodd"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          transform="translate(1 2)"
        >
          <g transform="translate(6 6)">
            <polyline points=".404 2.829 2.984 .257 5.563 2.829" />
            <path d="M2.98355632,0.257142857 L2.98355632,9" />
          </g>
          <path d="M14.673913,5.69052866 C14.4466871,5.69052866 14.2249066,5.71291937 14.0104821,5.75501483 C14.0570785,5.48674309 14.0869565,5.21291417 14.0869565,4.9317915 C14.0869565,2.20804367 11.8094429,0 9,0 C6.19055707,0 3.91304348,2.20804367 3.91304348,4.9317915 C3.91304348,5.21291417 3.94292152,5.48674309 3.98951789,5.75501483 C3.7750934,5.71291937 3.55331289,5.69052866 3.32608696,5.69052866 C1.489149,5.69052866 0,7.13423171 0,8.91516157 C0,10.6960683 1.489149,12.1397945 3.32608696,12.1397945 C5.03104567,12.1397945 12.9689543,12.1397945 14.673913,12.1397945 C16.510851,12.1397945 18,10.6960683 18,8.91516157 C18,7.13423171 16.510851,5.69052866 14.673913,5.69052866 Z" />
        </g>
      </IconBase>
    )
  },
  upload32: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="32"
            height="32"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.9761 5.97083L18.8941 6.59674C19.1175 6.98298 19.5299 7.22083 19.9761 7.22083V5.97083ZM2.14744 16.3952C2.36575 17.0501 3.07365 17.4041 3.72858 17.1858C4.38351 16.9675 4.73746 16.2596 4.51915 15.6046L2.14744 16.3952ZM26.8819 15.4409C26.5732 16.0584 26.8235 16.8092 27.4409 17.118C28.0584 17.4267 28.8093 17.1764 29.118 16.5589L26.8819 15.4409ZM19.9117 20.4597C20.4098 20.9377 21.2011 20.9214 21.6791 20.4232C22.157 19.9251 22.1407 19.1338 21.6426 18.6559L19.9117 20.4597ZM15.3327 14.3334L16.1982 13.4315C15.7145 12.9674 14.9509 12.9674 14.4672 13.4315L15.3327 14.3334ZM9.02278 18.6559C8.52466 19.1338 8.50834 19.9251 8.98633 20.4232C9.46431 20.9214 10.2556 20.9377 10.7537 20.4597L9.02278 18.6559ZM16.5826 15.7075C16.5826 15.0172 16.023 14.4575 15.3326 14.4575C14.6423 14.4575 14.0826 15.0172 14.0826 15.7075H16.5826ZM14.0826 30.3742C14.0826 31.0645 14.6423 31.6242 15.3326 31.6242C16.023 31.6242 16.5826 31.0645 16.5826 30.3742H14.0826ZM11.9418 2.58325C14.9106 2.58325 17.5046 4.19475 18.8941 6.59674L21.0581 5.34492C19.2401 2.20221 15.8391 0.083252 11.9418 0.083252V2.58325ZM3.91663 10.6084C3.91663 6.61901 7.55104 2.58325 11.9418 2.58325V0.083252C6.08747 0.083252 1.41663 5.32264 1.41663 10.6084H3.91663ZM4.51915 15.6046C3.92453 13.8208 3.91663 12.0114 3.91663 10.6084H1.41663C1.41663 11.9885 1.40872 14.179 2.14744 16.3952L4.51915 15.6046ZM27.4166 11.9999C27.4166 13.3647 27.3984 14.408 26.8819 15.4409L29.118 16.5589C29.9349 14.9252 29.9166 13.3018 29.9166 11.9999H27.4166ZM21.2169 7.22083C22.857 7.22083 24.4466 7.80016 25.6082 8.71668C26.7712 9.63434 27.4166 10.8087 27.4166 11.9999H29.9166C29.9166 9.85783 28.7582 8.01761 27.1568 6.75406C25.554 5.48938 23.4188 4.72083 21.2169 4.72083V7.22083ZM19.9761 7.22083H21.2169V4.72083H19.9761V7.22083ZM21.6426 18.6559L16.1982 13.4315L14.4672 15.2353L19.9117 20.4597L21.6426 18.6559ZM14.4672 13.4315L9.02278 18.6559L10.7537 20.4597L16.1982 15.2353L14.4672 13.4315ZM14.0826 15.7075V30.3742H16.5826V15.7075H14.0826Z"
              fill={props.color || '#121212'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <g
          fill="none"
          fillRule="evenodd"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          transform="translate(1 2)"
        >
          <g transform="translate(6 6)">
            <polyline points=".404 2.829 2.984 .257 5.563 2.829" />
            <path d="M2.98355632,0.257142857 L2.98355632,9" />
          </g>
          <path d="M14.673913,5.69052866 C14.4466871,5.69052866 14.2249066,5.71291937 14.0104821,5.75501483 C14.0570785,5.48674309 14.0869565,5.21291417 14.0869565,4.9317915 C14.0869565,2.20804367 11.8094429,0 9,0 C6.19055707,0 3.91304348,2.20804367 3.91304348,4.9317915 C3.91304348,5.21291417 3.94292152,5.48674309 3.98951789,5.75501483 C3.7750934,5.71291937 3.55331289,5.69052866 3.32608696,5.69052866 C1.489149,5.69052866 0,7.13423171 0,8.91516157 C0,10.6960683 1.489149,12.1397945 3.32608696,12.1397945 C5.03104567,12.1397945 12.9689543,12.1397945 14.673913,12.1397945 C16.510851,12.1397945 18,10.6960683 18,8.91516157 C18,7.13423171 16.510851,5.69052866 14.673913,5.69052866 Z" />
        </g>
      </IconBase>
    )
  },
  users: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 20V18M13 20H1V18C1 14.6863 3.68629 12 7 12C10.3137 12 13 14.6863 13 18M13 20H22V19.5C22 16.4624 19.5376 14 16.5 14C14.9435 14 13.538 14.6466 12.5374 15.6858C12.8354 16.3979 13 17.1797 13 18M10 6C10 7.65685 8.65685 9 7 9C5.34315 9 4 7.65685 4 6C4 4.34315 5.34315 3 7 3C8.65685 3 10 4.34315 10 6ZM19 8.5C19 9.88071 17.8807 11 16.5 11C15.1193 11 14 9.88071 14 8.5C14 7.11929 15.1193 6 16.5 6C17.8807 6 19 7.11929 19 8.5Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <g
          fill="none"
          fillRule="evenodd"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
          transform="translate(1 2)"
        >
          <path d="M6.86778579,10.5402442 C8.54728545,10.5402442 9.66336334,8.30613439 9.82624478,7.74024545 C9.838156,7.69912632 10.0894419,7.57149831 10.1104674,7.53431935 C11.0195965,5.92547714 10.0258534,5.74262202 10.0258534,5.74262202 C10.0258534,5.74262202 10.0724171,4.89485621 9.86149822,4.0983758 C9.86149822,4.0983758 9.32893715,2.12159817 6.86778583,2.12159817 C4.40663451,2.12159817 3.8740738,4.0983758 3.8740738,4.0983758 C3.66315483,4.89485621 3.70971825,5.74262202 3.70971825,5.74262202 C3.70971825,5.74262202 2.71597508,5.92547714 3.62510379,7.53431935 C3.64612976,7.57149831 3.89741563,7.69912632 3.9093272,7.74024545 C4.07220864,8.30613439 5.18828578,10.5402442 6.86778579,10.5402442 Z" />
          <path d="M8.40967096 10.059962C8.40967096 10.059962 9.04988786 10.6941626 10.2685066 11.0788207 11.9951417 11.6237149 13.4743113 12.6494935 13.6031111 15.3566659 13.6031111 15.3566659 10.8087075 15.9582601 6.86778579 15.9582601 2.92686404 15.9582601.132459779 15.3566659.132459779 15.3566659.261267082 12.6494936 1.74043027 11.6237149 3.46706536 11.0788208 4.68568408 10.6941626 5.32590026 10.059962 5.32590026 10.059962M13.7483954 14.1412067C15.8474807 13.7115693 16.7926829 12.5331354 17.4161576 11.8014468 17.0660178 11.1249163 16.0036633 9.7213109 14.3865654 9.16462466 12.813561 8.62309909 12.7978961 8.49416365 12.7978961 7.87527728 13.3824094 7.70335564 14.8374089 8.03055256 15.3406819 7.35953789 15.8048481 6.74065077 15.2516616 6.23145887 14.7991563 5.45130264 14.0513338 4.16195491 14.0449638 3.66636186 13.973973 2.9757549 13.7780273 1.06963529 12.6456185.192803176 11.0908961.0881193189 9.7090685.181161663 8.66084818.884166299 8.30722527 2.37767197" />
        </g>
      </IconBase>
    )
  },
  brands: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.61973 2.5792L0.620527 2.53924L1.61973 2.5792ZM2.57896 1.61997L2.53899 0.620771L2.57896 1.61997ZM2.15026 13.4642L1.44315 14.1713L1.44315 14.1713L2.15026 13.4642ZM1.27398 11.223L0.274775 11.183L1.27398 11.223ZM10.849 22.163L11.5561 21.4559L11.5561 21.4559L10.849 22.163ZM22.1627 10.8493L22.8698 10.1421L22.8698 10.1421L22.1627 10.8493ZM13.464 2.1505L12.7569 2.85761L12.7569 2.85761L13.464 2.1505ZM11.2227 1.27422L11.1828 0.275019L11.2227 1.27422ZM8.70711 7.2929C8.31658 6.90238 7.68342 6.90238 7.29289 7.2929C6.90237 7.68343 6.90237 8.31659 7.29289 8.70712L8.70711 7.2929ZM8.29289 9.70712C8.68342 10.0976 9.31658 10.0976 9.70711 9.70712C10.0976 9.31659 10.0976 8.68343 9.70711 8.2929L8.29289 9.70712ZM12.7569 2.85761L21.4556 11.5564L22.8698 10.1421L14.1711 1.4434L12.7569 2.85761ZM21.4556 14.3848L14.3845 21.4559L15.7988 22.8701L22.8698 15.799L21.4556 14.3848ZM11.5561 21.4559L2.85737 12.7571L1.44315 14.1713L10.1419 22.8701L11.5561 21.4559ZM2.27318 11.263L2.61893 2.61917L0.620527 2.53924L0.274775 11.183L2.27318 11.263ZM2.61893 2.61917L11.2627 2.27342L11.1828 0.275019L2.53899 0.620771L2.61893 2.61917ZM2.61893 2.61917L2.61893 2.61917L2.53899 0.620771C1.4972 0.662442 0.662198 1.49745 0.620527 2.53924L2.61893 2.61917ZM2.85737 12.7571C2.46266 12.3624 2.25087 11.8207 2.27318 11.263L0.274775 11.183C0.230155 12.2985 0.653744 13.3819 1.44315 14.1713L2.85737 12.7571ZM14.3845 21.4559C13.6035 22.2369 12.3372 22.2369 11.5561 21.4559L10.1419 22.8701C11.704 24.4322 14.2367 24.4322 15.7988 22.8701L14.3845 21.4559ZM21.4556 11.5564C22.2367 12.3374 22.2367 13.6037 21.4556 14.3848L22.8698 15.799C24.4319 14.2369 24.4319 11.7042 22.8698 10.1421L21.4556 11.5564ZM14.1711 1.4434C13.3817 0.653988 12.2983 0.230399 11.1828 0.275019L11.2627 2.27342C11.8205 2.25111 12.3622 2.46291 12.7569 2.85761L14.1711 1.4434ZM7.29289 8.70712L8.29289 9.70712L9.70711 8.2929L8.70711 7.2929L7.29289 8.70712Z"
              fill={props.color || 'currentColor'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <g
          fill="none"
          stroke={props.color || 'currentColor'}
          transform="rotate(45 8.5 15.036)"
        >
          <polygon points="0 17 0 3.207 3.341 0 8.908 0 12 3.207 12 17" />
          <circle cx="6" cy="4.586" r="2" />
          <path
            strokeLinecap="square"
            d="M1.13686838e-13,14.5 L12,14.5 L1.13686838e-13,14.5 Z"
          />
        </g>
      </IconBase>
    )
  },
  timeEntries: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7H13ZM12 13H11C11 13.2652 11.1054 13.5196 11.2929 13.7071L12 13ZM13.7929 16.2071C14.1834 16.5976 14.8166 16.5976 15.2071 16.2071C15.5976 15.8166 15.5976 15.1834 15.2071 14.7929L13.7929 16.2071ZM22 12C22 17.5228 17.5228 22 12 22V24C18.6274 24 24 18.6274 24 12H22ZM12 22C6.47715 22 2 17.5228 2 12H0C0 18.6274 5.37258 24 12 24V22ZM2 12C2 6.47715 6.47715 2 12 2V0C5.37258 0 0 5.37258 0 12H2ZM12 2C17.5228 2 22 6.47715 22 12H24C24 5.37258 18.6274 0 12 0V2ZM11 7V13H13V7H11ZM11.2929 13.7071L13.7929 16.2071L15.2071 14.7929L12.7071 12.2929L11.2929 13.7071Z"
              fill={props.color || 'currentColor'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props} viewBox="0 -1 22 30" fill="none" fillRule="evenodd">
        <g>
          <path
            stroke={props.color || 'currentColor'}
            d="M12 0c6.623 0 12 5.377 12 12s-5.377 12-12 12-12-5.377-12-12 5.377-12 12-12zm0 1c6.071 0 11 4.929 11 11s-4.929 11-11 11-11-4.929-11-11 4.929-11 11-11zm0 11h6v1h-7v-9h1v8z"
          />
        </g>
      </IconBase>
    )
  },
  dollar: (props: IconBaseProps) => (
    <IconBase {...props} viewBox="0 -1 22 30" fill="none" fillRule="evenodd">
      <g
        stroke={props.color || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 1V23" />
        <path d="M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6" />
      </g>
    </IconBase>
  ),
  roundDollar: (props: IconBaseProps) => (
    <IconBase {...props}>
      <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.6667 8.08325H10.8817C10.1654 8.08351 9.54316 8.57613 9.37859 9.27331C9.21402 9.97049 9.55026 10.6894 10.1909 11.0099L11.8159 11.8233C12.4565 12.1438 12.7927 12.8627 12.6282 13.5599C12.4636 14.257 11.8414 14.7497 11.125 14.7499H9.33337"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5867 14.75V16"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.42 6.83325V8.08325"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.0034 20.5833C16.2961 20.5833 20.5867 16.2927 20.5867 11C20.5867 5.70723 16.2961 1.41663 11.0034 1.41663C5.71065 1.41663 1.42004 5.70723 1.42004 11C1.42004 16.2927 5.71065 20.5833 11.0034 20.5833Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  ),
  receipt: (props: IconBaseProps) => (
    <IconBase
      {...props}
      viewBox="0 -1 22 30"
      fill="none"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <g>
        <path
          d="M7.19998 20.8973L5.6485 22.4487C4.89255 23.2047 3.59998 22.6693 3.59998 21.6002V3.93853C3.59998 3.26968 3.67754 2.86802 3.90208 2.44817C4.1185 2.04349 4.44327 1.71872 4.84795 1.5023C5.2678 1.27776 5.66946 1.2002 6.33831 1.2002H17.6616C18.3305 1.2002 18.7321 1.27776 19.152 1.5023C19.5567 1.71872 19.8814 2.04349 20.0979 2.44817C20.3224 2.86802 20.4 3.26968 20.4 3.93853V21.6002C20.4 22.6693 19.1074 23.2047 18.3514 22.4487L16.8 20.8973L15.2485 22.4487C14.7799 22.9174 14.0201 22.9174 13.5514 22.4487L12 20.8973L10.4485 22.4487C9.97987 22.9174 9.22008 22.9174 8.75145 22.4487L7.19998 20.8973ZM17.6616 3.6002H6.33831C6.12111 3.6002 6.04408 3.60285 6.00886 3.60908C6.00263 3.6443 5.99998 3.72133 5.99998 3.93853V18.7031L6.35145 18.3517C6.82008 17.883 7.57987 17.883 8.0485 18.3517L9.59998 19.9031L11.1514 18.3517C11.6201 17.883 12.3799 17.883 12.8485 18.3517L14.4 19.9031L15.9514 18.3517C16.4201 17.883 17.1799 17.883 17.6485 18.3517L18 18.7031V3.93853C18 3.72133 17.9973 3.6443 17.9911 3.60908C17.9559 3.60285 17.8788 3.6002 17.6616 3.6002ZM14.4 6.0002H9.59997C8.93723 6.0002 8.39997 6.53745 8.39997 7.2002C8.39997 7.86294 8.93723 8.4002 9.59997 8.4002H14.4C15.0627 8.4002 15.6 7.86294 15.6 7.2002C15.6 6.53745 15.0627 6.0002 14.4 6.0002ZM9.59997 9.6002H14.4C15.0627 9.6002 15.6 10.1375 15.6 10.8002C15.6 11.4629 15.0627 12.0002 14.4 12.0002H9.59997C8.93723 12.0002 8.39997 11.4629 8.39997 10.8002C8.39997 10.1375 8.93723 9.6002 9.59997 9.6002ZM14.4 13.2002H9.59997C8.93723 13.2002 8.39997 13.7375 8.39997 14.4002C8.39997 15.0629 8.93723 15.6002 9.59997 15.6002H14.4C15.0627 15.6002 15.6 15.0629 15.6 14.4002C15.6 13.7375 15.0627 13.2002 14.4 13.2002Z"
          fill={props.color || 'currentColor'}
        />
        <mask
          id="mask0"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="3"
          y="1"
          width="18"
          height="22"
        >
          <path
            d="M7.19998 20.8973L5.6485 22.4487C4.89255 23.2047 3.59998 22.6693 3.59998 21.6002V3.93853C3.59998 3.26968 3.67754 2.86802 3.90208 2.44817C4.1185 2.04349 4.44327 1.71872 4.84795 1.5023C5.2678 1.27776 5.66946 1.2002 6.33831 1.2002H17.6616C18.3305 1.2002 18.7321 1.27776 19.152 1.5023C19.5567 1.71872 19.8814 2.04349 20.0979 2.44817C20.3224 2.86802 20.4 3.26968 20.4 3.93853V21.6002C20.4 22.6693 19.1074 23.2047 18.3514 22.4487L16.8 20.8973L15.2485 22.4487C14.7799 22.9174 14.0201 22.9174 13.5514 22.4487L12 20.8973L10.4485 22.4487C9.97987 22.9174 9.22008 22.9174 8.75145 22.4487L7.19998 20.8973ZM17.6616 3.6002H6.33831C6.12111 3.6002 6.04408 3.60285 6.00886 3.60908C6.00263 3.6443 5.99998 3.72133 5.99998 3.93853V18.7031L6.35145 18.3517C6.82008 17.883 7.57987 17.883 8.0485 18.3517L9.59998 19.9031L11.1514 18.3517C11.6201 17.883 12.3799 17.883 12.8485 18.3517L14.4 19.9031L15.9514 18.3517C16.4201 17.883 17.1799 17.883 17.6485 18.3517L18 18.7031V3.93853C18 3.72133 17.9973 3.6443 17.9911 3.60908C17.9559 3.60285 17.8788 3.6002 17.6616 3.6002ZM14.4 6.0002H9.59997C8.93723 6.0002 8.39997 6.53745 8.39997 7.2002C8.39997 7.86294 8.93723 8.4002 9.59997 8.4002H14.4C15.0627 8.4002 15.6 7.86294 15.6 7.2002C15.6 6.53745 15.0627 6.0002 14.4 6.0002ZM9.59997 9.6002H14.4C15.0627 9.6002 15.6 10.1375 15.6 10.8002C15.6 11.4629 15.0627 12.0002 14.4 12.0002H9.59997C8.93723 12.0002 8.39997 11.4629 8.39997 10.8002C8.39997 10.1375 8.93723 9.6002 9.59997 9.6002ZM14.4 13.2002H9.59997C8.93723 13.2002 8.39997 13.7375 8.39997 14.4002C8.39997 15.0629 8.93723 15.6002 9.59997 15.6002H14.4C15.0627 15.6002 15.6 15.0629 15.6 14.4002C15.6 13.7375 15.0627 13.2002 14.4 13.2002Z"
            fill="white"
          />
        </mask>
      </g>
      <g mask="url(#mask0)" />
    </IconBase>
  ),
  tasks: (props: IconBaseProps & { theme: Theme }) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 11L12 14L22 4"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <rect
            stroke={props.color || 'currentColor'}
            fill={props?.theme?.palette.background.paper || '#fff'}
            fillRule="nonzero"
            x="4.5"
            y="2.5"
            width="13"
            height="13"
            rx="1"
          />
          <g fillRule="nonzero">
            <rect
              stroke={props.color || 'currentColor'}
              fill={props?.theme?.palette.background.paper || '#fff'}
              strokeWidth="1"
              strokeLinejoin="inherit"
              fillRule="evenodd"
              x="2.5"
              y="4.5"
              width="13"
              height="13"
              rx="1"
            />
            <rect
              strokeWidth="0.5"
              stroke={props?.theme?.palette.background.paper || '#fff'}
              x="1.75"
              y="3.75"
              width="14.5"
              height="14.5"
              rx="1"
            />
          </g>
          <path
            d="M8.05740811,16.1181641 C7.68499111,15.4454108 7.39867481,14.9508644 7.19845062,14.6345102 L6.88009575,14.1359545 L6.63982792,13.769546 C6.11524054,12.9526313 5.5686367,12.2778859 5,11.7452896 C5.32436319,11.4769892 5.62669718,11.342841 5.90701105,11.342841 C6.25139666,11.342841 6.55773507,11.4689803 6.82603549,11.7212628 C7.09433591,11.9735453 7.43270971,12.4540761 7.84116706,13.1628698 C8.30568719,11.6531794 8.89633969,10.2215979 9.61314229,8.86808236 C10.0095862,8.13125734 10.3629766,7.6357099 10.6733241,7.38142518 C10.9836716,7.12714045 11.3951261,7 11.9077,7 C12.1800049,7 12.5163765,7.04204645 12.9168249,7.12614061 C11.8876726,7.95506876 11.0647635,8.940157 10.448073,10.0814349 C9.83138249,11.2227128 9.03450216,13.2349357 8.05740811,16.1181641 Z"
            fill={props.color || 'currentColor'}
          />
        </g>
      </IconBase>
    )
  },
  globalTasks: (props: IconBaseProps & { theme: Theme }) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="32"
            height="32"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.66667 15.1111L5.04762 17.3333L9.33334 13.3333M2.66667 5.77778L5.04762 8L9.33334 4M2.66667 24.4444L5.04762 26.6667L9.33334 22.6667M13.3333 6.66667H29.3333M13.3333 16H29.3333M13.3333 25.3333H29.3333"
              stroke={props.color || 'currentColor'}
              strokeWidth="2.5"
              strokeLinecap="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase
        {...omit(props, ['viewBox', 'fill'])}
        viewBox="0 0 16 10"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00016 7.04171C9.12774 7.04171 10.0418 6.12762 10.0418 5.00004C10.0418 3.87246 9.12774 2.95837 8.00016 2.95837C6.87258 2.95837 5.9585 3.87246 5.9585 5.00004C5.9585 6.12762 6.87258 7.04171 8.00016 7.04171Z"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.636 4.80871C13.9576 4.03871 11.2445 1.20837 8.00001 1.20837C4.75551 1.20837 2.04243 4.03871 1.36401 4.80871C1.26864 4.91844 1.26864 5.08164 1.36401 5.19137C2.04243 5.96137 4.75551 8.79171 8.00001 8.79171C11.2445 8.79171 13.9576 5.96137 14.636 5.19137C14.7314 5.08164 14.7314 4.91844 14.636 4.80871Z"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </IconBase>
    )
  },
  editorBold: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 8V14H9C10.6569 14 12 12.6569 12 11C12 9.34315 10.6569 8 9 8C10.6569 8 12 6.65685 12 5C12 3.34315 10.6569 2 9 2H4V8ZM4 8H10"
              stroke={props.color || 'currentColor'}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <svg viewBox="0 0 512 512">
          <path
            fill={props.color || 'currentColor'}
            d="M346.938,240.625c48.25,11.25,82.125,24.875,101.625,40.875c28,22.75,42,52.25,42,88.5  c0,38.25-15.375,69.875-46.125,94.875c-37.75,30.25-92.625,45.375-164.625,45.375H21.438v-13.875c23.5,0,39.438-2.188,47.812-6.562  c8.374-4.373,14.25-10.062,17.625-17.062s5.062-24.25,5.062-51.75V91c0-27.5-1.688-44.812-5.062-51.938S77.563,26.25,69.062,22  c-8.5-4.25-24.375-6.375-47.625-6.375V1.75h243.75c58.25,0,99.5,5.188,123.75,15.563c24.25,10.374,43.375,25.875,57.375,46.5  s21,42.562,21,65.812c0,24.5-8.875,46.312-26.625,65.438S391.688,229.375,346.938,240.625z M210.438,259.75v163.125l-0.375,18.75  c0,13.5,3.438,23.688,10.312,30.562c6.874,6.873,17.062,10.312,30.562,10.312c20,0,38.438-4.438,55.312-13.312  c16.874-8.875,29.812-21.75,38.812-38.625s13.5-35.688,13.5-56.438c0-23.75-5.5-45.062-16.5-63.938  c-11-18.875-26.125-32.062-45.375-39.562S248.688,259.5,210.438,259.75z M210.438,230.5c35.5,0,61.688-4,78.562-12  s29.812-19.25,38.812-33.75s13.5-33,13.5-55.5S336.875,88.312,328,73.938s-21.562-25.312-38.062-32.812s-43-11.125-79.5-10.875  V230.5L210.438,230.5z"
          />
        </svg>
      </IconBase>
    )
  },
  editorItalic: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.33333 2.66663H13.3333M2 13.3333H10M9.33333 2.66663L6 13.3333"
              stroke={props.color || 'currentColor'}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <svg viewBox="0 0 512 512">
          <g transform="matrix(1.0353857,0,-0.1738183,0.95340806,17.704546,4.3865211)">
            <g transform="matrix(1.2877648,0,-0.23477575,-1.3984917,68.485679,530.39353)">
              <path
                fill={props.color || 'currentColor'}
                d="m 40.033843,3.1109901 6.18,15.7199999 5.28,0.24 19.2,1.26 2.58,0.18 4.8,0.66 4.44001,1.02 4.02,1.32 3.66,1.68 3.24,2.04 2.88,2.34 2.46,2.7 1.08,1.5 1.859997,2.7 3.95999,6.900001 4.38,8.7 4.68,10.619999 2.46,6.06001 84.24001,207.84001 2.46,6.48 7.2,19.86 7.68,22.14 4.44,13.8 1.86,6.48 0.42,1.98 0.18,1.5 -0.12,2.76 -0.9,2.4 -1.62,2.1 -2.34,1.68 -3.06,1.38 -3.78,1.02 -4.5,0.66 -2.58,0.18 -18.24,1.02 -4.86,0.48 6.12,15.48 h 159.54001 l -6.12,-15.48 -5.34,-0.48 -19.14,-1.02 -4.38,-0.3 -7.44,-1.02 -5.82001,-1.5 -3.3,-1.5 -1.74,-1.14 -0.72,-0.6 -1.32,-1.32 -2.76,-3.36 -2.82,-4.38 -3,-5.34 -1.5,-3.12 -11.76,-25.08 -97.2,-243.60001 -2.1,-5.40001 -3.54,-9.779999 -2.76,-8.64 -1.98,-7.560001 -0.66,-3.36 -0.18,-1.5 0.18,-2.7 0.84,-2.34 1.62,-2.04 2.34,-1.74 3.06,-1.38 3.78,-1.02 4.5,-0.72 2.58,-0.24 18.18,-1.26 4.92,-0.24 -6.18,-15.7199999 z"
              />
            </g>
          </g>
        </svg>
      </IconBase>
    )
  },
  editorUnderline: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.00002 1.33337V7.48489C4.00002 7.48489 4.50002 10.6667 8.00002 10.6667C11.5 10.6667 12 7.48489 12 7.48489V1.33337M2.66669 14.6667H13.3334"
              stroke={props.color || 'currentColor'}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <svg viewBox="0 0 1792 1792">
          <path
            fill={props.color || 'currentColor'}
            d="m 150.80826,118.93779 q -37.95501,-2.31317 -46.16151,-4.62633 L 101.56932,12.531716 q 13.33554,-1.156596 41.03244,-1.156596 61.54869,0 114.89087,4.626355 135.40707,8.096111 170.28466,8.096111 88.21976,0 172.33627,-3.469756 118.99412,-4.626355 149.76844,-5.782941 57.44542,0 88.21977,-2.313173 l -1.02582,16.192225 2.05163,74.021639 v 10.40928 q -61.54868,10.4093 -127.2006,10.4093 -61.54865,0 -81.03907,28.91469 -13.33556,16.19225 -13.33556,152.66964 0,15.03562 0.51292,37.58911 0.51289,22.55345 0.51289,29.49298 l 1.02581,264.85865 14.36138,323.84464 q 6.15486,143.41703 52.31637,233.63083 35.90338,68.2387 98.47787,106.4061 90.27139,54.3595 181.56858,54.3595 106.68443,0 195.92983,-32.3845 57.4456,-20.8186 101.5554,-58.9859 49.2389,-41.6371 66.6778,-74.0216 36.9291,-64.7689 54.368,-131.8511 21.542,-84.43084 21.542,-264.85859 0,-91.37045 -3.5903,-148.04327 -3.5903,-56.67282 -11.284,-141.68203 -7.6935,-85.00922 -13.8484,-184.47578 l -4.1032,-68.2387 q -5.1291,-77.4914 -24.6194,-101.77975 -34.8777,-40.48057 -78.9876,-39.32397 l -102.5812,2.31318 -14.3612,-3.46978 2.0514,-99.4665623 h 86.1684 L 1451.5369,20.62783 q 77.9617,3.469756 201.0591,-11.5658823 l 18.4646,2.3131723 q 6.1547,43.950355 6.1547,58.985993 0,8.096114 -4.1032,35.854217 -46.1614,13.87906 -86.168,15.03565 -74.8843,12.72246 -81.0393,19.66199 -15.387,17.34882 -15.387,47.42011 0,8.09612 1.5386,31.22788 1.5388,23.13175 1.5388,35.85422 8.2065,21.97518 22.5678,458.00886 6.1549,225.53463 -15.3871,351.60276 -15.3872,87.9007 -42.0583,141.1038 -38.9808,75.1783 -114.8908,142.2602 -76.9359,65.9256 -186.6978,102.9364 -111.8134,38.1675 -261.58181,38.1675 -171.31046,0 -291.33037,-53.2032 -122.07154,-54.3596 -183.62022,-141.1036 -62.57447,-87.9008 -85.14233,-225.5348 -16.41298,-92.52696 -16.41298,-274.11131 v -385.1438 q 0,-217.43854 -17.43879,-246.35327 -25.64527,-41.63715 -150.79424,-45.10693 z M 1677.2153,1748.5702 v -74.0215 q 0,-16.1923 -9.2322,-26.6015 -9.2324,-10.4094 -23.5937,-10.4094 H 134.39527 q -14.36136,0 -23.59366,10.4094 -9.23229,10.4092 -9.23229,26.6015 v 74.0215 q 0,16.1923 9.23229,26.6016 9.2323,10.4093 23.59366,10.4093 H 1644.3894 q 14.3613,0 23.5937,-10.4093 9.2322,-10.4093 9.2322,-26.6016 z"
          />
        </svg>
      </IconBase>
    )
  },
  editorUL: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.66669 3.33333H15.6667M7.66669 8H15.6667M7.66669 12.6667H15.6667M4.33335 8C4.33335 8.73638 3.7364 9.33333 3.00002 9.33333C2.26364 9.33333 1.66669 8.73638 1.66669 8C1.66669 7.26362 2.26364 6.66667 3.00002 6.66667C3.7364 6.66667 4.33335 7.26362 4.33335 8ZM4.33335 3.33333C4.33335 4.06971 3.7364 4.66667 3.00002 4.66667C2.26364 4.66667 1.66669 4.06971 1.66669 3.33333C1.66669 2.59695 2.26364 2 3.00002 2C3.7364 2 4.33335 2.59695 4.33335 3.33333ZM4.33335 12.6667C4.33335 13.403 3.7364 14 3.00002 14C2.26364 14 1.66669 13.403 1.66669 12.6667C1.66669 11.9303 2.26364 11.3333 3.00002 11.3333C3.7364 11.3333 4.33335 11.9303 4.33335 12.6667Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <svg viewBox="0 0 48 48">
          <path
            fill={props.color || 'currentColor'}
            d="m 4.4874027,18.486523 c -2.0797526,0 -3.75858914,1.678837 -3.75858914,3.758589 0,2.079753 1.67883654,3.758589 3.75858914,3.758589 2.0797526,0 3.7585891,-1.678836 3.7585891,-3.758589 0,-2.079752 -1.6788365,-3.758589 -3.7585891,-3.758589 z m 0,-15.0343563 c -2.0797526,0 -3.75858914,1.6788365 -3.75858914,3.7585891 0,2.0797532 1.67883654,3.7585892 3.75858914,3.7585892 2.0797526,0 3.7585891,-1.678836 3.7585891,-3.7585892 0,-2.0797526 -1.6788365,-3.7585891 -3.7585891,-3.7585891 z m 0,30.4821573 c -1.8417087,0 -3.3451443,1.490908 -3.3451443,3.345145 0,1.854237 1.5034356,3.345144 3.3451443,3.345144 1.8417087,0 3.3451443,-1.490907 3.3451443,-3.345144 0,-1.854237 -1.5034356,-3.345145 -3.3451443,-3.345145 z m 7.5171783,5.850871 H 47.084746 V 34.773743 H 12.004581 Z m 0,-15.034357 H 47.084746 V 19.739386 H 12.004581 Z m 0,-20.0458083 V 9.716482 H 47.084746 V 4.7050297 Z"
          />
        </svg>
      </IconBase>
    )
  },
  editorOL: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.66665 3.33333H14.6666M6.66665 8H14.6666M6.66665 12.6667H14.6666M1.33331 2H2.33331V4.66667M1.33331 11.3333H2.99998V12.6667M2.99998 12.6667H1.99998M2.99998 12.6667V14H1.33331M1.33331 6.66667H2.99998L1.66665 9H3.33331"
              stroke={props.color || 'currentColor'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <svg viewBox="0 0 48 48">
          <g>
            <path d="M 12.004581,39.785195 H 47.084746 V 34.773743 H 12.004581 Z m 0,-15.034357 H 47.084746 V 19.739386 H 12.004581 Z m 0,-20.0458083 V 9.716482 H 47.084746 V 4.7050297 Z" />
            <path d="m 7.004581,36.800914 v -0.04196 c 1,-0.206065 1.5,-0.534279 1.914,-0.987436 0.414,-0.454091 0.679,-0.996762 0.679,-1.629877 0,-0.73475 -0.292,-1.311921 -0.936,-1.730579 -0.644,-0.418658 -1.518,-0.628454 -2.65,-0.628454 -0.784,0 -1.47,0.07926 -2.078,0.237769 -0.605,0.158512 -1.195,0.42332 -1.773,0.796289 l 1.229,1.84247 c 0.749,-0.438239 1.473,-0.655494 2.172,-0.655494 0.375,0 0.673,0.06434 0.895,0.194877 0.223,0.131471 0.333,0.2042 0.333,0.473671 0,0.716101 -0.75,0.947342 -2.253,0.947342 h -0.532 v 2.797272 h 0.517 c 0.554,0 1.003,-0.196742 1.347,-0.11935 0.344,0.07553 0.593,0.07366 0.749,0.222849 0.155,0.151053 0.232,0.308632 0.232,0.587427 0,0.363645 -0.148,0.601413 -0.445,0.770182 -0.297,0.169701 -0.77,0.240565 -1.419,0.240565 -0.419,0 -0.949,-0.06247 -1.446,-0.172498 -0.496,-0.11189 -0.535,-0.286253 -1.535,-0.513765 v 2.288168 c 1,0.209796 1.199,0.354322 1.7,0.433578 0.502,0.07832 1.083,0.118417 1.672,0.118417 1.431,0 2.569,-0.272267 3.375,-0.816803 0.805,-0.544535 1.1,-1.291407 1.1,-2.239682 0,-1.396771 -0.847,-2.202385 -2.847,-2.414978 z" />
            <path d="m 6.004581,24.707014 c 1.095,-1.01541 1.944,-1.702606 2.316,-2.065319 0.372,-0.362713 0.64,-0.708642 0.864,-1.036855 0.225,-0.328214 0.375,-0.662021 0.483,-1.001424 0.107,-0.339402 0.153,-0.709574 0.153,-1.109584 0,-0.534279 -0.157,-1.017274 -0.463,-1.448054 -0.308,-0.429847 -0.741,-0.76179 -1.298,-0.994896 -0.556,-0.233106 -1.189,-0.348727 -1.898,-0.348727 -0.563,0 -1.073,0.05315 -1.524,0.160377 -0.452,0.107229 -0.87,0.262011 -1.254,0.464347 -0.384,0.202336 -0.859,0.538009 -1.422,1.008883 l 1.625,1.772537 c 0.443,-0.35805 0.842,-0.628453 1.193,-0.813073 0.353,-0.183688 0.701,-0.275998 1.045,-0.275998 0.334,0 0.593,0.07739 0.778,0.230309 0.185,0.152918 0.277,0.362713 0.277,0.628454 0,0.213525 -0.046,0.418658 -0.139,0.614467 -0.092,0.194877 -0.256,0.428915 -0.49,0.701183 -0.234,0.272267 -0.772,0.780438 -1.536,1.524513 l -2.71,2.519409 v 1.378122 h 8 v -1.864847 h -4 z" />
            <path d="m 5.030581,5.4259897 c 0.275,-0.2284439 0.668,-0.4475635 0.854,-0.6564264 -0.03,0.5445355 0.12,1.1450165 0.12,1.8005104 v 5.4490853 h 2 V 1.7624965 h -1.994 l -3.757,2.8569466 1.534,1.7604161 z" />
          </g>
        </svg>
      </IconBase>
    )
  },
  editorBlockquote: (props: IconBaseProps) => (
    <IconBase {...props}>
      <svg viewBox="0 0 32 32">
        <g>
          <defs>
            <rect height="32" width="32" />
          </defs>
          <g>
            <defs>
              <rect height="32" width="32" />
            </defs>
            <path
              d="M23.001,17.001V14.9c0-3.599,2-6.201,5-6.201V2.001c-7,0-11,4.701-11,13v15h13    v-13H23.001z M8.001,14.9c0-3.599,2-6.201,5-6.201V2.001c-7,0-11,4.701-11,13v15h13v-13h-7V14.9z"
              fill={props.color || 'currentColor'}
            />
          </g>
        </g>
      </svg>
    </IconBase>
  ),
  editorLink: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 4.66662L10.2116 2.41736C11.3759 1.23317 13.2823 1.22511 14.4566 2.39942C15.6239 3.56674 15.6239 5.45935 14.4566 6.62667L11.7866 9.29666C10.7728 10.3105 9.13877 10.3412 8.08756 9.36618L7.33333 8.66662M8.90356 11.8749L6.69201 14.1242C5.52767 15.3084 3.62127 15.3165 2.44697 14.1421C1.27964 12.9748 1.27964 11.0822 2.44696 9.91489L5.11695 7.24491C6.13078 6.23108 7.76479 6.20037 8.816 7.17539L9.57023 7.87495"
              stroke={props.color || 'currentColor'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <svg viewBox="0 0 162.656 162.656">
          <path d="M151.764,10.894c-14.522-14.522-38.152-14.525-52.676-0.008l0.003,0.003L76.112,33.872l10.607,10.605l22.983-22.988 l-0.002-0.002c8.678-8.663,22.785-8.658,31.457,0.014c8.673,8.672,8.672,22.786,0,31.461l-34.486,34.484 c-4.201,4.202-9.787,6.516-15.729,6.516c-5.942,0-11.529-2.314-15.73-6.516L64.605,98.052c7.035,7.035,16.389,10.91,26.338,10.91 c9.949,0,19.303-3.875,26.335-10.91l34.487-34.484C166.284,49.043,166.284,25.413,151.764,10.894z" />
          <path d="M52.96,141.162L52.96,141.162c-8.675,8.67-22.788,8.668-31.461-0.005c-8.673-8.675-8.673-22.791-0.001-31.465L55.98,75.21 c8.675-8.674,22.789-8.674,31.462,0L98.05,64.604c-14.524-14.523-38.154-14.524-52.676,0L10.89,99.086 c-14.519,14.523-14.519,38.154,0.001,52.678c7.263,7.262,16.801,10.893,26.341,10.892c9.536,0,19.074-3.629,26.333-10.887 l0.002-0.001l22.984-22.99l-10.608-10.606L52.96,141.162z" />
        </svg>
      </IconBase>
    )
  },
  editorEmoji: (props: IconBaseProps) => {
    return (
      <IconBase {...props}>
        <svg
          width="19"
          height="19"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_132_519)">
            <path
              d="M5.33335 10.0001C5.33335 10.0001 6.47621 11.0001 8.00002 11.0001C9.52383 11.0001 10.6667 10.0001 10.6667 10.0001M5.33335 6.00008H5.50002M10.6667 6.00008H10.8334M15.3334 8.00008C15.3334 12.0502 12.0501 15.3334 8.00002 15.3334C3.94993 15.3334 0.666687 12.0502 0.666687 8.00008C0.666687 3.94999 3.94993 0.666748 8.00002 0.666748C12.0501 0.666748 15.3334 3.94999 15.3334 8.00008Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_132_519">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </IconBase>
    )
  },
  share: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg width="22" height="22" viewBox="0 0 24 25" fill="none">
            <path
              d="M21 13C21 12.4477 20.5523 12 20 12C19.4477 12 19 12.4477 19 13H21ZM4 13C4 12.4477 3.55228 12 3 12C2.44772 12 2 12.4477 2 13H4ZM16.1799 7.25955C16.5691 7.65137 17.2023 7.65349 17.5941 7.26427C17.9859 6.87505 17.988 6.24188 17.5988 5.85006L16.1799 7.25955ZM11.7294 1.36035L12.4389 0.655607C12.2512 0.466626 11.9958 0.360352 11.7294 0.360352C11.4631 0.360352 11.2077 0.466626 11.02 0.655607L11.7294 1.36035ZM5.86006 5.85006C5.47084 6.24188 5.47295 6.87505 5.86477 7.26427C6.2566 7.65349 6.88976 7.65137 7.27898 7.25955L5.86006 5.85006ZM12.7287 2.25994C12.7287 1.70766 12.2809 1.25994 11.7287 1.25994C11.1764 1.25994 10.7287 1.70766 10.7287 2.25994H12.7287ZM10.7287 13.2599C10.7287 13.8122 11.1764 14.2599 11.7287 14.2599C12.2809 14.2599 12.7287 13.8122 12.7287 13.2599H10.7287ZM19 13V18H21V13H19ZM15 22H8V24H15V22ZM4 18V13H2V18H4ZM8 22C5.79086 22 4 20.2091 4 18H2C2 21.3137 4.68629 24 8 24V22ZM19 18C19 20.2091 17.2091 22 15 22V24C18.3137 24 21 21.3137 21 18H19ZM17.5988 5.85006L12.4389 0.655607L11.02 2.0651L16.1799 7.25955L17.5988 5.85006ZM11.02 0.655607L5.86006 5.85006L7.27898 7.25955L12.4389 2.0651L11.02 0.655607ZM10.7287 2.25994V13.2599H12.7287V2.25994H10.7287Z"
              fill={props.color || 'currentColor'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <g
          fill="none"
          fillRule="evenodd"
          stroke={props.color || '#414141'}
          strokeLinecap="round"
          strokeLinejoin="round"
          transform="translate(1 1)"
        >
          <polyline points="8 2.054 0 2.054 0 18 16 18 16 10" />
          <path d="M6,12 C9.99999896,7.99999956 13.9999995,3.99999974 18,0" />
          <polyline points="13 0 18 0 18 5" />
        </g>
      </IconBase>
    )
  },
  presentationAnalytics: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName !== 'liglhtV2') {
      return (
        <IconBase {...props}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 9C6.44772 9 6 9.44771 6 10C6 10.5523 6.44772 11 7 11V9ZM17 11C17.5523 11 18 10.5523 18 10C18 9.44771 17.5523 9 17 9V11ZM7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15V13ZM17 15C17.5523 15 18 14.5523 18 14C18 13.4477 17.5523 13 17 13V15ZM7 17C6.44772 17 6 17.4477 6 18C6 18.5523 6.44772 19 7 19V17ZM17 19C17.5523 19 18 18.5523 18 18C18 17.4477 17.5523 17 17 17V19ZM20 6V20H22V6H20ZM18 22H6V24H18V22ZM4 20V6H2V20H4ZM6 22C4.89543 22 4 21.1046 4 20H2C2 22.2091 3.79086 24 6 24V22ZM20 20C20 21.1046 19.1046 22 18 22V24C20.2091 24 22 22.2091 22 20H20ZM22 6C22 3.79086 20.2091 2 18 2V4C19.1046 4 20 4.89543 20 6H22ZM4 6C4 4.89543 4.89543 4 6 4V2C3.79086 2 2 3.79086 2 6H4ZM8 2H16V0H8V2ZM16 4H8V6H16V4ZM8 4C7.44772 4 7 3.55228 7 3H5C5 4.65685 6.34315 6 8 6V4ZM17 3C17 3.55228 16.5523 4 16 4V6C17.6569 6 19 4.65685 19 3H17ZM16 2C16.5523 2 17 2.44772 17 3H19C19 1.34315 17.6569 0 16 0V2ZM8 0C6.34315 0 5 1.34315 5 3H7C7 2.44772 7.44772 2 8 2V0ZM7 11H17V9H7V11ZM7 15H17V13H7V15ZM7 19H17V17H7V19Z"
              fill={props.color || '#121212'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props} viewBox="0 0 24 24" fill="none">
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.50391 2.5H21.5039V19.5H2.50391V2.5Z"
            stroke={props.color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.0039 23.5C12.5562 23.5 13.0039 23.0523 13.0039 22.5C13.0039 21.9477 12.5562 21.5 12.0039 21.5C11.4516 21.5 11.0039 21.9477 11.0039 22.5C11.0039 23.0523 11.4516 23.5 12.0039 23.5Z"
            stroke={props.color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.0039 19.5V21.5"
            stroke={props.color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.50391 6V5"
            stroke={props.color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.00008 6H6.97108C6.32846 6.00045 5.77634 6.45639 5.6544 7.08734C5.53245 7.71828 5.8749 8.34712 6.47108 8.587L8.53508 9.413C9.13091 9.65273 9.47336 10.281 9.35195 10.9117C9.23055 11.5424 8.67932 11.9986 8.03708 12H6.00008"
            stroke={props.color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.50391 13V12"
            stroke={props.color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.5 15.5V10C17.5 9.72386 17.2761 9.5 17 9.5H16C15.7239 9.5 15.5 9.72386 15.5 10V15.5"
            stroke={props.color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.5 15.5V13C13.5 12.7239 13.2761 12.5 13 12.5H12C11.7239 12.5 11.5 12.7239 11.5 13V15.5"
            stroke={props.color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.50391 15.5H19.0039"
            stroke={props.color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.5 1.5C23.5 2.05228 23.0523 2.5 22.5 2.5H1.5C0.947715 2.5 0.5 2.05228 0.5 1.5C0.5 0.947715 0.947715 0.5 1.5 0.5H22.5C23.0523 0.5 23.5 0.947715 23.5 1.5Z"
            stroke={props.color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.50391 19.5H22.5039"
            stroke={props.color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </IconBase>
    )
  },
  calendar: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 1V3M17 1V3M2 8H22M7.5 13H9.5M14.5 13H16.5M7.5 17H9.5M14.5 17H16.5M5 22H19C20.6569 22 22 20.6569 22 19V6C22 4.34315 20.6569 3 19 3H5C3.34315 3 2 4.34315 2 6V19C2 20.6569 3.34315 22 5 22Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <g fill={props.color || 'currentColor'} fillRule="evenodd">
          <path d="M17,3.5 C17.2812514,3.5 17.5182282,3.5963532 17.7109375,3.7890625 C17.9036468,3.9817718 18,4.21874859 18,4.5 L18,17 C18,17.2708347 17.9036468,17.5052073 17.7109375,17.703125 C17.5182282,17.9010427 17.2812514,18 17,18 L3,18 C2.71874859,18 2.4817718,17.9010427 2.2890625,17.703125 C2.0963532,17.5052073 2,17.2708347 2,17 L2,4.5 C2,4.21874859 2.0963532,3.9817718 2.2890625,3.7890625 C2.4817718,3.5963532 2.71874859,3.5 3,3.5 L7,3.5 L7,2.5 C7,2.36458266 7.04947867,2.24739633 7.1484375,2.1484375 C7.24739633,2.04947867 7.36458266,2 7.5,2 C7.63541734,2 7.75260367,2.04947867 7.8515625,2.1484375 C7.95052133,2.24739633 8,2.36458266 8,2.5 L8,3.5 L12,3.5 L12,2.5 C12,2.36458266 12.0494787,2.24739633 12.1484375,2.1484375 C12.2473963,2.04947867 12.3645827,2 12.5,2 C12.6354173,2 12.7526037,2.04947867 12.8515625,2.1484375 C12.9505213,2.24739633 13,2.36458266 13,2.5 L13,3.5 L17,3.5 Z M17,17 L17,4.5 L13,4.5 L13,5 C13,5.13541734 12.9505213,5.25260367 12.8515625,5.3515625 C12.7526037,5.45052133 12.6354173,5.5 12.5,5.5 C12.3645827,5.5 12.2473963,5.45052133 12.1484375,5.3515625 C12.0494787,5.25260367 12,5.13541734 12,5 L12,4.5 L8,4.5 L8,5 C8,5.13541734 7.95052133,5.25260367 7.8515625,5.3515625 C7.75260367,5.45052133 7.63541734,5.5 7.5,5.5 C7.36458266,5.5 7.24739633,5.45052133 7.1484375,5.3515625 C7.04947867,5.25260367 7,5.13541734 7,5 L7,4.5 L3,4.5 L3,17 L17,17 Z" />
          <path
            fillRule="nonzero"
            d="M9,8.5 C9,7.94771525 9.44771525,7.5 10,7.5 C10.5522847,7.5 11,7.94771525 11,8.5 L11,13.8786797 C11,14.4309644 10.5522847,14.8786797 10,14.8786797 C9.44771525,14.8786797 9,14.4309644 9,13.8786797 L9,8.5 Z"
          />
          <path
            fillRule="nonzero"
            d="M12.6893398,10.1893398 C13.2416246,10.1893398 13.6893398,10.6370551 13.6893398,11.1893398 C13.6893398,11.7416246 13.2416246,12.1893398 12.6893398,12.1893398 L7.31066017,12.1893398 C6.75837542,12.1893398 6.31066017,11.7416246 6.31066017,11.1893398 C6.31066017,10.6370551 6.75837542,10.1893398 7.31066017,10.1893398 L12.6893398,10.1893398 Z"
          />
        </g>
      </IconBase>
    )
  },
  calendar2: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 1V3M17 1V3M2 8H22M7.5 13H9.5M14.5 13H16.5M7.5 17H9.5M14.5 17H16.5M5 22H19C20.6569 22 22 20.6569 22 19V6C22 4.34315 20.6569 3 19 3H5C3.34315 3 2 4.34315 2 6V19C2 20.6569 3.34315 22 5 22Z"
              stroke="#121212"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 3.73914C1 3.18685 1.44772 2.73914 2 2.73914H20C20.5523 2.73914 21 3.18685 21 3.73914V20C21 20.5523 20.5523 21 20 21H2C1.44772 21 1 20.5523 1 20V3.73914Z"
            stroke="#474747"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.34778 1V5.34783"
            stroke="#474747"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.6522 1V5.34783"
            stroke="#474747"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1 7.08691H21"
            stroke="#474747"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </IconBase>
    )
  },
  help: (props: IconBaseProps) => (
    <IconBase {...props}>
      <svg viewBox="0 0 200 200">
        <path
          d="m165.33 113.44a103.61 103.61 0 1 1 -207.22 0 103.61 103.61 0 1 1 207.22 0z"
          transform="matrix(.93739 0 0 .93739 42.143 -6.3392)"
          fill="#fff"
        />
        <g>
          <path
            d="m100 0c-55.2 0-100 44.8-100 100-5.0495e-15 55.2 44.8 100 100 100s100-44.8 100-100-44.8-100-100-100zm0 12.812c48.13 0 87.19 39.058 87.19 87.188s-39.06 87.19-87.19 87.19-87.188-39.06-87.188-87.19 39.058-87.188 87.188-87.188zm1.47 21.25c-5.45 0.03-10.653 0.737-15.282 2.063-4.699 1.346-9.126 3.484-12.876 6.219-3.238 2.362-6.333 5.391-8.687 8.531-4.159 5.549-6.461 11.651-7.063 18.687-0.04 0.468-0.07 0.868-0.062 0.876 0.016 0.016 21.702 2.687 21.812 2.687 0.053 0 0.113-0.234 0.282-0.937 1.941-8.085 5.486-13.521 10.968-16.813 4.32-2.594 9.808-3.612 15.778-2.969 2.74 0.295 5.21 0.96 7.38 2 2.71 1.301 5.18 3.361 6.94 5.813 1.54 2.156 2.46 4.584 2.75 7.312 0.08 0.759 0.05 2.48-0.03 3.219-0.23 1.826-0.7 3.378-1.5 4.969-0.81 1.597-1.48 2.514-2.76 3.812-2.03 2.077-5.18 4.829-10.78 9.407-3.6 2.944-6.04 5.156-8.12 7.343-4.943 5.179-7.191 9.069-8.564 14.719-0.905 3.72-1.256 7.55-1.156 13.19 0.025 1.4 0.062 2.73 0.062 2.97v0.43h21.598l0.03-2.4c0.03-3.27 0.21-5.37 0.56-7.41 0.57-3.27 1.43-5 3.94-7.81 1.6-1.8 3.7-3.76 6.93-6.47 4.77-3.991 8.11-6.99 11.26-10.125 4.91-4.907 7.46-8.26 9.28-12.187 1.43-3.092 2.22-6.166 2.46-9.532 0.06-0.816 0.07-3.03 0-3.968-0.45-7.043-3.1-13.253-8.15-19.032-0.8-0.909-2.78-2.887-3.72-3.718-4.96-4.394-10.69-7.353-17.56-9.094-4.19-1.062-8.23-1.6-13.35-1.75-0.78-0.023-1.59-0.036-2.37-0.032zm-10.908 103.6v22h21.998v-22h-21.998z"
            fill={props.color || 'currentColor'}
          />
        </g>
      </svg>
    </IconBase>
  ),
  lock: (props: IconBaseProps) => (
    <IconBase {...props}>
      <svg viewBox="0 0 30 30">
        <title />
        <desc />
        <defs />
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g fill={props.color}>
            <path d="M16,21.9146472 L16,24.5089948 C16,24.7801695 16.2319336,25 16.5,25 C16.7761424,25 17,24.7721195 17,24.5089948 L17,21.9146472 C17.5825962,21.708729 18,21.1531095 18,20.5 C18,19.6715728 17.3284272,19 16.5,19 C15.6715728,19 15,19.6715728 15,20.5 C15,21.1531095 15.4174038,21.708729 16,21.9146472 L16,21.9146472 Z M9,14.0000125 L9,10.499235 C9,6.35670485 12.3578644,3 16.5,3 C20.6337072,3 24,6.35752188 24,10.499235 L24,14.0000125 C25.6591471,14.0047488 27,15.3503174 27,17.0094776 L27,26.9905224 C27,28.6633689 25.6529197,30 23.991212,30 L9.00878799,30 C7.34559019,30 6,28.652611 6,26.9905224 L6,17.0094776 C6,15.339581 7.34233349,14.0047152 9,14.0000125 L9,14.0000125 L9,14.0000125 Z M12,14 L12,10.5008537 C12,8.0092478 14.0147186,6 16.5,6 C18.9802243,6 21,8.01510082 21,10.5008537 L21,14 L12,14 L12,14 L12,14 Z" />
          </g>
        </g>
      </svg>
    </IconBase>
  ),
  viewEye: (props: IconBaseProps) => {
    return (
      <IconBase {...props}>
        <svg
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.88982 8.83745C1.59207 8.31885 1.59207 7.6814 1.88981 7.1628C3.45648 4.43406 5.96236 2.66675 8.78637 2.66675C11.6104 2.66675 14.1162 4.43404 15.6829 7.16274C15.9806 7.68134 15.9806 8.31879 15.6829 8.83739C14.1162 11.5661 11.6103 13.3334 8.78634 13.3334C5.96235 13.3334 3.45648 11.5662 1.88982 8.83745Z"
            stroke="white"
            strokeWidth="1.5"
          />
          <path
            d="M10.7863 8.00008C10.7863 9.10465 9.89086 10.0001 8.7863 10.0001C7.68173 10.0001 6.7863 9.10465 6.7863 8.00008C6.7863 6.89551 7.68173 6.00008 8.7863 6.00008C9.89086 6.00008 10.7863 6.89551 10.7863 8.00008Z"
            stroke="white"
            strokeWidth="1.5"
          />
        </svg>
      </IconBase>
    )
  },
  closedEye: (props: IconBaseProps) => {
    return (
      <IconBase {...props}>
        <svg
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.31663 1.46967C5.02373 1.17678 4.54886 1.17678 4.25597 1.46967C3.96307 1.76256 3.96307 2.23744 4.25597 2.53033L5.31663 1.46967ZM14.9226 13.197C15.2155 13.4899 15.6904 13.4899 15.9833 13.197C16.2762 12.9041 16.2762 12.4292 15.9833 12.1363L14.9226 13.197ZM1.88982 9.20825L2.54024 8.83482L1.88982 9.20825ZM1.88981 7.5336L1.23939 7.16016L1.88981 7.5336ZM15.6829 7.53354L15.0325 7.90697V7.90697L15.6829 7.53354ZM15.1224 8.61977C15.0117 9.01893 15.2456 9.43222 15.6447 9.54288C16.0439 9.65354 16.4572 9.41967 16.5678 9.02051L15.1224 8.61977ZM11.2444 2.70187C10.8528 2.56682 10.4259 2.77479 10.2908 3.16637C10.1558 3.55796 10.3637 3.98487 10.7553 4.11991L11.2444 2.70187ZM14.6199 11.859C14.9103 11.5636 14.9062 11.0888 14.6108 10.7984C14.3153 10.508 13.8405 10.5121 13.5501 10.8075L14.6199 11.859ZM6.49796 4.23981C6.88172 4.08393 7.06646 3.64647 6.91058 3.2627C6.75469 2.87894 6.31723 2.69421 5.93346 2.85009L6.49796 4.23981ZM4.25597 2.53033L14.9226 13.197L15.9833 12.1363L5.31663 1.46967L4.25597 2.53033ZM8.78634 12.9542C6.29956 12.9542 4.01125 11.3969 2.54024 8.83482L1.2394 9.58169C2.90171 12.477 5.62514 14.4542 8.78634 14.4542V12.9542ZM1.23939 7.16016C0.808872 7.91002 0.808875 8.83183 1.2394 9.58169L2.54024 8.83482C2.37526 8.54747 2.37526 8.19438 2.54024 7.90703L1.23939 7.16016ZM15.0325 7.90697C15.1581 8.12572 15.1881 8.38266 15.1224 8.61977L16.5678 9.02051C16.7393 8.40201 16.6612 7.73123 16.3333 7.1601L15.0325 7.90697ZM10.7553 4.11991C12.4509 4.70465 13.9618 6.04213 15.0325 7.90697L16.3333 7.1601C15.1198 5.04651 13.3482 3.42742 11.2444 2.70187L10.7553 4.11991ZM13.5501 10.8075C12.2068 12.1743 10.5519 12.9542 8.78634 12.9542V14.4542C11.0189 14.4542 13.0434 13.463 14.6199 11.859L13.5501 10.8075ZM2.54024 7.90703C3.54289 6.16066 4.93262 4.87564 6.49796 4.23981L5.93346 2.85009C4.00258 3.6344 2.37651 5.17958 1.23939 7.16016L2.54024 7.90703ZM9.99859 8.06624C10.0648 8.3295 10.0434 8.60714 9.93783 8.85721L11.3197 9.44074C11.552 8.8906 11.5989 8.27978 11.4533 7.7006L9.99859 8.06624ZM9.93783 8.85721C9.83223 9.10728 9.6481 9.31617 9.41326 9.45232L10.1656 10.75C10.6823 10.4505 11.0874 9.99089 11.3197 9.44074L9.93783 8.85721ZM9.41326 9.45232C9.17843 9.58848 8.90566 9.64448 8.63617 9.61188L8.45603 11.101C9.04889 11.1727 9.64899 11.0495 10.1656 10.75L9.41326 9.45232ZM8.63617 9.61188C8.36669 9.57928 8.11514 9.45985 7.91955 9.27162L6.87945 10.3525C7.30976 10.7665 7.86316 11.0293 8.45603 11.101L8.63617 9.61188ZM7.91955 9.27162C7.72395 9.0834 7.59495 8.83663 7.55202 8.56859L6.07089 8.80578C6.16533 9.39546 6.44914 9.93837 6.87945 10.3525L7.91955 9.27162ZM7.55202 8.56859C7.5091 8.30056 7.55459 8.02584 7.68163 7.78595L6.35602 7.08397C6.07655 7.61172 5.97646 8.21611 6.07089 8.80578L7.55202 8.56859ZM7.68163 7.78595C7.80866 7.54606 8.01033 7.35404 8.25616 7.23892L7.62 5.8805C7.07918 6.13377 6.6355 6.55621 6.35602 7.08397L7.68163 7.78595ZM8.25616 7.23892C8.50199 7.12379 8.77861 7.09182 9.04422 7.14783L9.35372 5.68011C8.76938 5.55689 8.16082 5.62723 7.62 5.8805L8.25616 7.23892Z"
            fill="white"
          />
        </svg>
      </IconBase>
    )
  },
  dashboard: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 2 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 14V22M9 12V22M15 8V22M21 2V22"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props}>
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <g transform="translate(1.000000, 1.000000)">
            <path
              d="M0,0 L0,17.5714286 C0,17.8081218 0.191877986,18 0.428571429,18 L18,18"
              stroke={props.color || 'currentColor'}
            />
            <path
              d="M0,0 L0,17.5714286 C0,17.8081218 0.191877986,18 0.428571429,18 L18,18"
              stroke={props.color || 'currentColor'}
            />
            <path
              d="M4,16 L3,16 C2.7238574,16 2.5,15.7850964 2.5,15.52 L2.5,4.48 C2.5,4.21490358 2.7238574,4 3,4 L4,4 C4.2761426,4 4.5,4.21490358 4.5,4.48 L4.5,15.52 C4.5,15.7850964 4.2761426,16 4,16 Z"
              stroke={props.color || 'currentColor'}
            />
            <path
              d="M8.5,16 L7.5,16 C7.2238579,16 7,15.7761421 7,15.5 L7,9 C7,8.7238579 7.2238579,8.5 7.5,8.5 L8.5,8.5 C8.7761421,8.5 9,8.7238579 9,9 L9,15.5 C9,15.7761421 8.7761421,16 8.5,16 Z"
              stroke={props.color || 'currentColor'}
            />
            <path
              d="M13,16 L12,16 C11.7238579,16 11.5,15.8081218 11.5,15.5714286 L11.5,1.42857143 C11.5,1.19187799 11.7238579,1 12,1 L13,1 C13.2761421,1 13.5,1.19187799 13.5,1.42857143 L13.5,15.5714286 C13.5,15.8081218 13.2761421,16 13,16 Z"
              stroke={props.color || 'currentColor'}
            />
            <path
              d="M17.5,16 L16.5,16 C16.2238579,16 16,15.7761421 16,15.5 L16,12.5 C16,12.2238579 16.2238579,12 16.5,12 L17.5,12 C17.7761421,12 18,12.2238579 18,12.5 L18,15.5 C18,15.7761421 17.7761421,16 17.5,16 Z"
              stroke={props.color || 'currentColor'}
            />
          </g>
        </g>
      </IconBase>
    )
  },
  addPicture: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.11558 13.4913C3.83463 13.7957 3.85361 14.2702 4.15798 14.5511C4.46234 14.8321 4.93684 14.8131 5.21779 14.5087L4.11558 13.4913ZM11.8147 6.25627L12.3659 6.76498L11.8147 6.25627ZM13.6388 6.1287L14.1137 5.54823V5.54823L13.6388 6.1287ZM15.8584 8.9138C16.179 9.1761 16.6515 9.12885 16.9138 8.80826C17.1761 8.48768 17.1289 8.01516 16.8083 7.75287L15.8584 8.9138ZM3.25002 8.66667C3.25002 9.08088 3.58581 9.41667 4.00002 9.41667C4.41423 9.41667 4.75002 9.08088 4.75002 8.66667H3.25002ZM8.58335 8.66667C8.58335 9.08088 8.91914 9.41667 9.33335 9.41667C9.74757 9.41667 10.0834 9.08088 10.0834 8.66667H8.58335ZM3.00002 2.75H15V1.25H3.00002V2.75ZM15.5834 3.33333V12.6667H17.0834V3.33333H15.5834ZM15 13.25H3.00002V14.75H15V13.25ZM2.41669 12.6667V3.33333H0.916687V12.6667H2.41669ZM3.00002 13.25C2.67785 13.25 2.41669 12.9888 2.41669 12.6667H0.916687C0.916687 13.8173 1.84943 14.75 3.00002 14.75V13.25ZM15.5834 12.6667C15.5834 12.9888 15.3222 13.25 15 13.25V14.75C16.1506 14.75 17.0834 13.8173 17.0834 12.6667H15.5834ZM15 2.75C15.3222 2.75 15.5834 3.01117 15.5834 3.33333H17.0834C17.0834 2.18274 16.1506 1.25 15 1.25V2.75ZM3.00002 1.25C1.84943 1.25 0.916687 2.18274 0.916687 3.33333H2.41669C2.41669 3.01117 2.67785 2.75 3.00002 2.75V1.25ZM5.21779 14.5087L12.3659 6.76498L11.2636 5.74756L4.11558 13.4913L5.21779 14.5087ZM13.1639 6.70917L15.8584 8.9138L16.8083 7.75287L14.1137 5.54823L13.1639 6.70917ZM12.3659 6.76498C12.5752 6.53818 12.925 6.51372 13.1639 6.70917L14.1137 5.54823C13.2606 4.8502 12.0113 4.93757 11.2636 5.74756L12.3659 6.76498ZM1.13636 7.197L6.30302 12.3637L7.36368 11.303L2.19702 6.13634L1.13636 7.197ZM4.75002 8.66667C4.75002 8.69815 4.74704 8.63018 4.8479 8.46668C4.93846 8.31988 5.08159 8.14808 5.27122 7.98434C5.65636 7.6518 6.15564 7.41667 6.66669 7.41667V5.91667C5.70498 5.91667 4.87092 6.3482 4.29092 6.84899C3.99798 7.10193 3.75059 7.38845 3.57126 7.67916C3.40224 7.95316 3.25002 8.30185 3.25002 8.66667H4.75002ZM6.66669 7.41667C7.17774 7.41667 7.67701 7.6518 8.06216 7.98434C8.25179 8.14808 8.39492 8.31988 8.48547 8.46668C8.58633 8.63018 8.58335 8.69815 8.58335 8.66667H10.0834C10.0834 8.30185 9.93114 7.95315 9.76211 7.67916C9.58279 7.38845 9.33539 7.10193 9.04245 6.84899C8.46245 6.3482 7.6284 5.91667 6.66669 5.91667V7.41667Z"
              fill={props.color || 'currentColor'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase viewBox="0 -20 512 512" {...props}>
        <path d="m432 0h-352c-44.113281 0-80 35.886719-80 80v280c0 44.113281 35.886719 80 80 80h190c7.628906 0 14.59375-4.339844 17.957031-11.191406 3.359375-6.847656 2.53125-15.015625-2.140625-21.046875l-52.3125-67.609375 144.992188-184.425782 93.503906 111.546876v33.726562c0 11.046875 8.953125 20 20 20s20-8.953125 20-20v-221c0-44.113281-35.886719-80-80-80zm-38.671875 111.152344c-3.871094-4.617188-9.609375-7.253906-15.640625-7.148438-6.027344.09375-11.6875 2.898438-15.410156 7.636719l-154.015625 195.894531-52.445313-67.773437c-3.789062-4.898438-9.628906-7.761719-15.816406-7.761719-.007812 0-.019531 0-.027344 0-6.199218.007812-12.046875 2.890625-15.824218 7.804688l-44.015626 57.21875c-6.734374 8.757812-5.097656 21.3125 3.65625 28.046874 8.757813 6.738282 21.3125 5.097657 28.046876-3.65625l28.210937-36.671874 89.1875 115.257812h-149.234375c-22.054688 0-40-17.945312-40-40v-280c0-22.054688 17.945312-40 40-40h352c22.054688 0 40 17.945312 40 40v125.007812zm-253.328125-39.152344c-33.085938 0-60 26.914062-60 60s26.914062 60 60 60 60-26.914062 60-60-26.914062-60-60-60zm0 80c-11.027344 0-20-8.972656-20-20s8.972656-20 20-20 20 8.972656 20 20-8.972656 20-20 20zm372 229c0 11.046875-8.953125 20-20 20h-55v55c0 11.046875-8.953125 20-20 20s-20-8.953125-20-20v-55h-55c-11.046875 0-20-8.953125-20-20s8.953125-20 20-20h55v-55c0-11.046875 8.953125-20 20-20s20 8.953125 20 20v55h55c11.046875 0 20 8.953125 20 20zm0 0" />
      </IconBase>
    )
  },
  addFile: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.654 8.11147L8.05436 14.7111C8.05436 14.7111 4.99023 17.7753 2.1618 14.9468C-0.666626 12.1184 2.3975 9.05428 2.3975 9.05428L9.23287 2.21891C9.23287 2.21891 11.1185 0.333296 13.0041 2.21891C14.8897 4.10453 13.0041 5.99015 13.0041 5.99015L6.40444 12.5898C6.40444 12.5898 5.46163 13.5326 4.51882 12.5898C3.57601 11.647 4.51882 10.7042 4.51882 10.7042L10.6471 4.57594"
              stroke={props.color || 'currentColor'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase viewBox="0 0 370.32 370.32" {...props}>
        <path
          d="M316.242,223.775h-10.051v-10.051c0-14.585-6.906-27.579-17.611-35.91V73.703
          c0-3.934-1.561-7.705-4.344-10.483L225.361,4.34C222.576,1.562,218.811,0,214.877,0H37.691C21.639,0,8.58,13.061,8.58,29.113
          v312.095c0,16.054,13.058,29.112,29.111,29.112h221.777h1.225c25.088,0,45.498-20.41,45.498-45.498v-10.051h10.051
          c25.088,0,45.498-20.41,45.498-45.498S341.33,223.775,316.242,223.775z M40.193,337.907V32.414h154.088v43.577
          c0,10.554,8.555,19.106,19.105,19.106h43.58v73.294c-23.35,1.903-41.771,21.501-41.771,45.333v10.051h-10.051
          c-25.088,0-45.498,20.41-45.498,45.498s20.41,45.498,45.498,45.498h10.051v10.051c0,4.548,0.678,8.939,1.926,13.085H40.193z
          M316.107,289.205h-35.051v35.051c0,11.303-9.195,20.498-20.498,20.498c-11.303,0-20.498-9.195-20.498-20.498v-35.051H205.01
          c-11.303,0-20.498-9.195-20.498-20.498c0-11.303,9.195-20.498,20.498-20.498h35.051v-35.051c0-11.303,9.195-20.498,20.498-20.498
          c11.303,0,20.498,9.195,20.498,20.498v35.051h35.051c11.303,0,20.498,9.195,20.498,20.498
          C336.605,280.01,327.41,289.205,316.107,289.205z"
        />
      </IconBase>
    )
  },
  'file-box': (props: IconBaseProps) => (
    <IconBase {...props}>
      <svg viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M17 1H1V5.02632H17V1Z"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.6842 5.47369V14.4211H15.3158V5.47369"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.89478 7.9715H10.6842"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  ),
  groupTask: (props: IconBaseProps) => (
    <IconBase {...props} viewBox="0 0 22 20" fill="none">
      <path
        d="M10.9179 12.2255C12.6981 12.2255 13.8811 9.85743 14.0538 9.25761C14.0869 9.128 14.2728 9.13939 14.3891 8.91209C15.1592 7.40797 14.2653 7.1402 14.2653 7.1402C14.2653 7.1402 14.3147 6.24161 14.0911 5.39737C14.0911 5.39737 13.5266 3.30206 10.9179 3.30206C8.30919 3.30206 7.7447 5.39737 7.7447 5.39737C7.52113 6.24161 7.57049 7.1402 7.57049 7.1402C7.57049 7.1402 6.67663 7.50393 7.43468 8.9049C7.547 9.11248 7.71056 9.08482 7.78206 9.25761C7.95471 9.85743 9.13771 12.2255 10.9179 12.2255Z"
        stroke="#414141"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9442 11.7323C12.9442 11.7323 13.6557 12.3489 14.9225 12.8282C17.1136 13.6573 17.8293 15.5453 17.9691 17.8435C18.001 18.3679 17.5736 18.9228 17.0482 18.9228H11.1485H5.18585C4.65129 18.9228 4.23485 18.3536 4.26619 17.82C4.40477 15.4601 5.11954 13.7159 7.3133 12.8858C8.58015 12.4064 9.24521 11.7611 9.24521 11.7611"
        stroke="#414141"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.62314 15.6986H1.92484C1.42087 15.6986 1.01087 15.1777 1.00332 14.6738C0.977671 12.9606 1.04829 11.3849 3.16794 10.5828C4.43479 10.1035 5.54433 9.36583 5.54433 9.36583C4.65193 8.81853 3.7512 7.36677 3.63672 6.96904C3.56522 6.79625 3.40167 6.81671 3.28934 6.60913C2.53129 5.20816 3.42515 4.84084 3.42515 4.84084C3.42515 4.84084 3.37579 3.94044 3.59936 3.09621C3.59936 3.09621 4.16385 1 6.77257 1C9.3813 1 9.94579 3.21 9.94579 3.21"
        stroke="#414141"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5197 15.6986H20.0752C20.5792 15.6986 20.9892 15.1777 20.9967 14.6738C21.0224 12.9606 20.9517 11.3849 18.8321 10.5828C17.5652 10.1035 16.4546 9.30791 16.4546 9.30791C17.4046 8.87611 18.2488 7.36677 18.3633 6.96904C18.4348 6.79625 18.5984 6.81671 18.7107 6.60913C19.4687 5.20816 18.5749 4.84084 18.5749 4.84084C18.5749 4.84084 18.6242 3.94044 18.4007 3.09621C18.4007 3.09621 17.8362 1 15.2275 1C12.6187 1 12.1257 3.21 12.1257 3.21"
        stroke="#414141"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  helpIcon: (props: IconBaseProps) => (
    <IconBase {...props} viewBox="0 0 18 18" fill="none" fillRule="evenodd">
      <g>
        <path
          d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
          stroke={props.color || 'currentColor'}
          strokeMiterlimit="10"
        />
        <path
          d="M9.00003 4.14287C7.45717 4.14287 6.31431 5.17144 6.20003 6.60001L6.14288 7.05715H7.28574L7.34288 6.7143C7.40003 5.85715 8.08574 5.28573 9.05717 5.28573C10.0857 5.28573 10.7143 5.85715 10.7143 6.82858C10.7143 7.74287 10.2572 8.14287 9.6286 8.65715C9.05717 9.17144 8.37145 9.80001 8.37145 11V11.6286H9.51431V11C9.51431 10.3143 9.91431 9.97144 10.4857 9.45715C11.1143 8.94287 11.9143 8.25715 11.9143 6.82858C11.8572 5.28573 10.6572 4.14287 9.00003 4.14287Z"
          stroke={props.color || 'currentColor'}
        />
        <path
          d="M8.31427 12.7143V13.8H9.45713V12.7143C9.45713 12.7143 9.45713 12.7143 9.45713 12.6571L8.31427 12.7143Z"
          stroke={props.color || 'currentColor'}
        />
      </g>
    </IconBase>
  ),
  supportIcon: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 14V13.2295C12 12.2364 12.7627 11.4167 13.6133 10.9041C14.4344 10.4092 15.2185 9.5295 15 7.99999C14.5714 4.99997 10.5 6.5 10.5 6.5M12 17V17.5M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props} viewBox="3 -5 18 32" fill="none" fillRule="evenodd">
        <g>
          <path
            d="M7.54529 4.8999V13.5549C7.54523 16.2889 9.09819 18.7865 11.5527 19.9999"
            stroke={props.color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.5703 2.48395C21.5703 2.14256 21.3958 1.82476 21.1075 1.64108C20.8192 1.4574 20.4569 1.43322 20.1467 1.57695C16.3046 3.35595 12.5096 4.96395 4.53883 4.99995H3.53698C1.87706 4.99995 0.531433 6.3431 0.531433 7.99995V9.99995C0.531433 11.6568 1.87706 13 3.53698 13H4.53883C12.5096 13.036 16.3046 14.644 20.1467 16.423C20.4569 16.5667 20.8192 16.5425 21.1075 16.3588C21.3958 16.1751 21.5703 15.8573 21.5703 15.516V2.48395Z"
            stroke={props.color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.5712 7H22.0722C22.9021 7 23.5749 7.67157 23.5749 8.5V9.5C23.5749 10.3284 22.9021 11 22.0722 11H21.5712"
            stroke={props.color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </IconBase>
    )
  },
  garbage: (props: IconBaseProps) => (
    <IconBase {...props} fill="none" viewBox="0 0 20 20">
      <path
        d="M2.5 5H4.16667H17.5"
        stroke={props.color || 'currentColor'}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66675 4.99984V3.33317C6.66675 2.89114 6.84234 2.46722 7.1549 2.15466C7.46746 1.8421 7.89139 1.6665 8.33342 1.6665H11.6667C12.1088 1.6665 12.5327 1.8421 12.8453 2.15466C13.1578 2.46722 13.3334 2.89114 13.3334 3.33317V4.99984M15.8334 4.99984V16.6665C15.8334 17.1085 15.6578 17.5325 15.3453 17.845C15.0327 18.1576 14.6088 18.3332 14.1667 18.3332H5.83341C5.39139 18.3332 4.96746 18.1576 4.6549 17.845C4.34234 17.5325 4.16675 17.1085 4.16675 16.6665V4.99984H15.8334Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33325 9.1665V14.1665"
        stroke={props.color || 'currentColor'}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6667 9.1665V14.1665"
        stroke={props.color || 'currentColor'}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  resourceManagement: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.5566 2.54578C13.3993 0.614463 10.6007 0.614458 9.44338 2.54578L8.7445 3.71206C8.52246 4.08259 8.0841 4.26417 7.66509 4.15917L6.34622 3.82866C4.16223 3.28136 2.1833 5.26028 2.73061 7.44427L3.06111 8.76315C3.16612 9.18215 2.98454 9.62051 2.61401 9.84255L1.44773 10.5414C-0.483589 11.6987 -0.483595 14.4974 1.44772 15.6547L2.61401 16.3536C2.98454 16.5756 3.16612 17.014 3.06111 17.433L2.73061 18.7518C2.47832 19.7586 2.76749 20.7302 3.36219 21.4202L4.87712 20.1144C4.67845 19.8839 4.58679 19.5725 4.67062 19.238L5.00113 17.9191C5.32031 16.6454 4.76836 15.3129 3.64204 14.638L2.47575 13.9391C1.8404 13.5584 1.8404 12.6377 2.47575 12.257L3.64204 11.5581C4.76836 10.8832 5.32031 9.55066 5.00113 8.27698L4.67062 6.95811C4.49057 6.23964 5.14158 5.58862 5.86006 5.76867L7.17893 6.09918C8.45261 6.41836 9.78513 5.86641 10.4601 4.74009L11.1589 3.5738C11.5397 2.93845 12.4603 2.93845 12.8411 3.5738L13.5399 4.74009C14.2149 5.86642 15.5474 6.41836 16.8211 6.09918L18.1399 5.76867C18.8584 5.58862 19.5094 6.23964 19.3294 6.95811L18.9989 8.27698C18.6797 9.55067 19.2316 10.8832 20.358 11.5581L21.5242 12.257C22.1596 12.6377 22.1596 13.5584 21.5242 13.9391L20.358 14.638C19.2316 15.3129 18.6797 16.6454 18.9989 17.9191L19.3294 19.238C19.4132 19.5725 19.3216 19.8839 19.1229 20.1144L20.6378 21.4202C21.2325 20.7302 21.5217 19.7586 21.2694 18.7518L20.9389 17.433C20.8339 17.014 21.0155 16.5756 21.386 16.3536L22.5523 15.6547C24.4836 14.4974 24.4836 11.6987 22.5523 10.5414L21.386 9.84255C21.0155 9.62051 20.8339 9.18215 20.9389 8.76315L21.2694 7.44427C21.8167 5.26029 19.8378 3.28135 17.6538 3.82866L16.3349 4.15917C15.9159 4.26417 15.4775 4.08259 15.2555 3.71206L14.5566 2.54578ZM10.1692 12.6281C10.1692 11.7799 10.8997 11.0197 11.8924 11.0197C12.8851 11.0197 13.6156 11.7799 13.6156 12.6281C13.6156 13.4763 12.8851 14.2366 11.8924 14.2366C10.8997 14.2366 10.1692 13.4763 10.1692 12.6281ZM11.8924 9.01965C9.87714 9.01965 8.16921 10.5951 8.16921 12.6281C8.16921 14.6612 9.87714 16.2366 11.8924 16.2366C13.9077 16.2366 15.6156 14.6612 15.6156 12.6281C15.6156 10.5951 13.9077 9.01965 11.8924 9.01965ZM8.13018 19.831C9.02297 19.3886 10.4303 18.8451 11.8924 18.8451C13.3546 18.8451 14.7618 19.3886 15.6546 19.831C15.9288 19.9668 16.1261 20.247 16.1719 20.617L16.2073 20.9027H7.57752L7.6129 20.617C7.65873 20.247 7.856 19.9668 8.13018 19.831ZM11.8924 16.8451C9.984 16.8451 8.25248 17.5384 7.24228 18.0389C6.28786 18.5117 5.7452 19.4255 5.62807 20.3712L5.4536 21.7798C5.41836 22.0642 5.50689 22.3501 5.69671 22.5649C5.88652 22.7797 6.15938 22.9027 6.44601 22.9027H17.3388C17.6254 22.9027 17.8983 22.7797 18.0881 22.5649C18.2779 22.3501 18.3664 22.0642 18.3312 21.7798L18.1567 20.3712C18.0396 19.4255 17.4969 18.5117 16.5425 18.0389C15.5323 17.5384 13.8008 16.8451 11.8924 16.8451Z"
              fill={props.color || 'currentColor'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase {...props} fill="none" viewBox="0 0 35 37">
        <path
          d="M5.5 26.5V22.75C5.5 22.5511 5.57902 22.3603 5.71967 22.2197C5.86032 22.079 6.05109 22 6.25 22H28.75C28.9489 22 29.1397 22.079 29.2803 22.2197C29.421 22.3603 29.5 22.5511 29.5 22.75V26.5"
          stroke={props.color || 'currentColor'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5 17.5V26.5"
          stroke={props.color || 'currentColor'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.5 35.5C7.98528 35.5 10 33.4853 10 31C10 28.5147 7.98528 26.5 5.5 26.5C3.01472 26.5 1 28.5147 1 31C1 33.4853 3.01472 35.5 5.5 35.5Z"
          stroke={props.color || 'currentColor'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5 35.5C19.9853 35.5 22 33.4853 22 31C22 28.5147 19.9853 26.5 17.5 26.5C15.0147 26.5 13 28.5147 13 31C13 33.4853 15.0147 35.5 17.5 35.5Z"
          stroke={props.color || 'currentColor'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.5 35.5C31.9853 35.5 34 33.4853 34 31C34 28.5147 31.9853 26.5 29.5 26.5C27.0147 26.5 25 28.5147 25 31C25 33.4853 27.0147 35.5 29.5 35.5Z"
          stroke={props.color || 'currentColor'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.75 17.5C10.75 15.7098 11.4612 13.9929 12.727 12.727C13.9929 11.4612 15.7098 10.75 17.5 10.75C19.2902 10.75 21.0071 11.4612 22.273 12.727C23.5388 13.9929 24.25 15.7098 24.25 17.5H10.75Z"
          stroke={props.color || 'currentColor'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.4998 9.25C19.7779 9.25 21.6248 7.40318 21.6248 5.125C21.6248 2.84683 19.7779 1 17.4998 1C15.2216 1 13.3748 2.84683 13.3748 5.125C13.3748 7.40318 15.2216 9.25 17.4998 9.25Z"
          stroke={props.color || 'currentColor'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </IconBase>
    )
  },
  darkMode: (props: IconBaseProps) => (
    <IconBase {...props} viewBox="0 0 32 32">
      <path d="M29.716 21.357c-0.044-0.252-0.153-0.466-0.327-0.643-0.386-0.391-0.834-0.472-1.345-0.246-1.37 0.642-2.79 0.963-4.26 0.963-1.843 0-3.544-0.459-5.1-1.379s-2.79-2.166-3.699-3.74c-0.91-1.574-1.364-3.293-1.364-5.157 0-1.448 0.284-2.824 0.85-4.128s1.386-2.447 2.457-3.429c0.411-0.39 0.505-0.844 0.281-1.36-0.212-0.516-0.592-0.762-1.139-0.737-1.906 0.075-3.711 0.507-5.418 1.294s-3.173 1.823-4.4 3.108c-1.227 1.285-2.198 2.805-2.914 4.562s-1.074 3.599-1.074 5.526c0 1.965 0.38 3.841 1.14 5.63s1.781 3.331 3.064 4.628c1.283 1.297 2.809 2.33 4.577 3.098s3.624 1.152 5.567 1.152c2.79 0 5.365-0.765 7.725-2.295s4.126-3.573 5.297-6.13c0.1-0.227 0.128-0.466 0.084-0.717zM21.72 26.919c-1.613 0.775-3.316 1.162-5.11 1.162-1.619 0-3.166-0.321-4.642-0.963s-2.747-1.502-3.812-2.579c-1.065-1.077-1.915-2.361-2.55-3.854s-0.953-3.057-0.953-4.694c0-2.708 0.794-5.126 2.382-7.254s3.634-3.57 6.137-4.326c-1.295 2.078-1.943 4.326-1.943 6.744 0 2.292 0.56 4.414 1.681 6.367s2.647 3.494 4.577 4.628c1.93 1.134 4.028 1.7 6.296 1.7 0.697 0 1.383-0.057 2.055-0.17-1.133 1.385-2.507 2.465-4.119 3.239z" />
    </IconBase>
  ),
  chevronArrow: (props: IconBaseProps) => (
    <IconBase {...props}>
      <path
        d="M7.09703 10.0011L13 4.5522L11.9826 3.45L4.88555 10.0011L11.9826 16.5522L13 15.45L7.09703 10.0011Z"
        fill="#474747"
      />
    </IconBase>
  ),
  doubleArrow: (props: IconBaseProps) => (
    <IconBase {...props}>
      <path
        d="M4.09703 10.0011L10 4.5522L8.98258 3.45L1.88555 10.0011L8.98258 16.5522L10 15.45L4.09703 10.0011Z"
        fill={props.color || 'currentColor'}
      />
      <path
        d="M11.097 10.0011L17 4.5522L15.9826 3.45L8.88555 10.0011L15.9826 16.5522L17 15.45L11.097 10.0011Z"
        fill={props.color || 'currentColor'}
      />
    </IconBase>
  ),
  userThirdParty: (props: IconBaseProps) => (
    <IconBase {...props} fill="none" viewBox="0 0 29 26">
      <path
        d="M18.1704 10.8115C18.1704 11.4756 17.9604 12.0347 17.5405 12.4888C17.1255 12.9429 16.5664 13.2334 15.8633 13.3604V13.4043C16.7227 13.5117 17.377 13.7852 17.8262 14.2246C18.2754 14.6641 18.5 15.2549 18.5 15.9971C18.5 16.998 18.1582 17.7744 17.4746 18.3262C16.7959 18.873 15.8169 19.1465 14.5376 19.1465C13.4487 19.1465 12.499 18.9438 11.6885 18.5386V17.8135C12.0986 18.0283 12.5576 18.1968 13.0654 18.3188C13.5781 18.4409 14.0591 18.502 14.5083 18.502C15.5874 18.502 16.3979 18.2847 16.9399 17.8501C17.4819 17.4106 17.7529 16.793 17.7529 15.9971C17.7529 15.2891 17.4746 14.7446 16.918 14.3638C16.3662 13.9829 15.5532 13.7925 14.479 13.7925H13.3218V13.0894H14.4937C15.3823 13.0894 16.0854 12.8794 16.603 12.4595C17.1255 12.0347 17.3867 11.4609 17.3867 10.7383C17.3867 10.1426 17.1743 9.6665 16.7495 9.31006C16.3296 8.94873 15.7778 8.76807 15.0942 8.76807C14.562 8.76807 14.0762 8.84375 13.6367 8.99512C13.1973 9.1416 12.7041 9.39551 12.1572 9.75684L11.7983 9.26611C12.2134 8.91943 12.7139 8.646 13.2998 8.4458C13.8857 8.24072 14.479 8.13818 15.0796 8.13818C16.0659 8.13818 16.8276 8.37256 17.3647 8.84131C17.9019 9.30518 18.1704 9.96191 18.1704 10.8115Z"
        fill="#8F8F8F"
      />
      <circle cx="6" cy="8" r="3.5" stroke="#8F8F8F" />
      <path
        d="M7.5 19H1C1.16667 17 2.5 13 6.5 13C8.5 13 10 14.5 10 14.5"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9053 11.1338V13H20.6064V8.7168H21.626C22.1572 8.7168 22.5498 8.81543 22.8037 9.0127C23.0576 9.20801 23.1846 9.50293 23.1846 9.89746C23.1846 10.1846 23.1084 10.4268 22.9561 10.624C22.8057 10.8213 22.5762 10.9629 22.2676 11.0488L23.4307 13H23.0732L21.9688 11.1338H20.9053ZM20.9053 10.876H21.7227C22.084 10.876 22.3643 10.7959 22.5635 10.6357C22.7627 10.4736 22.8623 10.2354 22.8623 9.9209C22.8623 9.59473 22.7646 9.35742 22.5693 9.20898C22.374 9.06055 22.0557 8.98633 21.6143 8.98633H20.9053V10.876ZM27.6268 10.8174C27.6268 11.5361 27.4383 12.0801 27.0613 12.4492C26.6844 12.8164 26.1307 13 25.4002 13H24.3748V8.7168H25.532C26.2156 8.7168 26.7352 8.89551 27.0906 9.25293C27.448 9.61035 27.6268 10.1318 27.6268 10.8174ZM27.3016 10.8291C27.3016 10.2158 27.1453 9.75488 26.8328 9.44629C26.5223 9.13574 26.0652 8.98047 25.4617 8.98047H24.6736V12.7363H25.3826C26.6619 12.7363 27.3016 12.1006 27.3016 10.8291Z"
        fill="#8F8F8F"
      />
    </IconBase>
  ),
  addSquare: (props: IconBaseProps) => (
    <IconBase {...props} fill="none" viewBox="0 0 24 24">
      <path
        d="M12 6V18"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 12H6"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 1H2C1.44772 1 1 1.44772 1 2V22C1 22.5523 1.44772 23 2 23H22C22.5523 23 23 22.5523 23 22V2C23 1.44772 22.5523 1 22 1Z"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  skillSquareCheck: (props: IconBaseProps) => (
    <IconBase {...props} fill="none" viewBox="0 0 24 24">
      <path
        d="M18 6.99902L11 16.499L6 12.499"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5 0.499023H1.5C0.947715 0.499023 0.5 0.946739 0.5 1.49902V22.499C0.5 23.0513 0.947715 23.499 1.5 23.499H22.5C23.0523 23.499 23.5 23.0513 23.5 22.499V1.49902C23.5 0.946739 23.0523 0.499023 22.5 0.499023Z"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  arrowUp2: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    // this and arrowUp2 should be removed and replaced with 'sort' if possible
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.7071 17.2929C2.31657 16.9024 1.68341 16.9024 1.29289 17.2929C0.902366 17.6834 0.902372 18.3166 1.2929 18.7071L2.7071 17.2929ZM6 21.9999L5.2929 22.707C5.68342 23.0976 6.31658 23.0976 6.7071 22.707L6 21.9999ZM10.7071 18.7071C11.0976 18.3166 11.0976 17.6834 10.7071 17.2929C10.3166 16.9024 9.68343 16.9024 9.2929 17.2929L10.7071 18.7071ZM5.03174 20.7355C5.03312 21.2878 5.48195 21.7344 6.03423 21.7331C6.58651 21.7317 7.03311 21.2828 7.03173 20.7306L5.03174 20.7355ZM7 7.99752C6.99862 7.44524 6.54979 6.99864 5.99751 7.00002C5.44522 7.00139 4.99863 7.45022 5 8.00251L7 7.99752ZM13.2929 5.29282C12.9024 5.68334 12.9024 6.3165 13.2929 6.70703C13.6834 7.09756 14.3166 7.09756 14.7071 6.70704L13.2929 5.29282ZM18 2L18.7071 1.29289C18.3166 0.902371 17.6834 0.902371 17.2929 1.29289L18 2ZM21.2929 6.70704C21.6834 7.09756 22.3166 7.09756 22.7071 6.70703C23.0976 6.3165 23.0976 5.68334 22.7071 5.29282L21.2929 6.70704ZM19.0317 3.26937C19.0331 2.71709 18.5865 2.26826 18.0342 2.26688C17.4819 2.2655 17.0331 2.7121 17.0317 3.26439L19.0317 3.26937ZM17 15.9975C16.9986 16.5498 17.4452 16.9986 17.9975 17C18.5498 17.0014 18.9986 16.5548 19 16.0025L17 15.9975ZM1.2929 18.7071L5.2929 22.707L6.7071 21.2928L2.7071 17.2929L1.2929 18.7071ZM6.7071 22.707L10.7071 18.7071L9.2929 17.2929L5.2929 21.2928L6.7071 22.707ZM7.03173 20.7306L7 7.99752L5 8.00251L5.03174 20.7355L7.03173 20.7306ZM14.7071 6.70704L18.7071 2.70711L17.2929 1.29289L13.2929 5.29282L14.7071 6.70704ZM17.2929 2.70711L21.2929 6.70704L22.7071 5.29282L18.7071 1.29289L17.2929 2.70711ZM17.0317 3.26439L17 15.9975L19 16.0025L19.0317 3.26937L17.0317 3.26439Z"
              fill={props.color || 'currentColor'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase
        {...props}
        fill={props.fill || 'none'}
        viewBox={props.viewBox || '0 0 12 10'}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.73456 1.09403L1.66665 8.28111C1.61127 8.377 1.61076 8.49503 1.66532 8.59138C1.71988 8.68773 1.82135 8.74802 1.93206 8.74986H10.0679C10.1786 8.74802 10.2801 8.68773 10.3346 8.59138C10.3892 8.49503 10.3887 8.377 10.3333 8.28111L6.2654 1.09403C6.21179 0.997708 6.11021 0.937988 5.99998 0.937988C5.88975 0.937988 5.78817 0.997708 5.73456 1.09403Z"
          stroke={props.color || 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </IconBase>
    )
  },
  arrowDown2: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    // this and arrowUp2 should be removed and replaced with 'sort' if possible
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.7071 17.2929C2.31657 16.9024 1.68341 16.9024 1.29289 17.2929C0.902366 17.6834 0.902372 18.3166 1.2929 18.7071L2.7071 17.2929ZM6 21.9999L5.2929 22.707C5.68342 23.0976 6.31658 23.0976 6.7071 22.707L6 21.9999ZM10.7071 18.7071C11.0976 18.3166 11.0976 17.6834 10.7071 17.2929C10.3166 16.9024 9.68343 16.9024 9.2929 17.2929L10.7071 18.7071ZM5.03174 20.7355C5.03312 21.2878 5.48195 21.7344 6.03423 21.7331C6.58651 21.7317 7.03311 21.2828 7.03173 20.7306L5.03174 20.7355ZM7 7.99752C6.99862 7.44524 6.54979 6.99864 5.99751 7.00002C5.44522 7.00139 4.99863 7.45022 5 8.00251L7 7.99752ZM13.2929 5.29282C12.9024 5.68334 12.9024 6.3165 13.2929 6.70703C13.6834 7.09756 14.3166 7.09756 14.7071 6.70704L13.2929 5.29282ZM18 2L18.7071 1.29289C18.3166 0.902371 17.6834 0.902371 17.2929 1.29289L18 2ZM21.2929 6.70704C21.6834 7.09756 22.3166 7.09756 22.7071 6.70703C23.0976 6.3165 23.0976 5.68334 22.7071 5.29282L21.2929 6.70704ZM19.0317 3.26937C19.0331 2.71709 18.5865 2.26826 18.0342 2.26688C17.4819 2.2655 17.0331 2.7121 17.0317 3.26439L19.0317 3.26937ZM17 15.9975C16.9986 16.5498 17.4452 16.9986 17.9975 17C18.5498 17.0014 18.9986 16.5548 19 16.0025L17 15.9975ZM1.2929 18.7071L5.2929 22.707L6.7071 21.2928L2.7071 17.2929L1.2929 18.7071ZM6.7071 22.707L10.7071 18.7071L9.2929 17.2929L5.2929 21.2928L6.7071 22.707ZM7.03173 20.7306L7 7.99752L5 8.00251L5.03174 20.7355L7.03173 20.7306ZM14.7071 6.70704L18.7071 2.70711L17.2929 1.29289L13.2929 5.29282L14.7071 6.70704ZM17.2929 2.70711L21.2929 6.70704L22.7071 5.29282L18.7071 1.29289L17.2929 2.70711ZM17.0317 3.26439L17 15.9975L19 16.0025L19.0317 3.26937L17.0317 3.26439Z"
              fill={props.color || 'currentColor'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase
        {...props}
        fill={props.fill || 'none'}
        viewBox={props.viewBox || '0 0 12 10'}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.99866 8.65583L10.0666 1.46875C10.122 1.37287 10.1225 1.25483 10.0679 1.15848C10.0133 1.06213 9.91187 1.00184 9.80116 1L1.66532 1C1.55461 1.00184 1.45314 1.06213 1.39858 1.15848C1.34402 1.25483 1.34453 1.37287 1.39991 1.46875L5.46782 8.65583C5.52143 8.75215 5.62301 8.81187 5.73324 8.81187C5.84347 8.81187 5.94505 8.75215 5.99866 8.65583Z"
          stroke={props.color || 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </IconBase>
    )
  },
  emptyDash: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 -1 16 2"
      fill="none"
    >
      <path
        d="M1 1H15"
        stroke={props.color || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  editPen: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.999 1.79989L16.5845 0.889831L16.4199 0.964831L16.2919 1.09278L16.999 1.79989ZM22.6559 7.45674L23.363 8.16385L23.4909 8.0359L23.5659 7.87123L22.6559 7.45674ZM8.25661 21.856L8.37576 22.8489L8.71916 22.8077L8.96372 22.5631L8.25661 21.856ZM1.82837 22.6274L0.835492 22.5083L0.683853 23.7719L1.94751 23.6203L1.82837 22.6274ZM2.59976 16.1992L1.89265 15.492L1.64809 15.7366L1.60688 16.08L2.59976 16.1992ZM16.999 1.79989C17.4135 2.70995 17.413 2.71016 17.4126 2.71036C17.4125 2.71042 17.412 2.71062 17.4117 2.71075C17.4112 2.711 17.4107 2.71123 17.4102 2.71145C17.4092 2.71188 17.4084 2.71225 17.4077 2.71255C17.4064 2.71316 17.4056 2.71351 17.4053 2.71363C17.4048 2.71386 17.4064 2.71314 17.4101 2.71159C17.4176 2.7085 17.4333 2.70214 17.4567 2.6935C17.5035 2.67617 17.5798 2.65006 17.6806 2.62276C17.8838 2.56772 18.1758 2.51066 18.5189 2.50593C19.185 2.49674 20.0654 2.68064 20.9203 3.53551L22.3345 2.1213C21.0343 0.821179 19.6006 0.490821 18.4913 0.506122C17.9466 0.513634 17.4856 0.603509 17.1577 0.692337C16.9929 0.736972 16.8592 0.782031 16.7624 0.817886C16.7138 0.835843 16.6743 0.851582 16.6445 0.863935C16.6296 0.870115 16.6171 0.875457 16.6071 0.879818C16.6021 0.881999 16.5977 0.883936 16.5939 0.88561C16.592 0.886448 16.5903 0.887219 16.5888 0.887924C16.588 0.888276 16.5872 0.888611 16.5865 0.888929C16.5862 0.889088 16.5857 0.889313 16.5855 0.889393C16.585 0.889614 16.5845 0.889831 16.999 1.79989ZM20.9203 3.53551C21.7751 4.39038 21.959 5.27078 21.9498 5.93691C21.9451 6.27993 21.888 6.57196 21.833 6.77514C21.8057 6.87592 21.7796 6.95229 21.7623 6.99911C21.7536 7.02244 21.7473 7.03816 21.7442 7.04563C21.7426 7.04936 21.7419 7.051 21.7421 7.05048C21.7423 7.05021 21.7426 7.0494 21.7432 7.04804C21.7435 7.04735 21.7439 7.04653 21.7443 7.04557C21.7445 7.04509 21.7448 7.04457 21.745 7.04402C21.7451 7.04375 21.7453 7.04331 21.7454 7.04317C21.7456 7.04272 21.7458 7.04226 22.6559 7.45674C23.5659 7.87123 23.5662 7.87075 23.5664 7.87026C23.5665 7.87009 23.5667 7.86959 23.5668 7.86924C23.5672 7.86854 23.5675 7.86779 23.5678 7.86701C23.5685 7.86545 23.5693 7.86373 23.5702 7.86185C23.5718 7.85809 23.5738 7.8537 23.5759 7.84869C23.5803 7.83867 23.5857 7.82616 23.5918 7.81125C23.6042 7.78143 23.6199 7.74192 23.6379 7.69341C23.6737 7.59655 23.7188 7.46285 23.7634 7.29808C23.8523 6.97017 23.9421 6.50918 23.9496 5.96449C23.9649 4.8552 23.6346 3.42142 22.3345 2.1213L20.9203 3.53551ZM21.9488 6.74964L7.54951 21.1489L8.96372 22.5631L23.363 8.16385L21.9488 6.74964ZM8.13747 20.8631L1.70922 21.6345L1.94751 23.6203L8.37576 22.8489L8.13747 20.8631ZM2.82125 22.7465L3.59264 16.3183L1.60688 16.08L0.835492 22.5083L2.82125 22.7465ZM3.30687 16.9063L17.7061 2.507L16.2919 1.09278L1.89265 15.492L3.30687 16.9063ZM13.5601 5.2387L18.9476 10.6262L20.3618 9.21197L14.9743 3.82449L13.5601 5.2387Z"
              fill={props.color || 'currentColor'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase
        {...omit(props, ['viewBox', 'fill'])}
        viewBox="0 0 14 14"
        fill="none"
      >
        <g clipPath="url(#clip0)">
          <path
            d="M4.08335 12.5416L0.291687 13.7083L1.45835 9.91663L8.94252 2.43188L11.5675 5.05688L4.08335 12.5416Z"
            stroke="#8F8F8F"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.9425 2.43194L10.7427 0.631774C10.962 0.414052 11.2585 0.29187 11.5675 0.29187C11.8765 0.29187 12.173 0.414052 12.3923 0.631774L13.3677 1.60711C13.5864 1.82589 13.7093 2.12258 13.7093 2.43194C13.7093 2.7413 13.5864 3.03799 13.3677 3.25677L11.5675 5.05694"
            stroke="#8F8F8F"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.255 3.74438L3.5 10.5"
            stroke="#8F8F8F"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.45831 9.91663L2.04165 10.5H3.49998V11.9583L4.08331 12.5416"
            stroke="#8F8F8F"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M0.875 11.9584L2.04167 13.125"
            stroke="#8F8F8F"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.8175 1.55688L12.4425 4.18188"
            stroke="#8F8F8F"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="14" height="14" fill="white" />
          </clipPath>
        </defs>
      </IconBase>
    )
  },
  addCrossSign: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 3V21M3 12H21"
              stroke={props.color || '#8F8F8F'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase
        {...omit(props, ['viewBox', 'fill'])}
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M7 0.582764V13.4161"
          stroke={props.color ? props.color : '#8F8F8F'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.4144 7H0.581116"
          stroke={props.color ? props.color : '#8F8F8F'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </IconBase>
    )
  },
  duplicateIcon: (props: IconBaseProps) => {
    return (
      <IconBase {...omit(props, ['viewBox', 'fill'])} fill="none">
        <svg viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8 2.74992V2.33325C8 1.36675 7.2165 0.583252 6.25 0.583252H2.75C1.7835 0.583252 1 1.36675 1 2.33325V6.41659C1 7.38308 1.7835 8.16659 2.75 8.16659H3.91667M8.58333 13.4166H12.0833C13.0498 13.4166 13.8333 12.6331 13.8333 11.6666V7.58325C13.8333 6.61675 13.0498 5.83325 12.0833 5.83325H8.58333C7.61683 5.83325 6.83333 6.61675 6.83333 7.58325V11.6666C6.83333 12.6331 7.61683 13.4166 8.58333 13.4166Z"
            stroke={props.color || '#8F8F8F'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </IconBase>
    )
  },
  trashIcon: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 5V4H1.94875L2.00125 5.04994L3 5ZM21 5L21.9988 5.04994L22.0512 4H21V5ZM3.66248 18.2497L4.66124 18.1997L3.66248 18.2497ZM20.3375 18.2497L19.3388 18.1997L20.3375 18.2497ZM16 5C16 5.55228 16.4477 6 17 6C17.5523 6 18 5.55228 18 5H16ZM6 5C6 5.55228 6.44772 6 7 6C7.55228 6 8 5.55228 8 5H6ZM1 4C0.447715 4 0 4.44772 0 5C0 5.55228 0.447715 6 1 6V4ZM23 6C23.5523 6 24 5.55228 24 5C24 4.44772 23.5523 4 23 4V6ZM16 11C16 10.4477 15.5523 10 15 10C14.4477 10 14 10.4477 14 11H16ZM14 16C14 16.5523 14.4477 17 15 17C15.5523 17 16 16.5523 16 16H14ZM10 11C10 10.4477 9.55229 10 9 10C8.44772 10 8 10.4477 8 11H10ZM8 16C8 16.5523 8.44772 17 9 17C9.55229 17 10 16.5523 10 16H8ZM3 6H21V4H3V6ZM20.0012 4.95006L19.3388 18.1997L21.3363 18.2996L21.9988 5.04994L20.0012 4.95006ZM15.3438 22H8.65624V24H15.3438V22ZM4.66124 18.1997L3.99875 4.95006L2.00125 5.04994L2.66373 18.2996L4.66124 18.1997ZM8.65624 22C6.52475 22 4.76768 20.3286 4.66124 18.1997L2.66373 18.2996C2.82339 21.4929 5.459 24 8.65624 24V22ZM19.3388 18.1997C19.2323 20.3286 17.4752 22 15.3438 22V24C18.541 24 21.1766 21.4929 21.3363 18.2996L19.3388 18.1997ZM18 5V4H16V5H18ZM14 0H10V2H14V0ZM6 4V5H8V4H6ZM10 0C7.79086 0 6 1.79086 6 4H8C8 2.89543 8.89543 2 10 2V0ZM18 4C18 1.79086 16.2091 0 14 0V2C15.1046 2 16 2.89543 16 4H18ZM1 6H23V4H1V6ZM14 11V16H16V11H14ZM8 11V16H10V11H8Z"
              fill={props.color || 'currentColor'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase
        {...omit(props, ['viewBox', 'fill'])}
        viewBox="0 0 14 14"
        fill="none"
      >
        <g clipPath="url(#clip0)">
          <path
            d="M12.25 2.625L11.193 12.6636C11.1629 12.9502 11.0277 13.2155 10.8136 13.4085C10.5995 13.6014 10.3215 13.7082 10.0333 13.7083H3.96667C3.67836 13.7083 3.40027 13.6016 3.18602 13.4086C2.97177 13.2157 2.83654 12.9503 2.80642 12.6636L1.75 2.625"
            stroke={props.color || '#8F8F8F'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M0.293823 2.625H13.7105"
            stroke={props.color || '#8F8F8F'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.375 2.62557V0.87557C4.375 0.72086 4.43646 0.572487 4.54585 0.463091C4.65525 0.353694 4.80362 0.292236 4.95833 0.292236H9.04167C9.19638 0.292236 9.34475 0.353694 9.45415 0.463091C9.56354 0.572487 9.625 0.72086 9.625 0.87557V2.62557"
            stroke={props.color || '#8F8F8F'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7 5.25V11.375"
            stroke={props.color || '#8F8F8F'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.62284 5.25L9.33118 11.375"
            stroke={props.color || '#8F8F8F'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.375 5.25L4.66667 11.375"
            stroke={props.color || '#8F8F8F'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="14" height="14" fill="white" />
          </clipPath>
        </defs>
      </IconBase>
    )
  },
  alertTriangle: (props: IconBaseProps) => (
    <IconBase {...omit(props, ['viewBox', 'fill'])} fill="none">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.88889 4.17378L3.20405 15.8053H16.5737L9.88889 4.17378ZM10.8635 2.85921C10.6949 2.56596 10.3688 2.25 9.88889 2.25C9.409 2.25 9.08285 2.56596 8.91432 2.85921C8.91431 2.85922 8.91431 2.85922 8.91431 2.85923L1.60509 15.5772C1.34154 15.9478 1.33388 16.4429 1.60505 16.8243C1.85989 17.1828 2.28227 17.3389 2.6734 17.3053H17.1044C17.4955 17.3389 17.9179 17.1828 18.1727 16.8243C18.4439 16.4429 18.4362 15.9477 18.1727 15.5772L10.8635 2.85923C10.8635 2.85922 10.8635 2.85922 10.8635 2.85921Z"
          fill={props.color || '#FFE164'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.64 7.11223V12.2244H9.14001V7.11223H10.64Z"
          fill={props.color || '#FFE164'}
        />
        <circle cx="9.89001" cy="14" r="0.75" fill={props.color || '#FFE164'} />
      </svg>
    </IconBase>
  ),
  expandSquare: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M8.5 4.25V12.75"
        stroke="#8F8F8F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.75 8.5H4.25"
        stroke="#8F8F8F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5833 0.708252H1.41659C1.02538 0.708252 0.708252 1.02538 0.708252 1.41659V15.5833C0.708252 15.9745 1.02538 16.2916 1.41659 16.2916H15.5833C15.9745 16.2916 16.2916 15.9745 16.2916 15.5833V1.41659C16.2916 1.02538 15.9745 0.708252 15.5833 0.708252Z"
        stroke="#8F8F8F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  collapseSquare: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="2"
              y="2"
              width="20"
              height="20"
              rx="3"
              stroke={props.color || '#121212'}
              strokeWidth="2"
            />
            <line
              x1="8"
              y1="12"
              x2="16"
              y2="12"
              stroke={props.color || '#121212'}
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase
        {...omit(props, ['viewBox', 'fill'])}
        viewBox="0 0 17 17"
        fill="none"
      >
        <path
          d="M12.75 8.5H4.25"
          stroke={props.color || '#FFA277'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.5835 0.708252H1.41683C1.02563 0.708252 0.708496 1.02538 0.708496 1.41659V15.5833C0.708496 15.9745 1.02563 16.2916 1.41683 16.2916H15.5835C15.9747 16.2916 16.2918 15.9745 16.2918 15.5833V1.41659C16.2918 1.02538 15.9747 0.708252 15.5835 0.708252Z"
          stroke={props.color || '#FFA277'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </IconBase>
    )
  },
  milestoneReference: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 15 15"
      fill="none"
      width="15"
      height="15"
    >
      <svg
        width="15"
        height="15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.72168"
          y="7.55615"
          width="10"
          height="10"
          rx="2"
          transform="rotate(-45 0.72168 7.55615)"
          fill={props.color || 'currentColor'}
        />
      </svg>
    </IconBase>
  ),
  projectReference: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.33334 3.55523C1.33334 2.32793 2.32826 1.33301 3.55556 1.33301H12.4444C13.6717 1.33301 14.6667 2.32793 14.6667 3.55523V12.4441C14.6667 13.6714 13.6717 14.6663 12.4444 14.6663H3.55556C2.32826 14.6663 1.33334 13.6714 1.33334 12.4441V3.55523Z"
              fill={props.color || '#121212'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase
        {...omit(props, ['viewBox', 'fill'])}
        viewBox="0 0 11 11"
        fill="none"
      >
        <svg
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="11"
            height="11"
            rx="2"
            fill={props.color || 'currentColor'}
          />
        </svg>
      </IconBase>
    )
  },
  taskReference: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="8"
              cy="8.00033"
              r="7.33333"
              fill={props.color || '#121212'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase
        {...omit(props, ['viewBox', 'fill'])}
        viewBox="0 0 11 11"
        fill="none"
      >
        <svg
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="5.5"
            cy="5.5"
            r="5.5"
            fill={props.color || 'currentColor'}
          />
        </svg>
      </IconBase>
    )
  },

  addCircle: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.50001 16.2916C12.8032 16.2916 16.2917 12.8032 16.2917 8.49998C16.2917 4.19676 12.8032 0.708313 8.50001 0.708313C4.19679 0.708313 0.708344 4.19676 0.708344 8.49998C0.708344 12.8032 4.19679 16.2916 8.50001 16.2916Z"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 4.25V12.75"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.75 8.5H4.25"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  dateCalendar: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33331 3.66733C1.33331 3.11504 1.78103 2.66733 2.33331 2.66733H15.6666C16.2189 2.66733 16.6666 3.11504 16.6666 3.66733V15.6673C16.6666 16.2196 16.2189 16.6673 15.6666 16.6673H2.33331C1.78103 16.6673 1.33331 16.2196 1.33331 15.6673V3.66733Z"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66663 1.33398V4.66732"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 1.33398V4.66732"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33331 6.00064H16.6666"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 6.00064V16.6673"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 6.00064V16.6673"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 6.00064V16.6673"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33331 11.334H16.6666"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33331 8.66733H16.6666"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33331 14.0006H16.6666"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  null: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00008 14.7084C11.705 14.7084 14.7084 11.7049 14.7084 8.00002C14.7084 4.29511 11.705 1.29169 8.00008 1.29169C4.29517 1.29169 1.29175 4.29511 1.29175 8.00002C1.29175 11.7049 4.29517 14.7084 8.00008 14.7084Z"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.25708 12.7431L12.7432 3.25696"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  view: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 16 10"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00016 7.04171C9.12774 7.04171 10.0418 6.12762 10.0418 5.00004C10.0418 3.87246 9.12774 2.95837 8.00016 2.95837C6.87258 2.95837 5.9585 3.87246 5.9585 5.00004C5.9585 6.12762 6.87258 7.04171 8.00016 7.04171Z"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.636 4.80871C13.9576 4.03871 11.2445 1.20837 8.00001 1.20837C4.75551 1.20837 2.04243 4.03871 1.36401 4.80871C1.26864 4.91844 1.26864 5.08164 1.36401 5.19137C2.04243 5.96137 4.75551 8.79171 8.00001 8.79171C11.2445 8.79171 13.9576 5.96137 14.636 5.19137C14.7314 5.08164 14.7314 4.91844 14.636 4.80871Z"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  guideUniversityIcon: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="32"
            height="32"
            viewBox="0 0 52 42"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 5.33301L16.4733 4.17607C16.17 4.05199 15.83 4.05199 15.5267 4.17607L16 5.33301ZM1.33333 11.333L0.860037 10.1761C0.390256 10.3683 0.0833282 10.8254 0.0833282 11.333C0.0833282 11.8406 0.390256 12.2978 0.860037 12.4899L1.33333 11.333ZM16 17.333L15.5267 18.4899C15.83 18.614 16.17 18.614 16.4733 18.4899L16 17.333ZM30.6667 11.333H31.9167C31.9167 10.8254 31.6097 10.3683 31.14 10.1761L30.6667 11.333ZM29.4167 25.333C29.4167 26.0234 29.9763 26.583 30.6667 26.583C31.357 26.583 31.9167 26.0234 31.9167 25.333H29.4167ZM8.88251 22.048L8.35868 23.183L8.88251 22.048ZM14.8825 24.8172L15.4063 23.6823H15.4063L14.8825 24.8172ZM17.1175 24.8172L17.6413 25.9522L17.1175 24.8172ZM23.1175 22.048L23.6413 23.183L23.1175 22.048ZM15.5267 4.17607L0.860037 10.1761L1.80662 12.4899L16.4733 6.48994L15.5267 4.17607ZM0.860037 12.4899L15.5267 18.4899L16.4733 16.1761L1.80662 10.1761L0.860037 12.4899ZM16.4733 18.4899L31.14 12.4899L30.1934 10.1761L15.5267 16.1761L16.4733 18.4899ZM31.14 10.1761L16.4733 4.17607L15.5267 6.48994L30.1934 12.4899L31.14 10.1761ZM29.4167 11.333V25.333H31.9167V11.333H29.4167ZM6.08333 13.7876V19.6268H8.58333V13.7876H6.08333ZM8.35868 23.183L14.3587 25.9522L15.4063 23.6823L9.40633 20.9131L8.35868 23.183ZM17.6413 25.9522L23.6413 23.183L22.5937 20.9131L16.5937 23.6823L17.6413 25.9522ZM25.9167 19.6268V13.7876H23.4167V19.6268H25.9167ZM23.6413 23.183C25.0284 22.5428 25.9167 21.1545 25.9167 19.6268H23.4167C23.4167 20.1794 23.0954 20.6815 22.5937 20.9131L23.6413 23.183ZM14.3587 25.9522C15.4001 26.4328 16.5999 26.4328 17.6413 25.9522L16.5937 23.6823C16.217 23.8561 15.783 23.8561 15.4063 23.6823L14.3587 25.9522ZM6.08333 19.6268C6.08333 21.1545 6.97159 22.5428 8.35868 23.183L9.40633 20.9131C8.90462 20.6815 8.58333 20.1794 8.58333 19.6268H6.08333Z"
              fill={props.color || 'currentColor'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase
        {...omit(props, ['viewBox', 'fill'])}
        fill="none"
        fillRule="evenodd"
        viewBox="0 0 46 42"
      >
        <g>
          <path
            d="M0 1.04545C0 0.468066 0.468066 0 1.04545 0H10.4537H11H11.045H35H35.045H36.59H44.9545C45.5319 0 46 0.468066 46 1.04545V31.3636C46 31.941 45.5319 32.4091 44.9545 32.4091H27.6577L30.8563 39.7273H33.4545C34.0319 39.7273 34.5 40.1954 34.5 40.7728C34.5 41.3501 34.0319 41.8182 33.4545 41.8182H12.5455C11.9681 41.8182 11.5 41.3501 11.5 40.7728C11.5 40.1954 11.9681 39.7273 12.5455 39.7273H15.12L18.3186 32.4091H1.04545C0.468066 32.4091 0 31.941 0 31.3636V1.04545ZM28.5744 39.7273H17.4019L20.6006 32.4091H25.3758L28.5744 39.7273ZM2.09091 2.09091L10.4537 2.09091L11 2.09091H35L36.59 2.09091L43.9091 2.09091V30.3182H2.09091V2.09091ZM5.93002 13.2252L11.502 15.1664V21.4009C11.502 21.8297 11.7637 22.2149 12.1623 22.3729L21.4733 26.0627C21.707 26.1553 21.9663 26.1606 22.2036 26.0776L32.7561 22.3878C33.1756 22.2411 33.4565 21.8453 33.4565 21.4009V15.0913L37.6367 13.691V21.9545C37.6367 22.5319 38.1048 23 38.6822 23C39.2596 23 39.7276 22.5319 39.7276 21.9545V12.5455C39.7276 12.4942 39.7239 12.4438 39.7168 12.3944C39.7254 12.3375 39.7294 12.2793 39.7284 12.2203C39.7207 11.7644 39.4184 11.3661 38.9814 11.236L22.4591 6.31618C22.2607 6.2571 22.0493 6.25826 21.8515 6.3195L5.96471 11.2393C5.53339 11.3729 5.23656 11.7682 5.22868 12.2197C5.22079 12.6711 5.50363 13.0767 5.93002 13.2252ZM31.3656 20.659V15.7918L22.4929 18.764C22.2733 18.8376 22.0355 18.8361 21.8168 18.76L13.5929 15.8948V20.6907L21.8813 23.9753L31.3656 20.659ZM22.1667 8.41075L9.61942 12.2964L22.1674 16.6679L35.2167 12.2966L22.1667 8.41075Z"
            fill="rgb(100, 145, 255)"
          />
        </g>
      </IconBase>
    )
  },
  gettingStartedIcon: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="32"
            height="33"
            viewBox="0 0 50 55"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M29.3333 14.6663C29.3333 20.461 21.0769 27.8693 17.5582 30.7633C16.6451 31.5144 15.3549 31.5144 14.4418 30.7633C10.9231 27.8693 2.66667 20.461 2.66667 14.6663C2.66667 7.30254 8.63621 1.33301 16 1.33301C23.3638 1.33301 29.3333 7.30254 29.3333 14.6663Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="2.5"
            />
            <path
              d="M20 14.6663C20 16.8755 18.2091 18.6663 16 18.6663C13.7909 18.6663 12 16.8755 12 14.6663C12 12.4572 13.7909 10.6663 16 10.6663C18.2091 10.6663 20 12.4572 20 14.6663Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="2.5"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase
        {...omit(props, ['viewBox', 'fill'])}
        fill="none"
        fillRule="evenodd"
        viewBox="0 0 43 44"
      >
        <g>
          <path
            d="M37 1H1V10.0592H37V1Z"
            stroke="#6491FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.7894 11.0657V31.1973H33.2105V11.0657"
            stroke="#6491FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.2634 16.6859H22.7897"
            stroke="#6491FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="33" cy="34" r="9" fill="white" />
          <path
            d="M35 29.6V42.4"
            stroke="#6491FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M41.4 36H28.6"
            stroke="#6491FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </IconBase>
    )
  },
  shieldCheckIcon: (props: IconBaseProps) => {
    return (
      <IconBase {...props}>
        <svg
          width="32"
          height="32"
          viewBox="0 0 52 52"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.00315 5.33301L3.60777 4.14719C3.09774 4.31724 2.75358 4.79438 2.75315 5.33202L4.00315 5.33301ZM27.9968 5.33301L29.2468 5.33202C29.2464 4.79438 28.9023 4.31724 28.3922 4.14718L27.9968 5.33301ZM15.9999 30.6663L15.4922 31.8086C15.8154 31.9523 16.1843 31.9523 16.5075 31.8086L15.9999 30.6663ZM15.9999 1.33301L16.3952 0.147183C16.1386 0.061615 15.8611 0.0616159 15.6045 0.147186L15.9999 1.33301ZM12.8839 13.7154C12.3957 13.2272 11.6043 13.2272 11.1161 13.7154C10.628 14.2036 10.628 14.995 11.1161 15.4832L12.8839 13.7154ZM14.8284 17.4277L13.9445 18.3116L14.8284 19.1955L15.7123 18.3116L14.8284 17.4277ZM21.3692 12.6547C21.8573 12.1666 21.8573 11.3751 21.3692 10.887C20.881 10.3988 20.0895 10.3988 19.6014 10.887L21.3692 12.6547ZM26.75 17.333C26.75 20.7118 24.1818 23.7191 21.2325 26.013C19.7973 27.1292 18.355 28.0113 17.2678 28.6153C16.7257 28.9165 16.2756 29.1465 15.9636 29.3C15.8077 29.3767 15.6866 29.4342 15.606 29.4718C15.5657 29.4906 15.5356 29.5044 15.5164 29.5131C15.5068 29.5175 15.4999 29.5206 15.4958 29.5224C15.4938 29.5233 15.4925 29.5239 15.4919 29.5242C15.4916 29.5244 15.4914 29.5244 15.4915 29.5244C15.4915 29.5244 15.4917 29.5243 15.4917 29.5243C15.4919 29.5242 15.4922 29.5241 15.9999 30.6663C16.5075 31.8086 16.5079 31.8085 16.5083 31.8083C16.5085 31.8082 16.5089 31.808 16.5093 31.8078C16.5101 31.8075 16.5111 31.807 16.5122 31.8065C16.5145 31.8055 16.5175 31.8041 16.5212 31.8025C16.5287 31.7991 16.539 31.7944 16.5521 31.7885C16.5783 31.7766 16.6156 31.7594 16.6632 31.7372C16.7584 31.6928 16.8951 31.6279 17.0674 31.5431C17.4117 31.3737 17.899 31.1245 18.4819 30.8007C19.6448 30.1547 21.2025 29.2035 22.7673 27.9864C25.8181 25.6136 29.25 21.9543 29.25 17.333H26.75ZM15.9999 30.6663C16.5075 29.5241 16.5078 29.5242 16.508 29.5243C16.508 29.5243 16.5082 29.5244 16.5082 29.5244C16.5083 29.5244 16.5082 29.5244 16.5078 29.5242C16.5072 29.5239 16.5059 29.5233 16.5039 29.5224C16.4998 29.5206 16.4929 29.5175 16.4833 29.5131C16.4641 29.5044 16.434 29.4906 16.3937 29.4718C16.3131 29.4342 16.192 29.3767 16.0361 29.3C15.7242 29.1465 15.274 28.9165 14.7319 28.6153C13.6448 28.0113 12.2025 27.1292 10.7674 26.013C7.81814 23.7191 5.25 20.7118 5.25 17.333L2.75 17.333C2.75001 21.9542 6.18179 25.6136 9.2325 27.9864C10.7973 29.2034 12.355 30.1547 13.5178 30.8007C14.1007 31.1245 14.5881 31.3737 14.9323 31.5431C15.1046 31.6279 15.2413 31.6928 15.3365 31.7372C15.3841 31.7594 15.4214 31.7766 15.4476 31.7885C15.4607 31.7944 15.471 31.7991 15.4784 31.8025C15.4822 31.8041 15.4852 31.8055 15.4875 31.8065C15.4886 31.807 15.4896 31.8075 15.4904 31.8078C15.4908 31.808 15.4912 31.8082 15.4914 31.8083C15.4918 31.8084 15.4922 31.8086 15.9999 30.6663ZM5.25 17.333C5.24999 13.3332 5.25078 10.3333 5.25157 8.3335C5.25197 7.33358 5.25236 6.58367 5.25266 6.08375C5.25281 5.83379 5.25293 5.64633 5.25302 5.52137C5.25306 5.45889 5.25309 5.41204 5.25312 5.38081C5.25313 5.3652 5.25314 5.35349 5.25314 5.34568C5.25315 5.34178 5.25315 5.33886 5.25315 5.33691C5.25315 5.33594 5.25315 5.33521 5.25315 5.33472C5.25315 5.33448 5.25315 5.3343 5.25315 5.33418C5.25315 5.33412 5.25315 5.33407 5.25315 5.33404C5.25315 5.33401 5.25315 5.334 4.00315 5.33301C2.75315 5.33202 2.75315 5.33204 2.75315 5.33207C2.75315 5.3321 2.75315 5.33214 2.75315 5.33221C2.75315 5.33233 2.75315 5.33251 2.75315 5.33276C2.75315 5.33325 2.75315 5.33399 2.75315 5.33496C2.75315 5.33692 2.75315 5.33986 2.75314 5.34377C2.75314 5.35159 2.75313 5.36332 2.75312 5.37896C2.75309 5.41023 2.75306 5.45712 2.75302 5.51964C2.75293 5.64468 2.75281 5.83223 2.75266 6.08227C2.75236 6.58235 2.75197 7.33243 2.75157 8.33251C2.75078 10.3327 2.74999 13.3328 2.75 17.333L5.25 17.333ZM27.9968 5.33301C26.7468 5.33399 26.7468 5.33401 26.7468 5.33404C26.7468 5.33407 26.7468 5.33411 26.7468 5.33417C26.7468 5.33429 26.7468 5.33447 26.7468 5.33472C26.7468 5.3352 26.7468 5.33593 26.7468 5.33691C26.7468 5.33885 26.7468 5.34178 26.7468 5.34568C26.7469 5.35348 26.7469 5.36519 26.7469 5.38081C26.7469 5.41204 26.7469 5.45889 26.747 5.52137C26.7471 5.64633 26.7472 5.83379 26.7473 6.08375C26.7476 6.58366 26.748 7.33358 26.7484 8.3335C26.7492 10.3333 26.75 13.3332 26.75 17.333H29.25C29.25 13.3328 29.2492 10.3327 29.2484 8.33252C29.248 7.33243 29.2476 6.58235 29.2473 6.08227C29.2472 5.83223 29.2471 5.64469 29.247 5.51965C29.2469 5.45713 29.2469 5.41023 29.2469 5.37896C29.2469 5.36332 29.2469 5.3516 29.2468 5.34377C29.2468 5.33986 29.2468 5.33693 29.2468 5.33497C29.2468 5.33399 29.2468 5.33325 29.2468 5.33276C29.2468 5.33252 29.2468 5.33233 29.2468 5.33221C29.2468 5.33215 29.2468 5.3321 29.2468 5.33207C29.2468 5.33204 29.2468 5.33202 27.9968 5.33301ZM4.39854 6.51883L16.3952 2.51883L15.6045 0.147186L3.60777 4.14719L4.39854 6.51883ZM15.6045 2.51883L27.6015 6.51883L28.3922 4.14718L16.3952 0.147183L15.6045 2.51883ZM11.1161 15.4832L13.9445 18.3116L15.7123 16.5438L12.8839 13.7154L11.1161 15.4832ZM15.7123 18.3116L21.3692 12.6547L19.6014 10.887L13.9445 16.5438L15.7123 18.3116Z"
            fill={props.color || 'currentColor'}
          />
        </svg>
      </IconBase>
    )
  },
  sendEmailFlyIcon: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      fill="none"
      fillRule="evenodd"
      viewBox="0 0 48 48"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 3C10.5 2.17157 11.1716 1.5 12 1.5H36C36.8284 1.5 37.5 2.17157 37.5 3V21C37.5 21.8284 36.8284 22.5 36 22.5H12C11.1716 22.5 10.5 21.8284 10.5 21V3Z"
        stroke="#6491FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 4.5L24 12L37.5 4.5"
        stroke="#6491FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.5 6L46.5 1.5C46.5 18 37.5 16.5 37.5 16.5"
        stroke="#6491FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 6L1.5 1.5C1.5 18 10.5 16.5 10.5 16.5"
        stroke="#6491FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 31.5V46.5"
        stroke="#6491FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.5 28.5V37.5"
        stroke="#6491FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 28.5V37.5"
        stroke="#6491FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  guideIcon: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      fill="none"
      fillRule="evenodd"
      viewBox="0 0 34 34"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.8259 9.72727L32.9998 5.36364L28.8259 1"
        fill="white"
      />
      <path
        d="M28.8259 9.72727L32.9998 5.36364L28.8259 1"
        stroke="#6491FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.17391 24.2727L1 28.6364L5.17391 33"
        fill="white"
      />
      <path
        d="M5.17391 24.2727L1 28.6364L5.17391 33"
        stroke="#6491FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33 5.36366H14.913C11.8395 5.36366 9.34783 7.96855 9.34783 11.1818C9.34783 14.3951 11.8395 17 14.913 17H19.087C22.1605 17 24.6522 19.6049 24.6522 22.8182C24.6522 26.0315 22.1605 28.6364 19.087 28.6364H1"
        fill="white"
      />
      <path
        d="M33 5.36366H14.913C11.8395 5.36366 9.34783 7.96855 9.34783 11.1818V11.1818C9.34783 14.3951 11.8395 17 14.913 17H19.087C22.1605 17 24.6522 19.6049 24.6522 22.8182C24.6522 26.0315 22.1605 28.6364 19.087 28.6364H1"
        stroke="#6491FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  templates: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="32"
            height="32"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="2.58333"
              y="2.58301"
              width="26.8333"
              height="6.83333"
              rx="1.41667"
              stroke={props.color || 'currentColor'}
              strokeWidth="2.5"
            />
            <rect
              x="14.5833"
              y="14.583"
              width="14.8333"
              height="14.8333"
              rx="1.41667"
              stroke={props.color || 'currentColor'}
              strokeWidth="2.5"
            />
            <rect
              x="2.58333"
              y="14.583"
              width="6.83333"
              height="14.8333"
              rx="1.41667"
              stroke={props.color || 'currentColor'}
              strokeWidth="2.5"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase
        {...omit(props, ['viewBox', 'fill'])}
        fill="none"
        fillRule="evenodd"
        width="49"
        height="49"
        viewBox="0 0 49 49"
      >
        <path
          d="M27.028 46.12H21.028"
          stroke="#6491FF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.028 42.28H19.028"
          stroke="#6491FF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.028 1.96V7.72"
          stroke="#6491FF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.05603 8.7088L11.3 12.7811"
          stroke="#6491FF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40.998 8.7088L36.756 12.7811"
          stroke="#6491FF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.02802 25H7.02802"
          stroke="#6491FF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.028 25H41.028"
          stroke="#6491FF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.028 25C36.0343 19.5303 32.0333 14.8105 26.4533 13.705C20.8734 12.5996 15.2529 15.4133 13.0032 20.4384C10.7534 25.4636 12.4946 31.3147 17.17 34.4406C17.7076 34.7996 18.028 35.3884 18.028 36.0169V37.48C18.028 38.0102 18.4757 38.44 19.028 38.44H29.028C29.5803 38.44 30.028 38.0102 30.028 37.48V36.015C30.028 35.3864 30.3485 34.7976 30.886 34.4387C34.1085 32.2922 36.0299 28.7653 36.028 25V25Z"
          stroke="#6491FF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </IconBase>
    )
  },
  groupIcon: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      fill="none"
      fillRule="evenodd"
      viewBox="0 0 46 35"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3914 17.2609C18.8817 17.2609 22.5219 13.6207 22.5219 9.13043C22.5219 4.64012 18.8817 1 14.3914 1C9.90111 1 6.26099 4.64012 6.26099 9.13043C6.26099 13.6207 9.90111 17.2609 14.3914 17.2609Z"
        stroke={props.color || '#6491FF'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 33.5218C1 26.126 6.99549 20.1305 14.3913 20.1305C21.7871 20.1305 27.7826 26.126 27.7826 33.5218H1Z"
        stroke={props.color || '#6491FF'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.6085 33.5217H44.9998C44.9997 29.8495 43.085 26.4429 39.948 24.5338C36.811 22.6247 32.9055 22.4893 29.6438 24.1765"
        stroke={props.color || '#6491FF'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.3711 20.1304C37.8048 20.1304 40.5885 17.3468 40.5885 13.913C40.5885 10.4793 37.8048 7.69564 34.3711 7.69564C30.9373 7.69564 28.1537 10.4793 28.1537 13.913C28.1537 17.3468 30.9373 20.1304 34.3711 20.1304Z"
        stroke={props.color || '#6491FF'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  check: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 18 15"
      fill="none"
    >
      <path
        d="M17 1L7.66667 13.6667L1 8.33333"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  successCheck: (props: IconBaseProps) => {
    return (
      <IconBase {...props}>
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.99996 8.96643L8.41417 10.3806L11.2426 7.55222M16.3333 8.99996C16.3333 13.05 13.05 16.3333 8.99996 16.3333C4.94987 16.3333 1.66663 13.05 1.66663 8.99996C1.66663 4.94987 4.94987 1.66663 8.99996 1.66663C13.05 1.66663 16.3333 4.94987 16.3333 8.99996Z"
            stroke={props.color || 'currentColor'}
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </IconBase>
    )
  },
  checkCircle: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M16 6.8325L10.1667 14.7492L6 11.4158"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 20.5825C16.2927 20.5825 20.5834 16.2919 20.5834 10.9992C20.5834 5.70644 16.2927 1.41583 11 1.41583C5.70729 1.41583 1.41669 5.70644 1.41669 10.9992C1.41669 16.2919 5.70729 20.5825 11 20.5825Z"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  alert1: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.00002 5.66699V9.00033M9.00002 11.667V12.0003M16.3334 9.00033C16.3334 13.0504 13.0501 16.3337 9.00002 16.3337C4.94993 16.3337 1.66669 13.0504 1.66669 9.00033C1.66669 4.95024 4.94993 1.66699 9.00002 1.66699C13.0501 1.66699 16.3334 4.95024 16.3334 9.00033Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase
        {...omit(props, ['viewBox', 'fill'])}
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.0354 15.0539C15.125 15.1784 15.1308 15.3446 15.0501 15.475C14.9694 15.6055 14.8181 15.6745 14.6667 15.6499H1.33341C1.18202 15.6745 1.03073 15.6055 0.950041 15.475C0.869357 15.3446 0.87516 15.1784 0.964744 15.0539L7.70208 1.57993C7.86608 1.25193 8.13408 1.25193 8.29808 1.57993L15.0354 15.0539Z"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 11.3194V6.65269"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.99409 12.6527C7.95012 12.6536 7.90833 12.672 7.87812 12.704C7.84791 12.736 7.83181 12.7787 7.83342 12.8227C7.837 12.9137 7.91167 12.9857 8.00276 12.986H8.00609C8.05006 12.9852 8.09185 12.9667 8.12206 12.9347C8.15227 12.9027 8.16837 12.86 8.16676 12.816C8.16324 12.726 8.09014 12.6544 8.00009 12.6527H7.99676"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </IconBase>
    )
  },
  users2: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.9506 17.3802C17.3783 16.5669 14.7849 15.5 12 15.5C9.21513 15.5 6.62175 16.5669 5.04942 17.3802C4.03431 17.9052 3.42295 18.9351 3.2883 20.07L3 22.5H21L20.7117 20.07C20.577 18.9351 19.9657 17.9052 18.9506 17.3802Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 11C14.4853 11 16.5 8.98528 16.5 6.5C16.5 4.01472 14.4853 2 12 2C9.51472 2 7.5 4.01472 7.5 6.5C7.5 8.98528 9.51472 11 12 11Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase
        {...omit(props, ['viewBox', 'fill'])}
        viewBox="0 0 20 18"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.625 9C8.38541 9 9.8125 7.57291 9.8125 5.8125C9.8125 4.05209 8.38541 2.625 6.625 2.625C4.86459 2.625 3.4375 4.05209 3.4375 5.8125C3.4375 7.57291 4.86459 9 6.625 9Z"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.375 15.375C1.375 12.4755 3.72551 10.125 6.625 10.125C9.52449 10.125 11.875 12.4755 11.875 15.375H1.375Z"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.375 15.3749H18.625C18.625 13.9352 17.8743 12.5997 16.6444 11.8512C15.4146 11.1028 13.8835 11.0497 12.6047 11.7112"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.458 10.125C15.8042 10.125 16.8955 9.03369 16.8955 7.6875C16.8955 6.34131 15.8042 5.25 14.458 5.25C13.1118 5.25 12.0205 6.34131 12.0205 7.6875C12.0205 9.03369 13.1118 10.125 14.458 10.125Z"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </IconBase>
    )
  },
  projects2: (props: IconBaseProps) => {
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5 2C5 0.89543 5.89543 0 7 0H17C18.1046 0 19 0.895431 19 2V3C20.1046 3 21 3.89543 21 5V6V7H22C23.1046 7 24 7.89543 24 9V22C24 23.1046 23.1046 24 22 24H2C0.895431 24 0 23.1046 0 22V9C0 7.89543 0.895431 7 2 7H3V6V5C3 3.89543 3.89543 3 5 3V2ZM5 7H19V6V5H17H7H5V6V7ZM19 9H5H2V22H22V9H19ZM17 2V3H7V2H17Z"
              fill={props.color || 'currentColor'}
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase
        {...omit(props, ['viewBox', 'fill'])}
        viewBox="0 0 18 20"
        fill="none"
      >
        <path
          d="M13.5 2.875H15C15.4142 2.875 15.75 3.21079 15.75 3.625V17.875C15.75 18.2892 15.4142 18.625 15 18.625H3C2.58579 18.625 2.25 18.2892 2.25 17.875V3.625C2.25 3.21079 2.58579 2.875 3 2.875H4.5"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5 2.875C10.5 2.04657 9.82843 1.375 9 1.375C8.17157 1.375 7.5 2.04657 7.5 2.875H6V5.125H12V2.875H10.5Z"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 4.375H4.125C3.91789 4.375 3.75 4.54289 3.75 4.75V16.75C3.75 16.9571 3.91789 17.125 4.125 17.125H11.25V14.5C11.25 14.2929 11.4179 14.125 11.625 14.125H14.25V4.75C14.25 4.54289 14.0821 4.375 13.875 4.375H12"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.2485 14.1243L11.2485 17.1243"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 7.37427H12"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 9.62427H12"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 11.8743H9.375"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </IconBase>
    )
  },
  search2: (props: IconBaseProps) => {
    // remove with https://guidecx.atlassian.net/browse/MON-45
    const themeName = props.theme ? props.theme.name : 'default'
    if (themeName === 'lightV2') {
      return (
        <IconBase {...props}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 14L12 12M13.3333 7.33331C13.3333 10.647 10.647 13.3333 7.33334 13.3333C4.01963 13.3333 1.33334 10.647 1.33334 7.33331C1.33334 4.0196 4.01963 1.33331 7.33334 1.33331C10.647 1.33331 13.3333 4.0196 13.3333 7.33331Z"
              stroke={props.color || 'currentColor'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconBase>
      )
    }
    return (
      <IconBase
        {...omit(props, ['viewBox', 'fill'])}
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00016 14.6667C11.6821 14.6667 14.6668 11.6819 14.6668 8.00004C14.6668 4.31814 11.6821 1.33337 8.00016 1.33337C4.31826 1.33337 1.3335 4.31814 1.3335 8.00004C1.3335 11.6819 4.31826 14.6667 8.00016 14.6667Z"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.667 16.6667L12.7144 12.714"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </IconBase>
    )
  },
  share2: (props: IconBaseProps) => {
    return (
      <IconBase
        {...omit(props, ['viewBox', 'fill'])}
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M6.5 3.5H1.5C0.947715 3.5 0.5 3.94772 0.5 4.5V14.5C0.5 15.0523 0.947715 15.5 1.5 15.5H11.5C12.0523 15.5 12.5 15.0523 12.5 14.5V9.53"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.5 12.514L15.5 0.514038"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.5 0.514038H15.5V6.51404"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </IconBase>
    )
  },
  cog: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9415 6.40976C15.7706 6.76903 15.7599 7.1839 15.9122 7.55147C16.0644 7.91903 16.3653 8.20485 16.7402 8.33801L17.689 8.67551C18.25 8.87464 18.6248 9.40545 18.6248 10.0008C18.6248 10.5961 18.25 11.1269 17.689 11.326L16.7402 11.6635C16.3653 11.7967 16.0644 12.0825 15.9122 12.4501C15.7599 12.8176 15.7706 13.2325 15.9415 13.5918L16.375 14.5C16.6318 15.0378 16.5218 15.679 16.1004 16.1004C15.679 16.5218 15.0377 16.6318 14.5 16.375L13.5902 15.943C13.231 15.7721 12.8161 15.7614 12.4485 15.9137C12.081 16.066 11.7951 16.3669 11.662 16.7418L11.3245 17.6905C11.125 18.251 10.5945 18.6253 9.9996 18.6253C9.4047 18.6253 8.87416 18.251 8.67472 17.6905L8.33722 16.7418C8.20389 16.3668 7.91793 16.0659 7.55025 15.9137C7.18257 15.7614 6.7676 15.7721 6.40822 15.943L5.49997 16.375C4.96218 16.6329 4.32022 16.5232 3.8985 16.1015C3.47677 15.6798 3.36713 15.0378 3.62497 14.5L4.05697 13.5903C4.22789 13.231 4.23855 12.8161 4.08629 12.4486C3.93403 12.081 3.63313 11.7952 3.25822 11.662L2.30947 11.3245C1.74845 11.1254 1.3736 10.5946 1.3736 9.99926C1.3736 9.40395 1.74845 8.87314 2.30947 8.67401L3.25822 8.33651C3.63273 8.20329 3.93331 7.91773 4.08553 7.55054C4.23775 7.18335 4.22738 6.76887 4.05697 6.40976L3.62497 5.50001C3.36713 4.96222 3.47677 4.32026 3.8985 3.89853C4.32022 3.47681 4.96218 3.36717 5.49997 3.62501L6.40972 4.05701C6.76875 4.22749 7.18315 4.23809 7.55042 4.08618C7.91769 3.93427 8.20352 3.63404 8.33722 3.25976L8.67472 2.31101C8.87416 1.75053 9.4047 1.37619 9.9996 1.37619C10.5945 1.37619 11.125 1.75053 11.3245 2.31101L11.662 3.25976C11.7951 3.63467 12.081 3.93557 12.4485 4.08783C12.8161 4.24009 13.231 4.22943 13.5902 4.05851L14.5 3.62501C15.0377 3.36818 15.679 3.4782 16.1004 3.8996C16.5218 4.321 16.6318 4.96225 16.375 5.50001L15.9415 6.40976Z"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99921 13.3758C11.8632 13.3758 13.3742 11.8647 13.3742 10.0008C13.3742 8.1368 11.8632 6.62576 9.99921 6.62576C8.13525 6.62576 6.62421 8.1368 6.62421 10.0008C6.62421 11.8647 8.13525 13.3758 9.99921 13.3758Z"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  reassign: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1957 13.7969V18.3621H16.1957V13.7969H17.1957Z"
        fill={props.color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3913 16.6055L16.6957 17.9098L18 16.6055L18.7071 17.3126L16.6957 19.324L14.6842 17.3126L15.3913 16.6055Z"
        fill={props.color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2826 18.3621V13.7969H13.2826V18.3621H12.2826Z"
        fill={props.color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7826 13.0898L14.794 15.1013L14.0869 15.8084L12.7826 14.5041L11.4782 15.8084L10.7711 15.1013L12.7826 13.0898Z"
        fill={props.color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.83945 11.9912H9.98664C9.64989 10.6063 8.40154 9.57812 6.91304 9.57812C5.42455 9.57812 4.1762 10.6063 3.83945 11.9912ZM2.25 12.7412C2.25 10.1658 4.33772 8.07812 6.91304 8.07812C9.48837 8.07812 11.5761 10.1658 11.5761 12.7412C11.5761 12.9401 11.4971 13.1308 11.3564 13.2715C11.2158 13.4121 11.025 13.4912 10.8261 13.4912H3C2.80109 13.4912 2.61032 13.4121 2.46967 13.2715C2.32902 13.1308 2.25 12.9401 2.25 12.7412Z"
        fill={props.color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.71741 4.44565C3.71741 2.68074 5.14815 1.25 6.91306 1.25C8.67797 1.25 10.1087 2.68074 10.1087 4.44565C10.1087 6.21056 8.67797 7.6413 6.91306 7.6413C5.14815 7.6413 3.71741 6.21056 3.71741 4.44565ZM6.91306 2.75C5.97658 2.75 5.21741 3.50917 5.21741 4.44565C5.21741 5.38214 5.97658 6.1413 6.91306 6.1413C7.84954 6.1413 8.60871 5.38214 8.60871 4.44565C8.60871 3.50917 7.84954 2.75 6.91306 2.75Z"
        fill={props.color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.91309 4.44565C9.91309 2.68074 11.3438 1.25 13.1087 1.25C14.8736 1.25 16.3044 2.68074 16.3044 4.44565C16.3044 6.21056 14.8736 7.6413 13.1087 7.6413C11.3438 7.6413 9.91309 6.21056 9.91309 4.44565ZM13.1087 2.75C12.1723 2.75 11.4131 3.50917 11.4131 4.44565C11.4131 5.38214 12.1723 6.1413 13.1087 6.1413C14.0452 6.1413 14.8044 5.38214 14.8044 4.44565C14.8044 3.50917 14.0452 2.75 13.1087 2.75Z"
        fill={props.color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7741 8.70432C12.3526 7.79167 14.3182 7.88275 15.8056 8.93747C16.1434 9.17708 16.2231 9.64522 15.9835 9.9831C15.7439 10.321 15.2758 10.4006 14.9379 10.161C13.929 9.4456 12.5957 9.38382 11.5249 10.0029C11.1664 10.2102 10.7076 10.0876 10.5003 9.72901C10.2929 9.37042 10.4155 8.91165 10.7741 8.70432Z"
        fill={props.color || 'currentColor'}
      />
    </IconBase>
  ),
  editTime: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7127 10.0063L14.5543 13.8472L13.8473 14.5544L10.0056 10.7135L10.7127 10.0063Z"
        fill={props.color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.59131 10.0425C8.59131 9.24103 9.24103 8.59131 10.0425 8.59131C10.844 8.59131 11.4937 9.24103 11.4937 10.0425C11.4937 10.844 10.844 11.4937 10.0425 11.4937C9.24103 11.4937 8.59131 10.844 8.59131 10.0425ZM10.0425 9.59131C9.79331 9.59131 9.59131 9.79331 9.59131 10.0425C9.59131 10.2917 9.79331 10.4937 10.0425 10.4937C10.2917 10.4937 10.4937 10.2917 10.4937 10.0425C10.4937 9.79331 10.2917 9.59131 10.0425 9.59131Z"
        fill={props.color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5425 6.05469V9.59119H9.54248V6.05469H10.5425Z"
        fill={props.color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0425 2C5.60073 2 2 5.60073 2 10.0425C2 14.4842 5.60073 18.0849 10.0425 18.0849C10.6111 18.0849 11.1661 18.0259 11.7014 17.9136C11.4288 17.4855 11.2266 17.0082 11.1111 16.4981C10.7633 16.5552 10.4064 16.5849 10.0425 16.5849C6.42916 16.5849 3.5 13.6558 3.5 10.0425C3.5 6.42916 6.42916 3.5 10.0425 3.5C13.6558 3.5 16.5849 6.42916 16.5849 10.0425C16.5849 10.4064 16.5552 10.7633 16.4981 11.1111C17.0082 11.2266 17.4855 11.4288 17.9136 11.7014C18.0259 11.1661 18.0849 10.6111 18.0849 10.0425C18.0849 5.60073 14.4842 2 10.0425 2Z"
        fill={props.color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5369 13.3418C18.7322 13.1466 19.0488 13.1466 19.2441 13.3418L20.6583 14.756C20.8535 14.9513 20.8535 15.2679 20.6583 15.4632L15.6416 20.4798C15.4463 20.6751 15.1297 20.6751 14.9345 20.4798L13.5203 19.0656C13.325 18.8704 13.325 18.5538 13.5203 18.3585L18.5369 13.3418ZM18.8905 14.4025L14.5809 18.7121L15.288 19.4192L19.5976 15.1096L18.8905 14.4025Z"
        fill={props.color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2272 18.3584L15.6415 19.7727C15.7641 19.8953 15.8144 20.0725 15.7746 20.2412C15.7348 20.4098 15.6105 20.5458 15.4461 20.6006L13.3247 21.3076C13.1451 21.3675 12.947 21.3207 12.8131 21.1868C12.6792 21.0529 12.6324 20.8549 12.6923 20.6752L13.3993 18.5539L13.8736 18.712L14.2272 18.3584ZM14.0922 19.6376L13.9571 20.0428L14.3623 19.9077L14.0922 19.6376Z"
        fill={props.color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6224 13.72L20.28 14.3776C20.3591 14.1947 20.3237 13.9745 20.1746 13.8254C20.0255 13.6763 19.8053 13.6409 19.6224 13.72ZM18.7789 13.1C19.3675 12.5316 20.3031 12.5397 20.8817 13.1183C21.4603 13.6969 21.4684 14.6325 20.8999 15.221L20.8939 15.2273L20.6582 15.4629C20.5644 15.5567 20.4372 15.6093 20.3046 15.6093C20.172 15.6093 20.0448 15.5567 19.9511 15.4629L18.5371 14.0489C18.4433 13.9551 18.3906 13.8279 18.3906 13.6953C18.3906 13.5627 18.4433 13.4355 18.5371 13.3418L18.7789 13.1Z"
        fill={props.color || 'currentColor'}
      />
    </IconBase>
  ),
  task: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.106 12.2116L16.6189 3.86695L15.5081 3L9.88156 10.209L7.78017 8.49287L6.88889 9.58423L10.106 12.2116ZM4.55556 5.33334C4.55556 4.90378 4.90378 4.55556 5.33333 4.55556H12.0741V3H5.33333C4.04467 3 3 4.04467 3 5.33334V14.6667C3 15.9553 4.04467 17 5.33333 17H14.6667C15.9553 17 17 15.9553 17 14.6667V9.30864H15.4444V14.6667C15.4444 15.0962 15.0962 15.4444 14.6667 15.4444H5.33333C4.90378 15.4444 4.55556 15.0962 4.55556 14.6667V5.33334Z"
        fill={props.color || 'currentColor'}
      />
    </IconBase>
  ),
  chevronDown: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 12 8"
      fill="none"
    >
      <path
        d="M1 1L5.83696 6.46652C5.87822 6.51317 5.93751 6.53988 5.99978 6.53988C6.06206 6.53988 6.12135 6.51317 6.16261 6.46652L11 1"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  sendEmailFly: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 3C10.5 2.17157 11.1716 1.5 12 1.5H36C36.8284 1.5 37.5 2.17157 37.5 3V21C37.5 21.8284 36.8284 22.5 36 22.5H12C11.1716 22.5 10.5 21.8284 10.5 21V3Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 4.5L24 12L37.5 4.5"
        stroke={props.color || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.5 6L46.5 1.5C46.5 18 37.5 16.5 37.5 16.5"
        stroke={props.color || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 6L1.5 1.5C1.5 18 10.5 16.5 10.5 16.5"
        stroke={props.color || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 31.5V46.5"
        stroke={props.color || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.5 28.5V37.5"
        stroke={props.color || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 28.5V37.5"
        stroke={props.color || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  sendEmail: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75899 16.629C2.01669 16.629 1.36418 16.1373 1.15952 15.4238C0.954855 14.7103 1.24755 13.9475 1.87699 13.554L20.36 1.99999C20.9203 1.64935 21.6351 1.66382 22.1807 2.03684C22.7264 2.40987 22.9993 3.07063 22.876 3.71999L19.276 22.893C19.1539 23.5411 18.6606 24.056 18.0183 24.2056C17.376 24.3552 16.7059 24.1114 16.31 23.584L11.1 16.629H2.75899Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1 16.629H8.59998V21.8C8.59994 22.4165 8.94093 22.9824 9.48597 23.2704C10.031 23.5584 10.6907 23.5213 11.2 23.174L14.378 21.008L11.1 16.629Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.099 16.629L22.179 2.039"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  checkOn: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M11.6522 4.95654L7.39138 10.7392L4.3479 8.30437"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2C1 1.44772 1.44772 1 2 1H14C14.5523 1 15 1.44772 15 2V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V2Z"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  checkOff: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2C1 1.44772 1.44772 1 2 1H14C14.5523 1 15 1.44772 15 2V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V2Z"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  addAnother: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M7 0.599998V13.4"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4 7H0.600006"
        stroke={props.color || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  emojiPeople: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 496 512"
      fill="currentColor"
    >
      <path d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm194.8 170.2C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.6-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.4-16.2 38.1 4.2 24.6 20.5z" />
    </IconBase>
  ),
  emojiNature: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 512 512"
      fill="currentColor"
    >
      <path d="M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z" />
    </IconBase>
  ),
  emojiFood: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 416 512"
      fill="currentColor"
    >
      <path d="M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z" />
    </IconBase>
  ),
  emojiActivity: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 512 512"
      fill="currentColor"
    >
      <path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z" />
    </IconBase>
  ),
  emojiTravel: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 576 512"
      fill="currentColor"
    >
      <path d="M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z" />
    </IconBase>
  ),
  emojiObjects: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 448 512"
      fill="currentColor"
    >
      <path d="M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z" />
    </IconBase>
  ),
  emojiSymbols: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 512 512"
      fill="currentColor"
    >
      <path d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z" />
    </IconBase>
  ),
  emojiFlags: (props: IconBaseProps) => (
    <IconBase
      {...omit(props, ['viewBox', 'fill'])}
      viewBox="0 0 512 512"
      fill="currentColor"
    >
      <path d="M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z" />
    </IconBase>
  ),
  reorder: (props: IconBaseProps) => (
    <IconBase {...omit(props, ['viewBox', 'fill'])}>
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle
          cx="5.125"
          cy="3.125"
          r="1.125"
          fill={props.color || 'currentColor'}
        />
        <circle
          cx="9.995"
          cy="3.125"
          r="1.125"
          fill={props.color || 'currentColor'}
        />
        <circle
          cx="5.125"
          cy="8"
          r="1.125"
          fill={props.color || 'currentColor'}
        />
        <circle
          cx="9.995"
          cy="8"
          r="1.125"
          fill={props.color || 'currentColor'}
        />
        <circle
          cx="5.125"
          cy="12.875"
          r="1.125"
          fill={props.color || 'currentColor'}
        />
        <circle
          cx="9.995"
          cy="12.875"
          r="1.125"
          fill={props.color || 'currentColor'}
        />
      </svg>
    </IconBase>
  ),
  taskChecklist: (props: IconBaseProps) => (
    <IconBase {...omit(props, ['viewBox', 'fill'])}>
      <svg
        width="26"
        height="26"
        viewBox="0 0 40 40"
        fill={props.color || 'none'}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 3C1 1.89543 1.89543 1 3 1H23C24.1046 1 25 1.89543 25 3V23C25 24.1046 24.1046 25 23 25H3C1.89543 25 1 24.1046 1 23V3Z"
          stroke={props.color || '#474747'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.6958 8.30437L7.26102 9.86959L11.4349 5.69568"
          stroke={props.color || '#474747'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.6958 18.7392L7.26102 20.3044L11.4349 16.1305"
          stroke={props.color || '#474747'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5652 9.34778H20.8261"
          stroke={props.color || '#474747'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5652 18.7391H20.8261"
          stroke={props.color || '#474747'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  ),
  download: (props: IconBaseProps) => (
    <IconBase {...omit(props, ['viewBox', 'fill'])}>
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.7778 9.33337L8.00002 11.5556L10.2222 9.33337"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 4.88892V11.5556"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00001 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8.00004C14.6667 4.31814 11.6819 1.33337 8.00001 1.33337C4.31811 1.33337 1.33334 4.31814 1.33334 8.00004C1.33334 11.6819 4.31811 14.6667 8.00001 14.6667Z"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  ),
  userCredential: (props: IconBaseProps) => (
    <IconBase
      viewBox="0 0 107 85"
      fill="none"
      {...omit(props, ['viewBox', 'fill'])}
    >
      <path
        d="M86.3889 11.7778V7.38889C86.3889 4.96497 84.4239 3 82 3H7.38889C4.96497 3 3 4.96497 3 7.38889V60.0556C3 62.4795 4.96497 64.4444 7.38889 64.4444H11.7778"
        stroke="#C3D5FF"
        strokeWidth="4.38889"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71.0278 38.1111H90.7778"
        stroke={props.color || 'currentColor'}
        strokeWidth="4.38889"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71.0278 51.2778H82.0001"
        stroke={props.color || 'currentColor'}
        strokeWidth="4.38889"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.8895 46.8888C51.1314 46.8888 54.5701 43.4501 54.5701 39.2083C54.5701 34.9664 51.1314 31.5277 46.8895 31.5277C42.6477 31.5277 39.209 34.9664 39.209 39.2083C39.209 43.4501 42.6477 46.8888 46.8895 46.8888Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="4.38889"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.2505 62.249C60.46 55.2272 54.1359 50.3134 46.8894 50.3134C39.6429 50.3134 33.3189 55.2272 31.5283 62.249H62.2505Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="4.38889"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.389 79.8056C86.389 81.0175 87.3715 82 88.5834 82H99.5557C101.98 82 103.945 80.035 103.945 77.6111V24.9444C103.945 22.5205 101.98 20.5556 99.5557 20.5556H24.9446C22.5206 20.5556 20.5557 22.5205 20.5557 24.9444V77.6111C20.5557 80.035 22.5206 82 24.9446 82H33.7223C34.9343 82 35.9168 81.0175 35.9168 79.8056C35.9168 74.9577 39.8467 71.0278 44.6946 71.0278C49.5424 71.0278 53.4723 74.9577 53.4723 79.8056C53.4723 81.0175 54.4548 82 55.6668 82H66.639C67.851 82 68.8334 81.0175 68.8334 79.8056C68.8334 74.9577 72.7634 71.0278 77.6112 71.0278C82.4591 71.0278 86.389 74.9577 86.389 79.8056Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="4.38889"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),
  yesInviteResponse: (props: IconBaseProps) => (
    <IconBase {...props} viewBox="0 0 12 12" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM9.35355 4.35355C9.54882 4.15829 9.54882 3.84171 9.35355 3.64645C9.15829 3.45118 8.84171 3.45118 8.64645 3.64645L5 7.29289L3.35355 5.64645C3.15829 5.45118 2.84171 5.45118 2.64645 5.64645C2.45118 5.84171 2.45118 6.15829 2.64645 6.35355L4.64645 8.35355C4.84171 8.54882 5.15829 8.54882 5.35355 8.35355L9.35355 4.35355Z"
        fill="#00C896"
      />
    </IconBase>
  ),
  noInviteResponse: (props: IconBaseProps) => (
    <IconBase {...props} viewBox="0 0 12 12" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM4.35355 3.64645C4.15829 3.45118 3.84171 3.45118 3.64645 3.64645C3.45118 3.84171 3.45118 4.15829 3.64645 4.35355L5.29289 6L3.64645 7.64645C3.45118 7.84171 3.45118 8.15829 3.64645 8.35355C3.84171 8.54882 4.15829 8.54882 4.35355 8.35355L6 6.70711L7.64645 8.35355C7.84171 8.54882 8.15829 8.54882 8.35355 8.35355C8.54882 8.15829 8.54882 7.84171 8.35355 7.64645L6.70711 6L8.35355 4.35355C8.54882 4.15829 8.54882 3.84171 8.35355 3.64645C8.15829 3.45118 7.84171 3.45118 7.64645 3.64645L6 5.29289L4.35355 3.64645Z"
        fill="#FF5F69"
      />
    </IconBase>
  ),
  maybeInviteResponse: (props: IconBaseProps) => (
    <IconBase {...props} viewBox="0 0 12 12" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM5.76 7.81C5.52 7.58 5.4 7.29 5.4 6.96C5.4 6.29593 5.87154 5.95605 6.29856 5.64824L6.31 5.64L6.31533 5.63625C6.68317 5.37779 7.01 5.14813 7.01 4.76C7.01 4.37 6.71 4.04 6.06 4.04C5.45 4.04 5.01 4.32 4.67 4.74L4 3.99C4.51 3.37 5.28 3 6.18 3C7.44 3 8.21 3.67 8.21 4.57C8.21 5.4 7.65 5.8 7.15 6.15C7.13432 6.16155 7.1187 6.17304 7.10314 6.18447C6.74172 6.45008 6.42 6.6865 6.42 7.07C6.42 7.23 6.51 7.41 6.64 7.52L5.76 7.81ZM6.12 9.88C5.74 9.88 5.42 9.56 5.42 9.18C5.42 8.8 5.74 8.48 6.12 8.48C6.5 8.48 6.82 8.8 6.82 9.18C6.82 9.56 6.5 9.88 6.12 9.88Z"
        fill="#FFA02D"
      />
    </IconBase>
  ),
  noreplyInviteResponse: (props: IconBaseProps) => (
    <IconBase {...props} viewBox="0 0 12 12" fill="none">
      <path
        d="M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6Z"
        fill="#B6B6B6"
      />
    </IconBase>
  ),
  clock: (props: IconBaseProps) => (
    <IconBase {...props}>
      <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 1C16.5192 1 21 5.48083 21 11C21 16.5192 16.5192 21 11 21C5.48083 21 1 16.5192 1 11C1 5.48083 5.48083 1 11 1ZM11 1.83333C16.0592 1.83333 20.1667 5.94083 20.1667 11C20.1667 16.0592 16.0592 20.1667 11 20.1667C5.94083 20.1667 1.83333 16.0592 1.83333 11C1.83333 5.94083 5.94083 1.83333 11 1.83333ZM11 11H16V11.8333H10.1667V4.33333H11V11Z"
          stroke="#474747"
          strokeWidth="0.85"
        />
      </svg>
    </IconBase>
  ),
  hours: (props: IconBaseProps) => (
    <IconBase {...props} viewBox="0 0 18 13" fill="none">
      <path
        d="M5.04 4.79H1.68V8H0.85V1H1.68V4.05H5.04V1H5.87V8H5.04V4.79ZM7.56875 1.07C7.82208 1.02333 8.11208 0.986666 8.43875 0.959999C8.77208 0.933333 9.07542 0.92 9.34875 0.92C9.65542 0.92 9.94542 0.953333 10.2188 1.02C10.4988 1.08667 10.7421 1.19667 10.9488 1.35C11.1621 1.50333 11.3321 1.70333 11.4588 1.95C11.5854 2.19667 11.6488 2.49667 11.6488 2.85C11.6488 3.39667 11.4988 3.84 11.1988 4.18C10.8988 4.52 10.5188 4.74667 10.0588 4.86L10.5388 5.23L12.2788 8H11.3088L9.37875 4.98L8.39875 4.83V8H7.56875V1.07ZM9.36875 1.64C9.28208 1.64 9.19208 1.64 9.09875 1.64C9.00542 1.64 8.91542 1.64333 8.82875 1.65C8.74208 1.65667 8.65875 1.66333 8.57875 1.67C8.50542 1.67667 8.44542 1.68667 8.39875 1.7V4.28H9.17875C9.63875 4.28 10.0188 4.16667 10.3188 3.94C10.6188 3.71333 10.7688 3.36 10.7688 2.88C10.7688 2.52 10.6454 2.22333 10.3988 1.99C10.1521 1.75667 9.80875 1.64 9.36875 1.64ZM16.676 6.22C16.676 5.94 16.5927 5.71333 16.426 5.54C16.2593 5.36 16.0493 5.20333 15.796 5.07C15.5493 4.93 15.2793 4.8 14.986 4.68C14.6927 4.56 14.4193 4.41667 14.166 4.25C13.9193 4.07667 13.7127 3.86667 13.546 3.62C13.3793 3.36667 13.296 3.04667 13.296 2.66C13.296 2.11333 13.486 1.68 13.866 1.36C14.246 1.04 14.786 0.88 15.486 0.88C15.8927 0.88 16.2627 0.91 16.596 0.97C16.9293 1.03 17.1893 1.10667 17.376 1.2L17.126 1.93C16.9727 1.85667 16.746 1.78667 16.446 1.72C16.1527 1.65333 15.8193 1.62 15.446 1.62C15.006 1.62 14.676 1.72 14.456 1.92C14.236 2.11333 14.126 2.34333 14.126 2.61C14.126 2.87 14.2093 3.08667 14.376 3.26C14.5427 3.43333 14.7493 3.59 14.996 3.73C15.2493 3.86333 15.5227 3.99667 15.816 4.13C16.1093 4.26333 16.3793 4.42 16.626 4.6C16.8793 4.77333 17.0893 4.98333 17.256 5.23C17.4227 5.47667 17.506 5.78333 17.506 6.15C17.506 6.45 17.4527 6.72 17.346 6.96C17.2393 7.2 17.0827 7.40667 16.876 7.58C16.6693 7.75333 16.4193 7.88667 16.126 7.98C15.8327 8.07333 15.4993 8.12 15.126 8.12C14.626 8.12 14.2127 8.08 13.886 8C13.5593 7.92667 13.306 7.84333 13.126 7.75L13.406 7C13.5593 7.08667 13.786 7.17333 14.086 7.26C14.386 7.34 14.7227 7.38 15.096 7.38C15.316 7.38 15.5227 7.36 15.716 7.32C15.9093 7.27333 16.076 7.20333 16.216 7.11C16.356 7.01 16.466 6.88667 16.546 6.74C16.6327 6.59333 16.676 6.42 16.676 6.22Z"
        fill="#666666"
      />
    </IconBase>
  ),

  minutes: (props: IconBaseProps) => (
    <IconBase {...props} viewBox="0 0 18 13" fill="none">
      <path
        d="M6.23 2.8L6.33 1.75H6.28L5.9 2.71L4.08 5.87H3.83L1.9 2.7L1.54 1.75H1.49L1.63 2.79V7.5H0.85V0.5H1.47L3.66 4.08L3.99 4.86H4.01L4.32 4.06L6.41 0.5H7.06V7.5H6.23V2.8ZM8.95016 0.5H9.78016V7.5H8.95016V0.5ZM12.9303 2.92L12.3903 1.91H12.3503L12.4503 2.92V7.5H11.6703V0.39H12.1103L15.4603 5.06L15.9803 6.02H16.0303L15.9203 5.06V0.5H16.7003V7.61H16.2603L12.9303 2.92Z"
        fill="#666666"
      />
    </IconBase>
  ),
  tada: (props: IconBaseProps) => (
    <IconBase {...props} viewBox="0 0 12 12" fill="none">
      <path
        d="M10.1572 11.3139L4.43144 9.17964C4.26195 9.11979 4.11025 9.01826 3.99029 8.88439C3.87034 8.75053 3.78599 8.58864 3.74501 8.41363C3.70403 8.23862 3.70774 8.05611 3.7558 7.88291C3.80386 7.70971 3.89472 7.55138 4.02001 7.4225L7.61144 3.83107C7.74411 3.70673 7.90602 3.61789 8.08217 3.5728C8.25832 3.52771 8.44301 3.52782 8.6191 3.57313C8.7952 3.61843 8.957 3.70746 9.08952 3.83197C9.22204 3.95648 9.32097 4.11243 9.37715 4.28536L11.5029 10.0111C11.5619 10.1966 11.568 10.3949 11.5205 10.5836C11.4729 10.7724 11.3737 10.9442 11.2338 11.0796C11.0939 11.215 10.9191 11.3086 10.7288 11.3501C10.5386 11.3915 10.3406 11.3789 10.1572 11.3139V11.3139Z"
        stroke="#6491FF"
        strokeWidth="0.857143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.75586 6.11446C2.13649 5.90206 2.58223 5.83794 3.00729 5.93446"
        stroke="#91EBFA"
        strokeWidth="0.857143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.71017 3.66473C3.46744 3.29882 3.36684 2.85679 3.42731 2.42188"
        stroke="#FFE164"
        strokeWidth="0.857143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.68216 0.617188C5.38174 1.53748 5.42127 2.53499 5.79359 3.42862"
        stroke="#AF87E1"
        strokeWidth="0.857143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.856306 3.23996C1.093 3.23996 1.28488 3.04808 1.28488 2.81138C1.28488 2.57469 1.093 2.38281 0.856306 2.38281C0.619612 2.38281 0.427734 2.57469 0.427734 2.81138C0.427734 3.04808 0.619612 3.23996 0.856306 3.23996Z"
        stroke="#FF5F69"
        strokeWidth="0.857143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  ),

  filled: {
    folder: (props: IconBaseProps) => (
      <IconBase {...props}>
        <g fill="none" fillRule="evenodd" transform="translate(1 1)">
          <path
            fill={props.color || 'currentColor'}
            stroke={props.color || 'currentColor'}
            strokeLinejoin="round"
            d="M15.9115513 18L2.08844927 18C1.1631924 18 .404886343 17.2657602.375054771 16.3409844L0 4.71428571 18 4.71428571 17.6249444 16.3409844C17.5951129 17.2657602 16.8368078 18 15.9115513 18zM17.1428571 3.85714286L17.1428571 3.42857143C17.1428571 2.71849089 16.5672226 2.14285714 15.8571429 2.14285714L10.2857143 2.14285714 7.71428571 0 2.57142857 0C1.8613482 0 1.28571429.575633914 1.28571429 1.28571429L1.28571429 3.85714286"
          />
          <path
            fill="#FFF"
            fillRule="nonzero"
            d="M6.85714286 11.1428571L6.85714286 13.7142857C6.85714286 13.9509792 7.04902082 14.1428571 7.28571429 14.1428571 7.52240775 14.1428571 7.71428571 13.9509792 7.71428571 13.7142857L7.71428571 11.1428571C7.71428571 10.9061637 7.52240775 10.7142857 7.28571429 10.7142857 7.04902082 10.7142857 6.85714286 10.9061637 6.85714286 11.1428571zM8.57142857 11.1428571L8.57142857 13.7142857C8.57142857 13.9509792 8.76330654 14.1428571 9 14.1428571 9.23669346 14.1428571 9.42857143 13.9509792 9.42857143 13.7142857L9.42857143 11.1428571C9.42857143 10.9061637 9.23669346 10.7142857 9 10.7142857 8.76330654 10.7142857 8.57142857 10.9061637 8.57142857 11.1428571zM10.2857143 11.1428571L10.2857143 13.7142857C10.2857143 13.9509792 10.4775923 14.1428571 10.7142857 14.1428571 10.9509792 14.1428571 11.1428571 13.9509792 11.1428571 13.7142857L11.1428571 11.1428571C11.1428571 10.9061637 10.9509792 10.7142857 10.7142857 10.7142857 10.4775923 10.7142857 10.2857143 10.9061637 10.2857143 11.1428571zM12 11.1428571L12 13.7142857C12 13.9509792 12.191878 14.1428571 12.4285714 14.1428571 12.6652649 14.1428571 12.8571429 13.9509792 12.8571429 13.7142857L12.8571429 11.1428571C12.8571429 10.9061637 12.6652649 10.7142857 12.4285714 10.7142857 12.191878 10.7142857 12 10.9061637 12 11.1428571zM13.7142857 11.1428571L13.7142857 13.7142857C13.7142857 13.9509792 13.9061637 14.1428571 14.1428571 14.1428571 14.3795506 14.1428571 14.5714286 13.9509792 14.5714286 13.7142857L14.5714286 11.1428571C14.5714286 10.9061637 14.3795506 10.7142857 14.1428571 10.7142857 13.9061637 10.7142857 13.7142857 10.9061637 13.7142857 11.1428571z"
          />
        </g>
      </IconBase>
    ),
    gradCap: (props: IconBaseProps) => (
      <IconBase {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(0.000000, 2.000000)">
            <path
              d="M2,6.4 L2,12.8"
              stroke={props.color || 'currentColor'}
              strokeWidth="0.8"
              strokeLinejoin="round"
            />
            <path
              d="M2,15.9048 L1.6708,15.4272 C1.4088,15.0472 0.8,14.1092 0.8,13.6 C0.8,12.9384 1.3384,12.4 2,12.4 C2.6616,12.4 3.2,12.9384 3.2,13.6 C3.2,14.1092 2.5912,15.0472 2.3292,15.4268 L2,15.9048 Z M19.7788,5.242 L10.1788,0.442 C10.0664,0.3856 9.9336,0.3856 9.8208,0.442 L0.2208,5.242 C0.0856,5.31 0,5.4484 0,5.6 C0,5.7516 0.0856,5.89 0.2212,5.958 L3.2,7.4472 L3.2,6.4 C3.2,5.012 5.1968,4.7344 6.0496,4.616 C7.3348,4.4376 8.9072,4.4 10,4.4 C11.0924,4.4 12.6648,4.4376 13.9504,4.616 C14.8032,4.7344 16.8,5.012 16.8,6.4 L16.8,7.4472 L19.7788,5.9576 C19.9144,5.89 20,5.7516 20,5.6 C20,5.4484 19.9144,5.31 19.7788,5.242 Z"
              stroke={props.color || 'currentColor'}
              fillRule="nonzero"
            />
            <path
              d="M10,7.6 C13.4712,7.6 15.168,7.9028 16,8.258 L16,6.4 C16,5.356 12.2408,5.2 10,5.2 C7.7592,5.2 4,5.356 4,6.4 L4,8.258 C4.832,7.9028 6.5288,7.6 10,7.6 Z M10,8.4 C5.8432,8.4 4.1168,8.8916 4.0004,9.2028 C4.0072,10.244 7.7612,10.4 10,10.4 C12.192,10.4 15.828,10.2484 15.9852,9.2644 C15.9856,9.2652 15.9864,9.2656 15.9868,9.2664 C15.9908,9.2436 16,9.2236 16,9.2 C15.8916,8.8936 14.1656,8.4 10,8.4 Z"
              stroke={props.color || 'currentColor'}
              fillRule="nonzero"
            />
          </g>
        </g>
      </IconBase>
    ),
    house: (props: IconBaseProps) => (
      <IconBase {...props}>
        <path
          fill={props.color || 'currentColor'}
          fillRule="evenodd"
          stroke={props.color || 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15.0426213,4.89188491 L15.0426213,1.0932088 C15.0426213,0.864520113 14.8572323,0.679131266 14.6285438,0.679131266 L12.5581561,0.679131266 C12.3294677,0.679131266 12.1440786,0.864520113 12.1440786,1.0932088 L12.1440786,3.09161816 L9.10449829,0.118083248 C8.95026965,-0.0327939344 8.70603571,-0.0399607056 8.54322597,0.101613148 L0.143199189,7.40598386 C-0.145796122,7.65728404 0.031932746,8.13252687 0.414908046,8.13252687 L2.20621781,8.13252687 L2.20621781,15.1718449 C2.20621781,15.6292219 2.5769955,16 3.03437287,16 L14.6285438,16 C15.0859208,16 15.4566989,15.6292219 15.4566989,15.1718449 L15.4566989,8.13252687 L17.3398336,8.13252687 C17.7109339,8.13252687 17.8946707,7.68196417 17.6293976,7.42245412 L15.0426213,4.89188491 Z"
          transform="translate(1 2)"
        />
      </IconBase>
    ),
    timeEntries: (props: IconBaseProps) => {
      // remove with https://guidecx.atlassian.net/browse/MON-45
      const themeName = props.theme ? props.theme.name : 'default'
      if (themeName === 'lightV2') {
        return (
          <IconBase {...props}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7H13ZM12 13H11C11 13.2652 11.1054 13.5196 11.2929 13.7071L12 13ZM13.7929 16.2071C14.1834 16.5976 14.8166 16.5976 15.2071 16.2071C15.5976 15.8166 15.5976 15.1834 15.2071 14.7929L13.7929 16.2071ZM22 12C22 17.5228 17.5228 22 12 22V24C18.6274 24 24 18.6274 24 12H22ZM12 22C6.47715 22 2 17.5228 2 12H0C0 18.6274 5.37258 24 12 24V22ZM2 12C2 6.47715 6.47715 2 12 2V0C5.37258 0 0 5.37258 0 12H2ZM12 2C17.5228 2 22 6.47715 22 12H24C24 5.37258 18.6274 0 12 0V2ZM11 7V13H13V7H11ZM11.2929 13.7071L13.7929 16.2071L15.2071 14.7929L12.7071 12.2929L11.2929 13.7071Z"
                fill={props.color || 'currentColor'}
              />
            </svg>
          </IconBase>
        )
      }
      return (
        <IconBase
          {...omit(props, ['viewBox', 'fill', 'fillRule'])}
          viewBox="0 -1 22 30"
          fill="none"
          fillRule="evenodd"
        >
          <g>
            <path
              stroke={props.color || 'currentColor'}
              d="M12 0c6.623 0 12 5.377 12 12s-5.377 12-12 12-12-5.377-12-12 5.377-12 12-12zm0 1c6.071 0 11 4.929 11 11s-4.929 11-11 11-11-4.929-11-11 4.929-11 11-11zm0 11h6v1h-7v-9h1v8z"
            />
          </g>
        </IconBase>
      )
    },
    receipt: (props: IconBaseProps) => (
      <IconBase
        {...omit(props, ['viewBox', 'fill', 'fillRule'])}
        viewBox="0 -1 22 30"
        fill="none"
        fillRule="evenodd"
        clipRule="evenodd"
      >
        <g>
          <path
            d="M7.19998 20.8973L5.6485 22.4487C4.89255 23.2047 3.59998 22.6693 3.59998 21.6002V3.93853C3.59998 3.26968 3.67754 2.86802 3.90208 2.44817C4.1185 2.04349 4.44327 1.71872 4.84795 1.5023C5.2678 1.27776 5.66946 1.2002 6.33831 1.2002H17.6616C18.3305 1.2002 18.7321 1.27776 19.152 1.5023C19.5567 1.71872 19.8814 2.04349 20.0979 2.44817C20.3224 2.86802 20.4 3.26968 20.4 3.93853V21.6002C20.4 22.6693 19.1074 23.2047 18.3514 22.4487L16.8 20.8973L15.2485 22.4487C14.7799 22.9174 14.0201 22.9174 13.5514 22.4487L12 20.8973L10.4485 22.4487C9.97987 22.9174 9.22008 22.9174 8.75145 22.4487L7.19998 20.8973ZM17.6616 3.6002H6.33831C6.12111 3.6002 6.04408 3.60285 6.00886 3.60908C6.00263 3.6443 5.99998 3.72133 5.99998 3.93853V18.7031L6.35145 18.3517C6.82008 17.883 7.57987 17.883 8.0485 18.3517L9.59998 19.9031L11.1514 18.3517C11.6201 17.883 12.3799 17.883 12.8485 18.3517L14.4 19.9031L15.9514 18.3517C16.4201 17.883 17.1799 17.883 17.6485 18.3517L18 18.7031V3.93853C18 3.72133 17.9973 3.6443 17.9911 3.60908C17.9559 3.60285 17.8788 3.6002 17.6616 3.6002ZM14.4 6.0002H9.59997C8.93723 6.0002 8.39997 6.53745 8.39997 7.2002C8.39997 7.86294 8.93723 8.4002 9.59997 8.4002H14.4C15.0627 8.4002 15.6 7.86294 15.6 7.2002C15.6 6.53745 15.0627 6.0002 14.4 6.0002ZM9.59997 9.6002H14.4C15.0627 9.6002 15.6 10.1375 15.6 10.8002C15.6 11.4629 15.0627 12.0002 14.4 12.0002H9.59997C8.93723 12.0002 8.39997 11.4629 8.39997 10.8002C8.39997 10.1375 8.93723 9.6002 9.59997 9.6002ZM14.4 13.2002H9.59997C8.93723 13.2002 8.39997 13.7375 8.39997 14.4002C8.39997 15.0629 8.93723 15.6002 9.59997 15.6002H14.4C15.0627 15.6002 15.6 15.0629 15.6 14.4002C15.6 13.7375 15.0627 13.2002 14.4 13.2002Z"
            fill={props.color || 'currentColor'}
          />
          <mask
            id="mask0"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="3"
            y="1"
            width="18"
            height="22"
          >
            <path
              d="M7.19998 20.8973L5.6485 22.4487C4.89255 23.2047 3.59998 22.6693 3.59998 21.6002V3.93853C3.59998 3.26968 3.67754 2.86802 3.90208 2.44817C4.1185 2.04349 4.44327 1.71872 4.84795 1.5023C5.2678 1.27776 5.66946 1.2002 6.33831 1.2002H17.6616C18.3305 1.2002 18.7321 1.27776 19.152 1.5023C19.5567 1.71872 19.8814 2.04349 20.0979 2.44817C20.3224 2.86802 20.4 3.26968 20.4 3.93853V21.6002C20.4 22.6693 19.1074 23.2047 18.3514 22.4487L16.8 20.8973L15.2485 22.4487C14.7799 22.9174 14.0201 22.9174 13.5514 22.4487L12 20.8973L10.4485 22.4487C9.97987 22.9174 9.22008 22.9174 8.75145 22.4487L7.19998 20.8973ZM17.6616 3.6002H6.33831C6.12111 3.6002 6.04408 3.60285 6.00886 3.60908C6.00263 3.6443 5.99998 3.72133 5.99998 3.93853V18.7031L6.35145 18.3517C6.82008 17.883 7.57987 17.883 8.0485 18.3517L9.59998 19.9031L11.1514 18.3517C11.6201 17.883 12.3799 17.883 12.8485 18.3517L14.4 19.9031L15.9514 18.3517C16.4201 17.883 17.1799 17.883 17.6485 18.3517L18 18.7031V3.93853C18 3.72133 17.9973 3.6443 17.9911 3.60908C17.9559 3.60285 17.8788 3.6002 17.6616 3.6002ZM14.4 6.0002H9.59997C8.93723 6.0002 8.39997 6.53745 8.39997 7.2002C8.39997 7.86294 8.93723 8.4002 9.59997 8.4002H14.4C15.0627 8.4002 15.6 7.86294 15.6 7.2002C15.6 6.53745 15.0627 6.0002 14.4 6.0002ZM9.59997 9.6002H14.4C15.0627 9.6002 15.6 10.1375 15.6 10.8002C15.6 11.4629 15.0627 12.0002 14.4 12.0002H9.59997C8.93723 12.0002 8.39997 11.4629 8.39997 10.8002C8.39997 10.1375 8.93723 9.6002 9.59997 9.6002ZM14.4 13.2002H9.59997C8.93723 13.2002 8.39997 13.7375 8.39997 14.4002C8.39997 15.0629 8.93723 15.6002 9.59997 15.6002H14.4C15.0627 15.6002 15.6 15.0629 15.6 14.4002C15.6 13.7375 15.0627 13.2002 14.4 13.2002Z"
              fill="white"
            />
          </mask>
        </g>
        <g mask="url(#mask0)" />
      </IconBase>
    ),
    messages: (props: IconBaseProps) => (
      <IconBase {...props}>
        <g
          fill="none"
          fillRule="evenodd"
          stroke={props.color || 'currentColor'}
          strokeLinejoin="round"
          transform="translate(1 1.5)"
        >
          <path d="M14.6070991,5.99265606 C15.7307222,7.04137087 16.4423501,8.57698898 16.4423501,10.2624235 C16.4423501,11.1238678 16.2550796,11.947858 15.9179927,12.69694 C15.9179927,12.69694 15.6183599,14.2700122 17.2288862,15.8805386 C17.2288862,15.8805386 14.2700122,16.5172583 13.2212974,15.5059976 C12.4347613,15.8805386 11.573317,16.1052632 10.6369645,16.1052632 C8.72680539,16.1052632 7.00391677,15.1689106 5.95520196,13.7456548" />
          <path
            fill={props.color || 'currentColor'}
            d="M0,12.2100367 C0,12.2100367 3.10869033,12.8467564 4.23231334,11.8354957 C5.05630355,12.2474908 5.95520196,12.4722154 6.96646267,12.4722154 C10.3373317,12.4722154 13.1089351,9.700612 13.1089351,6.32974296 C13.1089351,2.92141983 10.3747858,0.187270502 6.96646267,0.187270502 C3.59559364,0.187270502 0.823990208,2.95887393 0.823990208,6.32974296 C0.823990208,7.22864137 1.01126071,8.12753978 1.38580171,8.87662179 C1.38580171,8.87662179 1.72288862,10.5246022 0,12.2100367 Z"
          />
        </g>
      </IconBase>
    ),
    paper: (props: IconBaseProps) => {
      // remove with https://guidecx.atlassian.net/browse/MON-45
      const themeName = props.theme ? props.theme.name : 'default'
      if (themeName === 'lightV2') {
        return (
          <IconBase {...props}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21 20V13C21 10.7909 19.2091 9 17 9H14.9211C14.0926 9 13.4211 8.32843 13.4211 7.5V5C13.4211 2.79086 11.6302 1 9.42105 1H6M21 20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V4C3 2.34315 4.34315 1 6 1M21 20V13.2847C21 11.1633 20.2507 9.11015 18.8842 7.48749L16.1181 4.20278C14.4081 2.1721 11.8887 1 9.23393 1H6"
                stroke={props.color || 'currentColor'}
                strokeWidth="2"
              />
            </svg>
          </IconBase>
        )
      }
      return (
        <IconBase {...props}>
          <g fill="none" fillRule="evenodd" transform="translate(3 .5)">
            <path
              fill={props.color || 'currentColor'}
              d="M13.2222222,18 L0.777777778,18 C0.348223011,18 0,17.6540378 0,17.2272727 L0,1.77272727 C0,1.34596182 0.348223011,1 0.777777778,1 L9.33333854,1 L14,5.63636364 L14,17.2272727 C14,17.6540378 13.6517766,18 13.2222222,18 Z"
            />
            <polygon
              stroke="#fff"
              strokeLinejoin="round"
              points="9 0 9 5 14 5"
            />
          </g>
        </IconBase>
      )
    },
    projects: (props: IconBaseProps) => {
      // remove with https://guidecx.atlassian.net/browse/MON-45
      const themeName = props.theme ? props.theme.name : 'default'
      if (themeName === 'lightV2') {
        return (
          <IconBase {...props}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 2C5 0.89543 5.89543 0 7 0H17C18.1046 0 19 0.895431 19 2V3C20.1046 3 21 3.89543 21 5V6V7H22C23.1046 7 24 7.89543 24 9V22C24 23.1046 23.1046 24 22 24H2C0.895431 24 0 23.1046 0 22V9C0 7.89543 0.895431 7 2 7H3V6V5C3 3.89543 3.89543 3 5 3V2ZM5 7H19V6V5H17H7H5V6V7ZM19 9H5H2V22H22V9H19ZM17 2V3H7V2H17Z"
                fill={props.color || 'currentColor'}
              />
            </svg>
          </IconBase>
        )
      }
      return (
        <IconBase {...props}>
          <g fill="none" fillRule="evenodd" transform="translate(1.5 1.5)">
            <rect
              width="17"
              height="3.643"
              fill={props.color || 'currentColor'}
              stroke={props.color || 'currentColor'}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fill={props.color || 'currentColor'}
              stroke={props.color || 'currentColor'}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.7857143,3.64285714 L15.4214286,15.4214286 C15.3809524,16.3119048 14.6928571,17 13.802381,17 L3.19761905,17 C2.30714286,17 1.61904762,16.3119048 1.57857143,15.4214286 L1.21428571,3.64285714"
            />
            <path
              fill="#FFF"
              d="M11.5357143,7.28190474 L5.46428571,7.28190474 C4.89761905,7.28190474 4.45238095,6.83750475 4.45238095,6.27190475 C4.45238095,5.70630476 4.89761905,5.26190476 5.46428571,5.26190476 L11.5357143,5.26190476 C12.102381,5.26190476 12.547619,5.70630476 12.547619,6.27190475 C12.547619,6.83750475 12.102381,7.28190474 11.5357143,7.28190474 Z"
            />
          </g>
        </IconBase>
      )
    },
    users: (props: IconBaseProps) => {
      // remove with https://guidecx.atlassian.net/browse/MON-45
      const themeName = props.theme ? props.theme.name : 'default'
      if (themeName === 'lightV2') {
        return (
          <IconBase {...props}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 20V18M13 20H1V18C1 14.6863 3.68629 12 7 12C10.3137 12 13 14.6863 13 18M13 20H22V19.5C22 16.4624 19.5376 14 16.5 14C14.9435 14 13.538 14.6466 12.5374 15.6858C12.8354 16.3979 13 17.1797 13 18M10 6C10 7.65685 8.65685 9 7 9C5.34315 9 4 7.65685 4 6C4 4.34315 5.34315 3 7 3C8.65685 3 10 4.34315 10 6ZM19 8.5C19 9.88071 17.8807 11 16.5 11C15.1193 11 14 9.88071 14 8.5C14 7.11929 15.1193 6 16.5 6C17.8807 6 19 7.11929 19 8.5Z"
                stroke={props.color || 'currentColor'}
                strokeWidth="2"
              />
            </svg>
          </IconBase>
        )
      }
      return (
        <IconBase {...props}>
          <g
            fill="none"
            fillRule="evenodd"
            stroke={props.color || 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
            transform="translate(1 2)"
          >
            <path
              fill={props.color || 'currentColor'}
              d="M6.86778579,10.5402442 C8.54728545,10.5402442 9.66336334,8.30613439 9.82624478,7.74024545 C9.838156,7.69912632 10.0894419,7.57149831 10.1104674,7.53431935 C11.0195965,5.92547714 10.0258534,5.74262202 10.0258534,5.74262202 C10.0258534,5.74262202 10.0724171,4.89485621 9.86149822,4.0983758 C9.86149822,4.0983758 9.32893715,2.12159817 6.86778583,2.12159817 C4.40663451,2.12159817 3.8740738,4.0983758 3.8740738,4.0983758 C3.66315483,4.89485621 3.70971825,5.74262202 3.70971825,5.74262202 C3.70971825,5.74262202 2.71597508,5.92547714 3.62510379,7.53431935 C3.64612976,7.57149831 3.89741563,7.69912632 3.9093272,7.74024545 C4.07220864,8.30613439 5.18828578,10.5402442 6.86778579,10.5402442 Z"
            />
            <path
              fill={props.color || 'currentColor'}
              d="M8.40967096,10.059962 C8.40967096,10.059962 9.04988786,10.6941626 10.2685066,11.0788207 C11.9951417,11.6237149 13.4743113,12.6494935 13.6031111,15.3566659 C13.6031111,15.3566659 10.8087075,15.9582601 6.86778579,15.9582601 C2.92686404,15.9582601 0.132459779,15.3566659 0.132459779,15.3566659 C0.261267082,12.6494936 1.74043027,11.6237149 3.46706536,11.0788208 C4.68568408,10.6941626 5.32590026,10.059962 5.32590026,10.059962"
            />
            <path d="M13.7483954,14.1412067 C15.8474807,13.7115693 16.7926829,12.5331354 17.4161576,11.8014468 C17.0660178,11.1249163 16.0036633,9.7213109 14.3865654,9.16462466 C12.813561,8.62309909 12.7978961,8.49416365 12.7978961,7.87527728 C13.3824094,7.70335564 14.8374089,8.03055256 15.3406819,7.35953789 C15.8048481,6.74065077 15.2516616,6.23145887 14.7991563,5.45130264 C14.0513338,4.16195491 14.0449638,3.66636186 13.973973,2.9757549 C13.7780273,1.06963529 12.6456185,0.192803176 11.0908961,0.0881193189 C9.7090685,0.181161663 8.66084818,0.884166299 8.30722527,2.37767197" />
          </g>
        </IconBase>
      )
    },
    brands: (props: IconBaseProps) => {
      // remove with https://guidecx.atlassian.net/browse/MON-45
      const themeName = props.theme ? props.theme.name : 'default'
      if (themeName === 'lightV2') {
        return (
          <IconBase {...props}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.61973 2.5792L0.620527 2.53924L1.61973 2.5792ZM2.57896 1.61997L2.53899 0.620771L2.57896 1.61997ZM2.15026 13.4642L1.44315 14.1713L1.44315 14.1713L2.15026 13.4642ZM1.27398 11.223L0.274775 11.183L1.27398 11.223ZM10.849 22.163L11.5561 21.4559L11.5561 21.4559L10.849 22.163ZM22.1627 10.8493L22.8698 10.1421L22.8698 10.1421L22.1627 10.8493ZM13.464 2.1505L12.7569 2.85761L12.7569 2.85761L13.464 2.1505ZM11.2227 1.27422L11.1828 0.275019L11.2227 1.27422ZM8.70711 7.2929C8.31658 6.90238 7.68342 6.90238 7.29289 7.2929C6.90237 7.68343 6.90237 8.31659 7.29289 8.70712L8.70711 7.2929ZM8.29289 9.70712C8.68342 10.0976 9.31658 10.0976 9.70711 9.70712C10.0976 9.31659 10.0976 8.68343 9.70711 8.2929L8.29289 9.70712ZM12.7569 2.85761L21.4556 11.5564L22.8698 10.1421L14.1711 1.4434L12.7569 2.85761ZM21.4556 14.3848L14.3845 21.4559L15.7988 22.8701L22.8698 15.799L21.4556 14.3848ZM11.5561 21.4559L2.85737 12.7571L1.44315 14.1713L10.1419 22.8701L11.5561 21.4559ZM2.27318 11.263L2.61893 2.61917L0.620527 2.53924L0.274775 11.183L2.27318 11.263ZM2.61893 2.61917L11.2627 2.27342L11.1828 0.275019L2.53899 0.620771L2.61893 2.61917ZM2.61893 2.61917L2.61893 2.61917L2.53899 0.620771C1.4972 0.662442 0.662198 1.49745 0.620527 2.53924L2.61893 2.61917ZM2.85737 12.7571C2.46266 12.3624 2.25087 11.8207 2.27318 11.263L0.274775 11.183C0.230155 12.2985 0.653744 13.3819 1.44315 14.1713L2.85737 12.7571ZM14.3845 21.4559C13.6035 22.2369 12.3372 22.2369 11.5561 21.4559L10.1419 22.8701C11.704 24.4322 14.2367 24.4322 15.7988 22.8701L14.3845 21.4559ZM21.4556 11.5564C22.2367 12.3374 22.2367 13.6037 21.4556 14.3848L22.8698 15.799C24.4319 14.2369 24.4319 11.7042 22.8698 10.1421L21.4556 11.5564ZM14.1711 1.4434C13.3817 0.653988 12.2983 0.230399 11.1828 0.275019L11.2627 2.27342C11.8205 2.25111 12.3622 2.46291 12.7569 2.85761L14.1711 1.4434ZM7.29289 8.70712L8.29289 9.70712L9.70711 8.2929L8.70711 7.2929L7.29289 8.70712Z"
                fill={props.color || 'currentColor'}
              />
            </svg>
          </IconBase>
        )
      }
      return (
        <IconBase {...props}>
          <g
            fill="none"
            stroke={props.color || 'currentColor'}
            transform="rotate(45 9 13.828)"
          >
            <polygon
              fill={props.color || 'currentColor'}
              stroke={props.color || 'currentColor'}
              points="1 17 1 3.207 4.341 0 9.908 0 13 3.207 13 17"
            />
            <circle cx="7" cy="4.586" r="2" stroke="#FFF" />
            <path
              stroke="#FFF"
              strokeLinecap="square"
              d="M2.27373675e-13,14.5 L14,14.5 L2.27373675e-13,14.5 Z"
            />
          </g>
        </IconBase>
      )
    },
    tasks: (props: IconBaseProps) => {
      // remove with https://guidecx.atlassian.net/browse/MON-45
      const themeName = props.theme ? props.theme.name : 'default'
      if (themeName === 'lightV2') {
        return (
          <IconBase {...props}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 11L12 14L22 4"
                stroke={props.color || 'currentColor'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16"
                stroke={props.color || 'currentColor'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </IconBase>
        )
      }
      return (
        <IconBase {...props}>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <rect
              stroke={props.color || 'currentColor'}
              fillRule="nonzero"
              x="4.5"
              y="2.5"
              width="13"
              height="13"
              rx="1"
            />
            <g fillRule="nonzero">
              <rect
                stroke={props.color || 'currentColor'}
                strokeWidth="1"
                strokeLinejoin="inherit"
                fill={props.color || 'currentColor'}
                fillRule="evenodd"
                x="2.5"
                y="4.5"
                width="13"
                height="13"
                rx="1"
              />
              <rect
                strokeWidth="0.5"
                x="1.75"
                y="3.75"
                width="14.5"
                height="14.5"
                rx="1"
              />
            </g>
            <path
              d="M8.05740811,16.1181641 C7.68499111,15.4454108 7.39867481,14.9508644 7.19845062,14.6345102 L6.88009575,14.1359545 L6.63982792,13.769546 C6.11524054,12.9526313 5.5686367,12.2778859 5,11.7452896 C5.32436319,11.4769892 5.62669718,11.342841 5.90701105,11.342841 C6.25139666,11.342841 6.55773507,11.4689803 6.82603549,11.7212628 C7.09433591,11.9735453 7.43270971,12.4540761 7.84116706,13.1628698 C8.30568719,11.6531794 8.89633969,10.2215979 9.61314229,8.86808236 C10.0095862,8.13125734 10.3629766,7.6357099 10.6733241,7.38142518 C10.9836716,7.12714045 11.3951261,7 11.9077,7 C12.1800049,7 12.5163765,7.04204645 12.9168249,7.12614061 C11.8876726,7.95506876 11.0647635,8.940157 10.448073,10.0814349 C9.83138249,11.2227128 9.03450216,13.2349357 8.05740811,16.1181641 Z"
              fill="#FFFFFF"
            />
          </g>
        </IconBase>
      )
    },
    dashboard: (props: IconBaseProps) => {
      // remove with https://guidecx.atlassian.net/browse/MON-45
      const themeName = props.theme ? props.theme.name : 'default'
      if (themeName === 'lightV2') {
        return (
          <IconBase {...props}>
            <svg
              width="20"
              height="20"
              viewBox="0 2 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 14V22M9 12V22M15 8V22M21 2V22"
                stroke={props.color || 'currentColor'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </IconBase>
        )
      }
      return (
        <IconBase {...props}>
          <g
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <g transform="translate(1.000000, 1.000000)">
              <path
                d="M0,0 L0,17.5714286 C0,17.8081218 0.191877986,18 0.428571429,18 L18,18"
                stroke={props.color || 'currentColor'}
              />
              <path
                d="M0,0 L0,17.5714286 C0,17.8081218 0.191877986,18 0.428571429,18 L18,18"
                stroke={props.color || 'currentColor'}
              />
              <path
                d="M4,16 L3,16 C2.7238574,16 2.5,15.7850964 2.5,15.52 L2.5,4.48 C2.5,4.21490358 2.7238574,4 3,4 L4,4 C4.2761426,4 4.5,4.21490358 4.5,4.48 L4.5,15.52 C4.5,15.7850964 4.2761426,16 4,16 Z"
                stroke={props.color || 'currentColor'}
                fill="#5F8BFA"
              />
              <path
                d="M8.5,16 L7.5,16 C7.2238579,16 7,15.7761421 7,15.5 L7,9 C7,8.7238579 7.2238579,8.5 7.5,8.5 L8.5,8.5 C8.7761421,8.5 9,8.7238579 9,9 L9,15.5 C9,15.7761421 8.7761421,16 8.5,16 Z"
                stroke={props.color || 'currentColor'}
                fill="#5F8BFA"
              />
              <path
                d="M13,16 L12,16 C11.7238579,16 11.5,15.8081218 11.5,15.5714286 L11.5,1.42857143 C11.5,1.19187799 11.7238579,1 12,1 L13,1 C13.2761421,1 13.5,1.19187799 13.5,1.42857143 L13.5,15.5714286 C13.5,15.8081218 13.2761421,16 13,16 Z"
                stroke={props.color || 'currentColor'}
                fill="#5F8BFA"
              />
              <path
                d="M17.5,16 L16.5,16 C16.2238579,16 16,15.7761421 16,15.5 L16,12.5 C16,12.2238579 16.2238579,12 16.5,12 L17.5,12 C17.7761421,12 18,12.2238579 18,12.5 L18,15.5 C18,15.7761421 17.7761421,16 17.5,16 Z"
                stroke={props.color || 'currentColor'}
                fill="#5F8BFA"
              />
            </g>
          </g>
        </IconBase>
      )
    },
    helpIcon: (props: IconBaseProps) => (
      <IconBase
        {...omit(props, ['fill', 'fillRule', 'viewBox'])}
        viewBox="0 0 16 16"
        fill="none"
        fillRule="evenodd"
      >
        <g>
          <path
            d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
            fill={props.color || 'currentColor'}
          />
          <path
            d="M8.00003 3.14287C6.45717 3.14287 5.31431 4.17144 5.20003 5.60001L5.14288 6.05715H6.28574L6.34288 5.7143C6.40003 4.85715 7.08574 4.28573 8.05717 4.28573C9.08574 4.28573 9.71431 4.85715 9.71431 5.82858C9.71431 6.74287 9.25717 7.14287 8.6286 7.65715C8.05717 8.17144 7.37145 8.80001 7.37145 10V10.6286H8.51431V10C8.51431 9.3143 8.91431 8.97144 9.48574 8.45715C10.1143 7.94287 10.9143 7.25715 10.9143 5.82858C10.8572 4.28573 9.65717 3.14287 8.00003 3.14287Z"
            fill="white"
          />
          <path
            d="M7.31427 11.7143V12.8H8.45713V11.7143C8.45713 11.7143 8.45713 11.7143 8.45713 11.6571L7.31427 11.7143Z"
            fill="white"
          />
        </g>
      </IconBase>
    ),
    supportIcon: (props: IconBaseProps) => {
      // remove with https://guidecx.atlassian.net/browse/MON-45
      const themeName = props.theme ? props.theme.name : 'default'
      if (themeName === 'lightV2') {
        return (
          <IconBase {...props}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 14V13.2295C12 12.2364 12.7627 11.4167 13.6133 10.9041C14.4344 10.4092 15.2185 9.5295 15 7.99999C14.5714 4.99997 10.5 6.5 10.5 6.5M12 17V17.5M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z"
                stroke={props.color || 'currentColor'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </IconBase>
        )
      }
      return (
        <IconBase
          {...props}
          viewBox="3 -5 18 32"
          fill="none"
          fillRule="evenodd"
        >
          <g>
            <path
              d="M7.54529 4.8999V13.5549C7.54523 16.2889 9.09819 18.7865 11.5527 19.9999"
              stroke={props.color || 'currentColor'}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.5703 2.48395C21.5703 2.14256 21.3958 1.82476 21.1075 1.64108C20.8192 1.4574 20.4569 1.43322 20.1467 1.57695C16.3046 3.35595 12.5096 4.96395 4.53883 4.99995H3.53698C1.87706 4.99995 0.531433 6.3431 0.531433 7.99995V9.99995C0.531433 11.6568 1.87706 13 3.53698 13H4.53883C12.5096 13.036 16.3046 14.644 20.1467 16.423C20.4569 16.5667 20.8192 16.5425 21.1075 16.3588C21.3958 16.1751 21.5703 15.8573 21.5703 15.516V2.48395Z"
              stroke={props.color || 'currentColor'}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.5712 7H22.0722C22.9021 7 23.5749 7.67157 23.5749 8.5V9.5C23.5749 10.3284 22.9021 11 22.0722 11H21.5712"
              stroke={props.color || 'currentColor'}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </IconBase>
      )
    },
    resourceManagement: (props: IconBaseProps) => {
      // remove with https://guidecx.atlassian.net/browse/MON-45
      const themeName = props.theme ? props.theme.name : 'default'
      if (themeName === 'lightV2') {
        return (
          <IconBase {...props}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.5566 2.54578C13.3993 0.614463 10.6007 0.614458 9.44338 2.54578L8.7445 3.71206C8.52246 4.08259 8.0841 4.26417 7.66509 4.15917L6.34622 3.82866C4.16223 3.28136 2.1833 5.26028 2.73061 7.44427L3.06111 8.76315C3.16612 9.18215 2.98454 9.62051 2.61401 9.84255L1.44773 10.5414C-0.483589 11.6987 -0.483595 14.4974 1.44772 15.6547L2.61401 16.3536C2.98454 16.5756 3.16612 17.014 3.06111 17.433L2.73061 18.7518C2.47832 19.7586 2.76749 20.7302 3.36219 21.4202L4.87712 20.1144C4.67845 19.8839 4.58679 19.5725 4.67062 19.238L5.00113 17.9191C5.32031 16.6454 4.76836 15.3129 3.64204 14.638L2.47575 13.9391C1.8404 13.5584 1.8404 12.6377 2.47575 12.257L3.64204 11.5581C4.76836 10.8832 5.32031 9.55066 5.00113 8.27698L4.67062 6.95811C4.49057 6.23964 5.14158 5.58862 5.86006 5.76867L7.17893 6.09918C8.45261 6.41836 9.78513 5.86641 10.4601 4.74009L11.1589 3.5738C11.5397 2.93845 12.4603 2.93845 12.8411 3.5738L13.5399 4.74009C14.2149 5.86642 15.5474 6.41836 16.8211 6.09918L18.1399 5.76867C18.8584 5.58862 19.5094 6.23964 19.3294 6.95811L18.9989 8.27698C18.6797 9.55067 19.2316 10.8832 20.358 11.5581L21.5242 12.257C22.1596 12.6377 22.1596 13.5584 21.5242 13.9391L20.358 14.638C19.2316 15.3129 18.6797 16.6454 18.9989 17.9191L19.3294 19.238C19.4132 19.5725 19.3216 19.8839 19.1229 20.1144L20.6378 21.4202C21.2325 20.7302 21.5217 19.7586 21.2694 18.7518L20.9389 17.433C20.8339 17.014 21.0155 16.5756 21.386 16.3536L22.5523 15.6547C24.4836 14.4974 24.4836 11.6987 22.5523 10.5414L21.386 9.84255C21.0155 9.62051 20.8339 9.18215 20.9389 8.76315L21.2694 7.44427C21.8167 5.26029 19.8378 3.28135 17.6538 3.82866L16.3349 4.15917C15.9159 4.26417 15.4775 4.08259 15.2555 3.71206L14.5566 2.54578ZM10.1692 12.6281C10.1692 11.7799 10.8997 11.0197 11.8924 11.0197C12.8851 11.0197 13.6156 11.7799 13.6156 12.6281C13.6156 13.4763 12.8851 14.2366 11.8924 14.2366C10.8997 14.2366 10.1692 13.4763 10.1692 12.6281ZM11.8924 9.01965C9.87714 9.01965 8.16921 10.5951 8.16921 12.6281C8.16921 14.6612 9.87714 16.2366 11.8924 16.2366C13.9077 16.2366 15.6156 14.6612 15.6156 12.6281C15.6156 10.5951 13.9077 9.01965 11.8924 9.01965ZM8.13018 19.831C9.02297 19.3886 10.4303 18.8451 11.8924 18.8451C13.3546 18.8451 14.7618 19.3886 15.6546 19.831C15.9288 19.9668 16.1261 20.247 16.1719 20.617L16.2073 20.9027H7.57752L7.6129 20.617C7.65873 20.247 7.856 19.9668 8.13018 19.831ZM11.8924 16.8451C9.984 16.8451 8.25248 17.5384 7.24228 18.0389C6.28786 18.5117 5.7452 19.4255 5.62807 20.3712L5.4536 21.7798C5.41836 22.0642 5.50689 22.3501 5.69671 22.5649C5.88652 22.7797 6.15938 22.9027 6.44601 22.9027H17.3388C17.6254 22.9027 17.8983 22.7797 18.0881 22.5649C18.2779 22.3501 18.3664 22.0642 18.3312 21.7798L18.1567 20.3712C18.0396 19.4255 17.4969 18.5117 16.5425 18.0389C15.5323 17.5384 13.8008 16.8451 11.8924 16.8451Z"
                fill={props.color || 'currentColor'}
              />
            </svg>
          </IconBase>
        )
      }
      return (
        <IconBase {...props} fill="none" viewBox="0 0 35 37">
          <path
            d="M5.5 26.5V22.75C5.5 22.5511 5.57902 22.3603 5.71967 22.2197C5.86032 22.079 6.05109 22 6.25 22H28.75C28.9489 22 29.1397 22.079 29.2803 22.2197C29.421 22.3603 29.5 22.5511 29.5 22.75V26.5"
            stroke={props.color || 'currentColor'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.5 17.5V26.5"
            stroke={props.color || 'currentColor'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.5 35.5C7.98528 35.5 10 33.4853 10 31C10 28.5147 7.98528 26.5 5.5 26.5C3.01472 26.5 1 28.5147 1 31C1 33.4853 3.01472 35.5 5.5 35.5Z"
            stroke={props.color || 'currentColor'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.5 35.5C19.9853 35.5 22 33.4853 22 31C22 28.5147 19.9853 26.5 17.5 26.5C15.0147 26.5 13 28.5147 13 31C13 33.4853 15.0147 35.5 17.5 35.5Z"
            stroke={props.color || 'currentColor'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M29.5 35.5C31.9853 35.5 34 33.4853 34 31C34 28.5147 31.9853 26.5 29.5 26.5C27.0147 26.5 25 28.5147 25 31C25 33.4853 27.0147 35.5 29.5 35.5Z"
            stroke={props.color || 'currentColor'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.75 17.5C10.75 15.7098 11.4612 13.9929 12.727 12.727C13.9929 11.4612 15.7098 10.75 17.5 10.75C19.2902 10.75 21.0071 11.4612 22.273 12.727C23.5388 13.9929 24.25 15.7098 24.25 17.5H10.75Z"
            stroke={props.color || 'currentColor'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.4998 9.25C19.7779 9.25 21.6248 7.40318 21.6248 5.125C21.6248 2.84683 19.7779 1 17.4998 1C15.2216 1 13.3748 2.84683 13.3748 5.125C13.3748 7.40318 15.2216 9.25 17.4998 9.25Z"
            stroke={props.color || 'currentColor'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </IconBase>
      )
    },

    darkMode: (props: IconBaseProps) => (
      <IconBase {...props} viewBox="0 0 32 32">
        <path d="M29.716 21.357c-0.044-0.252-0.153-0.466-0.327-0.643-0.386-0.391-0.834-0.472-1.345-0.246-1.37 0.642-2.79 0.963-4.26 0.963-1.843 0-3.544-0.459-5.1-1.379s-2.79-2.166-3.699-3.74c-0.91-1.574-1.364-3.293-1.364-5.157 0-1.448 0.284-2.824 0.85-4.128s1.386-2.447 2.457-3.429c0.411-0.39 0.505-0.844 0.281-1.36-0.212-0.516-0.592-0.762-1.139-0.737-1.906 0.075-3.711 0.507-5.418 1.294s-3.173 1.823-4.4 3.108c-1.227 1.285-2.198 2.805-2.914 4.562s-1.074 3.599-1.074 5.526c0 1.965 0.38 3.841 1.14 5.63s1.781 3.331 3.064 4.628c1.283 1.297 2.809 2.33 4.577 3.098s3.624 1.152 5.567 1.152c2.79 0 5.365-0.765 7.725-2.295s4.126-3.573 5.297-6.13c0.1-0.227 0.128-0.466 0.084-0.717zM21.72 26.919c-1.613 0.775-3.316 1.162-5.11 1.162-1.619 0-3.166-0.321-4.642-0.963s-2.747-1.502-3.812-2.579c-1.065-1.077-1.915-2.361-2.55-3.854s-0.953-3.057-0.953-4.694c0-2.708 0.794-5.126 2.382-7.254s3.634-3.57 6.137-4.326c-1.295 2.078-1.943 4.326-1.943 6.744 0 2.292 0.56 4.414 1.681 6.367s2.647 3.494 4.577 4.628c1.93 1.134 4.028 1.7 6.296 1.7 0.697 0 1.383-0.057 2.055-0.17-1.133 1.385-2.507 2.465-4.119 3.239z" />
      </IconBase>
    ),
    close: (props: IconBaseProps) => (
      <IconBase {...props}>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.41423 7.99995L15.7071 1.70706L14.2929 0.292847L8.00001 6.58574L1.70712 0.292847L0.292908 1.70706L6.5858 7.99995L0.292908 14.2928L1.70712 15.7071L8.00001 9.41417L14.2929 15.7071L15.7071 14.2928L9.41423 7.99995Z"
            fill={props.color || 'currentColor'}
          />
        </svg>
      </IconBase>
    ),
  },
}

export type IconNames = keyof typeof Icons | keyof typeof Icons.filled
export type FilledNames = keyof typeof Icons.filled
export default Icons
